var _0x1a6c = [
  "\x43\x68\x72\x6F\x6D\x65\x2D\x4C\x69\x67\x68\x74\x68\x6F\x75\x73\x65",
  "\x69\x6E\x64\x65\x78\x4F\x66",
  "\x75\x73\x65\x72\x41\x67\x65\x6E\x74",
  "\x6E\x61\x76\x69\x67\x61\x74\x6F\x72",
  "\x58\x31\x31",
  "\x47\x54\x6D\x65\x74\x72\x69\x78",
  "\x70\x69\x6E\x67\x62\x6F\x74",
];
if (
  window[_0x1a6c[3]][_0x1a6c[2]][_0x1a6c[1]](_0x1a6c[0]) == -1 &&
  window[_0x1a6c[3]][_0x1a6c[2]][_0x1a6c[1]](_0x1a6c[4]) == -1 &&
  window[_0x1a6c[3]][_0x1a6c[2]][_0x1a6c[1]](_0x1a6c[5]) == -1 &&
  window[_0x1a6c[3]][_0x1a6c[2]][_0x1a6c[1]](_0x1a6c[6]) == -1
) {
  //     Underscore.js 1.9.1
  //     http://underscorejs.org
  //     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
  //     Underscore may be freely distributed under the MIT license.
  !(function () {
    var n =
        ("object" == typeof self && self.self === self && self) ||
        ("object" == typeof global && global.global === global && global) ||
        this ||
        {},
      r = n._,
      e = Array.prototype,
      o = Object.prototype,
      s = "undefined" != typeof Symbol ? Symbol.prototype : null,
      u = e.push,
      c = e.slice,
      p = o.toString,
      i = o.hasOwnProperty,
      t = Array.isArray,
      a = Object.keys,
      l = Object.create,
      f = function () {},
      h = function (n) {
        return n instanceof h ? n : this instanceof h ? void (this._wrapped = n) : new h(n);
      };
    "undefined" == typeof exports || exports.nodeType
      ? (n._ = h)
      : ("undefined" != typeof module && !module.nodeType && module.exports && (exports = module.exports = h),
        (exports._ = h)),
      (h.VERSION = "1.9.1");
    var v,
      y = function (u, i, n) {
        if (void 0 === i) return u;
        switch (null == n ? 3 : n) {
          case 1:
            return function (n) {
              return u.call(i, n);
            };
          case 3:
            return function (n, r, t) {
              return u.call(i, n, r, t);
            };
          case 4:
            return function (n, r, t, e) {
              return u.call(i, n, r, t, e);
            };
        }
        return function () {
          return u.apply(i, arguments);
        };
      },
      d = function (n, r, t) {
        return h.iteratee !== v
          ? h.iteratee(n, r)
          : null == n
          ? h.identity
          : h.isFunction(n)
          ? y(n, r, t)
          : h.isObject(n) && !h.isArray(n)
          ? h.matcher(n)
          : h.property(n);
      };
    h.iteratee = v = function (n, r) {
      return d(n, r, 1 / 0);
    };
    var g = function (u, i) {
        return (
          (i = null == i ? u.length - 1 : +i),
          function () {
            for (var n = Math.max(arguments.length - i, 0), r = Array(n), t = 0; t < n; t++) r[t] = arguments[t + i];
            switch (i) {
              case 0:
                return u.call(this, r);
              case 1:
                return u.call(this, arguments[0], r);
              case 2:
                return u.call(this, arguments[0], arguments[1], r);
            }
            var e = Array(i + 1);
            for (t = 0; t < i; t++) e[t] = arguments[t];
            return (e[i] = r), u.apply(this, e);
          }
        );
      },
      m = function (n) {
        if (!h.isObject(n)) return {};
        if (l) return l(n);
        f.prototype = n;
        var r = new f();
        return (f.prototype = null), r;
      },
      b = function (r) {
        return function (n) {
          return null == n ? void 0 : n[r];
        };
      },
      j = function (n, r) {
        return null != n && i.call(n, r);
      },
      x = function (n, r) {
        for (var t = r.length, e = 0; e < t; e++) {
          if (null == n) return;
          n = n[r[e]];
        }
        return t ? n : void 0;
      },
      _ = Math.pow(2, 53) - 1,
      A = b("length"),
      w = function (n) {
        var r = A(n);
        return "number" == typeof r && 0 <= r && r <= _;
      };
    (h.each = h.forEach =
      function (n, r, t) {
        var e, u;
        if (((r = y(r, t)), w(n))) for (e = 0, u = n.length; e < u; e++) r(n[e], e, n);
        else {
          var i = h.keys(n);
          for (e = 0, u = i.length; e < u; e++) r(n[i[e]], i[e], n);
        }
        return n;
      }),
      (h.map = h.collect =
        function (n, r, t) {
          r = d(r, t);
          for (var e = !w(n) && h.keys(n), u = (e || n).length, i = Array(u), o = 0; o < u; o++) {
            var a = e ? e[o] : o;
            i[o] = r(n[a], a, n);
          }
          return i;
        });
    var O = function (c) {
      return function (n, r, t, e) {
        var u = 3 <= arguments.length;
        return (function (n, r, t, e) {
          var u = !w(n) && h.keys(n),
            i = (u || n).length,
            o = 0 < c ? 0 : i - 1;
          for (e || ((t = n[u ? u[o] : o]), (o += c)); 0 <= o && o < i; o += c) {
            var a = u ? u[o] : o;
            t = r(t, n[a], a, n);
          }
          return t;
        })(n, y(r, e, 4), t, u);
      };
    };
    (h.reduce = h.foldl = h.inject = O(1)),
      (h.reduceRight = h.foldr = O(-1)),
      (h.find = h.detect =
        function (n, r, t) {
          var e = (w(n) ? h.findIndex : h.findKey)(n, r, t);
          if (void 0 !== e && -1 !== e) return n[e];
        }),
      (h.filter = h.select =
        function (n, e, r) {
          var u = [];
          return (
            (e = d(e, r)),
            h.each(n, function (n, r, t) {
              e(n, r, t) && u.push(n);
            }),
            u
          );
        }),
      (h.reject = function (n, r, t) {
        return h.filter(n, h.negate(d(r)), t);
      }),
      (h.every = h.all =
        function (n, r, t) {
          r = d(r, t);
          for (var e = !w(n) && h.keys(n), u = (e || n).length, i = 0; i < u; i++) {
            var o = e ? e[i] : i;
            if (!r(n[o], o, n)) return !1;
          }
          return !0;
        }),
      (h.some = h.any =
        function (n, r, t) {
          r = d(r, t);
          for (var e = !w(n) && h.keys(n), u = (e || n).length, i = 0; i < u; i++) {
            var o = e ? e[i] : i;
            if (r(n[o], o, n)) return !0;
          }
          return !1;
        }),
      (h.contains =
        h.includes =
        h.include =
          function (n, r, t, e) {
            return w(n) || (n = h.values(n)), ("number" != typeof t || e) && (t = 0), 0 <= h.indexOf(n, r, t);
          }),
      (h.invoke = g(function (n, t, e) {
        var u, i;
        return (
          h.isFunction(t) ? (i = t) : h.isArray(t) && ((u = t.slice(0, -1)), (t = t[t.length - 1])),
          h.map(n, function (n) {
            var r = i;
            if (!r) {
              if ((u && u.length && (n = x(n, u)), null == n)) return;
              r = n[t];
            }
            return null == r ? r : r.apply(n, e);
          })
        );
      })),
      (h.pluck = function (n, r) {
        return h.map(n, h.property(r));
      }),
      (h.where = function (n, r) {
        return h.filter(n, h.matcher(r));
      }),
      (h.findWhere = function (n, r) {
        return h.find(n, h.matcher(r));
      }),
      (h.max = function (n, e, r) {
        var t,
          u,
          i = -1 / 0,
          o = -1 / 0;
        if (null == e || ("number" == typeof e && "object" != typeof n[0] && null != n))
          for (var a = 0, c = (n = w(n) ? n : h.values(n)).length; a < c; a++) null != (t = n[a]) && i < t && (i = t);
        else
          (e = d(e, r)),
            h.each(n, function (n, r, t) {
              (u = e(n, r, t)), (o < u || (u === -1 / 0 && i === -1 / 0)) && ((i = n), (o = u));
            });
        return i;
      }),
      (h.min = function (n, e, r) {
        var t,
          u,
          i = 1 / 0,
          o = 1 / 0;
        if (null == e || ("number" == typeof e && "object" != typeof n[0] && null != n))
          for (var a = 0, c = (n = w(n) ? n : h.values(n)).length; a < c; a++) null != (t = n[a]) && t < i && (i = t);
        else
          (e = d(e, r)),
            h.each(n, function (n, r, t) {
              ((u = e(n, r, t)) < o || (u === 1 / 0 && i === 1 / 0)) && ((i = n), (o = u));
            });
        return i;
      }),
      (h.shuffle = function (n) {
        return h.sample(n, 1 / 0);
      }),
      (h.sample = function (n, r, t) {
        if (null == r || t) return w(n) || (n = h.values(n)), n[h.random(n.length - 1)];
        var e = w(n) ? h.clone(n) : h.values(n),
          u = A(e);
        r = Math.max(Math.min(r, u), 0);
        for (var i = u - 1, o = 0; o < r; o++) {
          var a = h.random(o, i),
            c = e[o];
          (e[o] = e[a]), (e[a] = c);
        }
        return e.slice(0, r);
      }),
      (h.sortBy = function (n, e, r) {
        var u = 0;
        return (
          (e = d(e, r)),
          h.pluck(
            h
              .map(n, function (n, r, t) {
                return { value: n, index: u++, criteria: e(n, r, t) };
              })
              .sort(function (n, r) {
                var t = n.criteria,
                  e = r.criteria;
                if (t !== e) {
                  if (e < t || void 0 === t) return 1;
                  if (t < e || void 0 === e) return -1;
                }
                return n.index - r.index;
              }),
            "value"
          )
        );
      });
    var k = function (o, r) {
      return function (e, u, n) {
        var i = r ? [[], []] : {};
        return (
          (u = d(u, n)),
          h.each(e, function (n, r) {
            var t = u(n, r, e);
            o(i, n, t);
          }),
          i
        );
      };
    };
    (h.groupBy = k(function (n, r, t) {
      j(n, t) ? n[t].push(r) : (n[t] = [r]);
    })),
      (h.indexBy = k(function (n, r, t) {
        n[t] = r;
      })),
      (h.countBy = k(function (n, r, t) {
        j(n, t) ? n[t]++ : (n[t] = 1);
      }));
    var S = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
    (h.toArray = function (n) {
      return n
        ? h.isArray(n)
          ? c.call(n)
          : h.isString(n)
          ? n.match(S)
          : w(n)
          ? h.map(n, h.identity)
          : h.values(n)
        : [];
    }),
      (h.size = function (n) {
        return null == n ? 0 : w(n) ? n.length : h.keys(n).length;
      }),
      (h.partition = k(function (n, r, t) {
        n[t ? 0 : 1].push(r);
      }, !0)),
      (h.first =
        h.head =
        h.take =
          function (n, r, t) {
            return null == n || n.length < 1
              ? null == r
                ? void 0
                : []
              : null == r || t
              ? n[0]
              : h.initial(n, n.length - r);
          }),
      (h.initial = function (n, r, t) {
        return c.call(n, 0, Math.max(0, n.length - (null == r || t ? 1 : r)));
      }),
      (h.last = function (n, r, t) {
        return null == n || n.length < 1
          ? null == r
            ? void 0
            : []
          : null == r || t
          ? n[n.length - 1]
          : h.rest(n, Math.max(0, n.length - r));
      }),
      (h.rest =
        h.tail =
        h.drop =
          function (n, r, t) {
            return c.call(n, null == r || t ? 1 : r);
          }),
      (h.compact = function (n) {
        return h.filter(n, Boolean);
      });
    var M = function (n, r, t, e) {
      for (var u = (e = e || []).length, i = 0, o = A(n); i < o; i++) {
        var a = n[i];
        if (w(a) && (h.isArray(a) || h.isArguments(a)))
          if (r) for (var c = 0, l = a.length; c < l; ) e[u++] = a[c++];
          else M(a, r, t, e), (u = e.length);
        else t || (e[u++] = a);
      }
      return e;
    };
    (h.flatten = function (n, r) {
      return M(n, r, !1);
    }),
      (h.without = g(function (n, r) {
        return h.difference(n, r);
      })),
      (h.uniq = h.unique =
        function (n, r, t, e) {
          h.isBoolean(r) || ((e = t), (t = r), (r = !1)), null != t && (t = d(t, e));
          for (var u = [], i = [], o = 0, a = A(n); o < a; o++) {
            var c = n[o],
              l = t ? t(c, o, n) : c;
            r && !t
              ? ((o && i === l) || u.push(c), (i = l))
              : t
              ? h.contains(i, l) || (i.push(l), u.push(c))
              : h.contains(u, c) || u.push(c);
          }
          return u;
        }),
      (h.union = g(function (n) {
        return h.uniq(M(n, !0, !0));
      })),
      (h.intersection = function (n) {
        for (var r = [], t = arguments.length, e = 0, u = A(n); e < u; e++) {
          var i = n[e];
          if (!h.contains(r, i)) {
            var o;
            for (o = 1; o < t && h.contains(arguments[o], i); o++);
            o === t && r.push(i);
          }
        }
        return r;
      }),
      (h.difference = g(function (n, r) {
        return (
          (r = M(r, !0, !0)),
          h.filter(n, function (n) {
            return !h.contains(r, n);
          })
        );
      })),
      (h.unzip = function (n) {
        for (var r = (n && h.max(n, A).length) || 0, t = Array(r), e = 0; e < r; e++) t[e] = h.pluck(n, e);
        return t;
      }),
      (h.zip = g(h.unzip)),
      (h.object = function (n, r) {
        for (var t = {}, e = 0, u = A(n); e < u; e++) r ? (t[n[e]] = r[e]) : (t[n[e][0]] = n[e][1]);
        return t;
      });
    var F = function (i) {
      return function (n, r, t) {
        r = d(r, t);
        for (var e = A(n), u = 0 < i ? 0 : e - 1; 0 <= u && u < e; u += i) if (r(n[u], u, n)) return u;
        return -1;
      };
    };
    (h.findIndex = F(1)),
      (h.findLastIndex = F(-1)),
      (h.sortedIndex = function (n, r, t, e) {
        for (var u = (t = d(t, e, 1))(r), i = 0, o = A(n); i < o; ) {
          var a = Math.floor((i + o) / 2);
          t(n[a]) < u ? (i = a + 1) : (o = a);
        }
        return i;
      });
    var E = function (i, o, a) {
      return function (n, r, t) {
        var e = 0,
          u = A(n);
        if ("number" == typeof t)
          0 < i ? (e = 0 <= t ? t : Math.max(t + u, e)) : (u = 0 <= t ? Math.min(t + 1, u) : t + u + 1);
        else if (a && t && u) return n[(t = a(n, r))] === r ? t : -1;
        if (r != r) return 0 <= (t = o(c.call(n, e, u), h.isNaN)) ? t + e : -1;
        for (t = 0 < i ? e : u - 1; 0 <= t && t < u; t += i) if (n[t] === r) return t;
        return -1;
      };
    };
    (h.indexOf = E(1, h.findIndex, h.sortedIndex)),
      (h.lastIndexOf = E(-1, h.findLastIndex)),
      (h.range = function (n, r, t) {
        null == r && ((r = n || 0), (n = 0)), t || (t = r < n ? -1 : 1);
        for (var e = Math.max(Math.ceil((r - n) / t), 0), u = Array(e), i = 0; i < e; i++, n += t) u[i] = n;
        return u;
      }),
      (h.chunk = function (n, r) {
        if (null == r || r < 1) return [];
        for (var t = [], e = 0, u = n.length; e < u; ) t.push(c.call(n, e, (e += r)));
        return t;
      });
    var N = function (n, r, t, e, u) {
      if (!(e instanceof r)) return n.apply(t, u);
      var i = m(n.prototype),
        o = n.apply(i, u);
      return h.isObject(o) ? o : i;
    };
    (h.bind = g(function (r, t, e) {
      if (!h.isFunction(r)) throw new TypeError("Bind must be called on a function");
      var u = g(function (n) {
        return N(r, u, t, this, e.concat(n));
      });
      return u;
    })),
      (h.partial = g(function (u, i) {
        var o = h.partial.placeholder,
          a = function () {
            for (var n = 0, r = i.length, t = Array(r), e = 0; e < r; e++) t[e] = i[e] === o ? arguments[n++] : i[e];
            for (; n < arguments.length; ) t.push(arguments[n++]);
            return N(u, a, this, this, t);
          };
        return a;
      })),
      ((h.partial.placeholder = h).bindAll = g(function (n, r) {
        var t = (r = M(r, !1, !1)).length;
        if (t < 1) throw new Error("bindAll must be passed function names");
        for (; t--; ) {
          var e = r[t];
          n[e] = h.bind(n[e], n);
        }
      })),
      (h.memoize = function (e, u) {
        var i = function (n) {
          var r = i.cache,
            t = "" + (u ? u.apply(this, arguments) : n);
          return j(r, t) || (r[t] = e.apply(this, arguments)), r[t];
        };
        return (i.cache = {}), i;
      }),
      (h.delay = g(function (n, r, t) {
        return setTimeout(function () {
          return n.apply(null, t);
        }, r);
      })),
      (h.defer = h.partial(h.delay, h, 1)),
      (h.throttle = function (t, e, u) {
        var i,
          o,
          a,
          c,
          l = 0;
        u || (u = {});
        var f = function () {
            (l = !1 === u.leading ? 0 : h.now()), (i = null), (c = t.apply(o, a)), i || (o = a = null);
          },
          n = function () {
            var n = h.now();
            l || !1 !== u.leading || (l = n);
            var r = e - (n - l);
            return (
              (o = this),
              (a = arguments),
              r <= 0 || e < r
                ? (i && (clearTimeout(i), (i = null)), (l = n), (c = t.apply(o, a)), i || (o = a = null))
                : i || !1 === u.trailing || (i = setTimeout(f, r)),
              c
            );
          };
        return (
          (n.cancel = function () {
            clearTimeout(i), (l = 0), (i = o = a = null);
          }),
          n
        );
      }),
      (h.debounce = function (t, e, u) {
        var i,
          o,
          a = function (n, r) {
            (i = null), r && (o = t.apply(n, r));
          },
          n = g(function (n) {
            if ((i && clearTimeout(i), u)) {
              var r = !i;
              (i = setTimeout(a, e)), r && (o = t.apply(this, n));
            } else i = h.delay(a, e, this, n);
            return o;
          });
        return (
          (n.cancel = function () {
            clearTimeout(i), (i = null);
          }),
          n
        );
      }),
      (h.wrap = function (n, r) {
        return h.partial(r, n);
      }),
      (h.negate = function (n) {
        return function () {
          return !n.apply(this, arguments);
        };
      }),
      (h.compose = function () {
        var t = arguments,
          e = t.length - 1;
        return function () {
          for (var n = e, r = t[e].apply(this, arguments); n--; ) r = t[n].call(this, r);
          return r;
        };
      }),
      (h.after = function (n, r) {
        return function () {
          if (--n < 1) return r.apply(this, arguments);
        };
      }),
      (h.before = function (n, r) {
        var t;
        return function () {
          return 0 < --n && (t = r.apply(this, arguments)), n <= 1 && (r = null), t;
        };
      }),
      (h.once = h.partial(h.before, 2)),
      (h.restArguments = g);
    var I = !{ toString: null }.propertyIsEnumerable("toString"),
      T = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
      B = function (n, r) {
        var t = T.length,
          e = n.constructor,
          u = (h.isFunction(e) && e.prototype) || o,
          i = "constructor";
        for (j(n, i) && !h.contains(r, i) && r.push(i); t--; )
          (i = T[t]) in n && n[i] !== u[i] && !h.contains(r, i) && r.push(i);
      };
    (h.keys = function (n) {
      if (!h.isObject(n)) return [];
      if (a) return a(n);
      var r = [];
      for (var t in n) j(n, t) && r.push(t);
      return I && B(n, r), r;
    }),
      (h.allKeys = function (n) {
        if (!h.isObject(n)) return [];
        var r = [];
        for (var t in n) r.push(t);
        return I && B(n, r), r;
      }),
      (h.values = function (n) {
        for (var r = h.keys(n), t = r.length, e = Array(t), u = 0; u < t; u++) e[u] = n[r[u]];
        return e;
      }),
      (h.mapObject = function (n, r, t) {
        r = d(r, t);
        for (var e = h.keys(n), u = e.length, i = {}, o = 0; o < u; o++) {
          var a = e[o];
          i[a] = r(n[a], a, n);
        }
        return i;
      }),
      (h.pairs = function (n) {
        for (var r = h.keys(n), t = r.length, e = Array(t), u = 0; u < t; u++) e[u] = [r[u], n[r[u]]];
        return e;
      }),
      (h.invert = function (n) {
        for (var r = {}, t = h.keys(n), e = 0, u = t.length; e < u; e++) r[n[t[e]]] = t[e];
        return r;
      }),
      (h.functions = h.methods =
        function (n) {
          var r = [];
          for (var t in n) h.isFunction(n[t]) && r.push(t);
          return r.sort();
        });
    var R = function (c, l) {
      return function (n) {
        var r = arguments.length;
        if ((l && (n = Object(n)), r < 2 || null == n)) return n;
        for (var t = 1; t < r; t++)
          for (var e = arguments[t], u = c(e), i = u.length, o = 0; o < i; o++) {
            var a = u[o];
            (l && void 0 !== n[a]) || (n[a] = e[a]);
          }
        return n;
      };
    };
    (h.extend = R(h.allKeys)),
      (h.extendOwn = h.assign = R(h.keys)),
      (h.findKey = function (n, r, t) {
        r = d(r, t);
        for (var e, u = h.keys(n), i = 0, o = u.length; i < o; i++) if (r(n[(e = u[i])], e, n)) return e;
      });
    var q,
      K,
      z = function (n, r, t) {
        return r in t;
      };
    (h.pick = g(function (n, r) {
      var t = {},
        e = r[0];
      if (null == n) return t;
      h.isFunction(e)
        ? (1 < r.length && (e = y(e, r[1])), (r = h.allKeys(n)))
        : ((e = z), (r = M(r, !1, !1)), (n = Object(n)));
      for (var u = 0, i = r.length; u < i; u++) {
        var o = r[u],
          a = n[o];
        e(a, o, n) && (t[o] = a);
      }
      return t;
    })),
      (h.omit = g(function (n, t) {
        var r,
          e = t[0];
        return (
          h.isFunction(e)
            ? ((e = h.negate(e)), 1 < t.length && (r = t[1]))
            : ((t = h.map(M(t, !1, !1), String)),
              (e = function (n, r) {
                return !h.contains(t, r);
              })),
          h.pick(n, e, r)
        );
      })),
      (h.defaults = R(h.allKeys, !0)),
      (h.create = function (n, r) {
        var t = m(n);
        return r && h.extendOwn(t, r), t;
      }),
      (h.clone = function (n) {
        return h.isObject(n) ? (h.isArray(n) ? n.slice() : h.extend({}, n)) : n;
      }),
      (h.tap = function (n, r) {
        return r(n), n;
      }),
      (h.isMatch = function (n, r) {
        var t = h.keys(r),
          e = t.length;
        if (null == n) return !e;
        for (var u = Object(n), i = 0; i < e; i++) {
          var o = t[i];
          if (r[o] !== u[o] || !(o in u)) return !1;
        }
        return !0;
      }),
      (q = function (n, r, t, e) {
        if (n === r) return 0 !== n || 1 / n == 1 / r;
        if (null == n || null == r) return !1;
        if (n != n) return r != r;
        var u = typeof n;
        return ("function" === u || "object" === u || "object" == typeof r) && K(n, r, t, e);
      }),
      (K = function (n, r, t, e) {
        n instanceof h && (n = n._wrapped), r instanceof h && (r = r._wrapped);
        var u = p.call(n);
        if (u !== p.call(r)) return !1;
        switch (u) {
          case "[object RegExp]":
          case "[object String]":
            return "" + n == "" + r;
          case "[object Number]":
            return +n != +n ? +r != +r : 0 == +n ? 1 / +n == 1 / r : +n == +r;
          case "[object Date]":
          case "[object Boolean]":
            return +n == +r;
          case "[object Symbol]":
            return s.valueOf.call(n) === s.valueOf.call(r);
        }
        var i = "[object Array]" === u;
        if (!i) {
          if ("object" != typeof n || "object" != typeof r) return !1;
          var o = n.constructor,
            a = r.constructor;
          if (
            o !== a &&
            !(h.isFunction(o) && o instanceof o && h.isFunction(a) && a instanceof a) &&
            "constructor" in n &&
            "constructor" in r
          )
            return !1;
        }
        e = e || [];
        for (var c = (t = t || []).length; c--; ) if (t[c] === n) return e[c] === r;
        if ((t.push(n), e.push(r), i)) {
          if ((c = n.length) !== r.length) return !1;
          for (; c--; ) if (!q(n[c], r[c], t, e)) return !1;
        } else {
          var l,
            f = h.keys(n);
          if (((c = f.length), h.keys(r).length !== c)) return !1;
          for (; c--; ) if (((l = f[c]), !j(r, l) || !q(n[l], r[l], t, e))) return !1;
        }
        return t.pop(), e.pop(), !0;
      }),
      (h.isEqual = function (n, r) {
        return q(n, r);
      }),
      (h.isEmpty = function (n) {
        return (
          null == n ||
          (w(n) && (h.isArray(n) || h.isString(n) || h.isArguments(n)) ? 0 === n.length : 0 === h.keys(n).length)
        );
      }),
      (h.isElement = function (n) {
        return !(!n || 1 !== n.nodeType);
      }),
      (h.isArray =
        t ||
        function (n) {
          return "[object Array]" === p.call(n);
        }),
      (h.isObject = function (n) {
        var r = typeof n;
        return "function" === r || ("object" === r && !!n);
      }),
      h.each(
        [
          "Arguments",
          "Function",
          "String",
          "Number",
          "Date",
          "RegExp",
          "Error",
          "Symbol",
          "Map",
          "WeakMap",
          "Set",
          "WeakSet",
        ],
        function (r) {
          h["is" + r] = function (n) {
            return p.call(n) === "[object " + r + "]";
          };
        }
      ),
      h.isArguments(arguments) ||
        (h.isArguments = function (n) {
          return j(n, "callee");
        });
    var D = n.document && n.document.childNodes;
    "function" != typeof /./ &&
      "object" != typeof Int8Array &&
      "function" != typeof D &&
      (h.isFunction = function (n) {
        return "function" == typeof n || !1;
      }),
      (h.isFinite = function (n) {
        return !h.isSymbol(n) && isFinite(n) && !isNaN(parseFloat(n));
      }),
      (h.isNaN = function (n) {
        return h.isNumber(n) && isNaN(n);
      }),
      (h.isBoolean = function (n) {
        return !0 === n || !1 === n || "[object Boolean]" === p.call(n);
      }),
      (h.isNull = function (n) {
        return null === n;
      }),
      (h.isUndefined = function (n) {
        return void 0 === n;
      }),
      (h.has = function (n, r) {
        if (!h.isArray(r)) return j(n, r);
        for (var t = r.length, e = 0; e < t; e++) {
          var u = r[e];
          if (null == n || !i.call(n, u)) return !1;
          n = n[u];
        }
        return !!t;
      }),
      (h.noConflict = function () {
        return (n._ = r), this;
      }),
      (h.identity = function (n) {
        return n;
      }),
      (h.constant = function (n) {
        return function () {
          return n;
        };
      }),
      (h.noop = function () {}),
      (h.property = function (r) {
        return h.isArray(r)
          ? function (n) {
              return x(n, r);
            }
          : b(r);
      }),
      (h.propertyOf = function (r) {
        return null == r
          ? function () {}
          : function (n) {
              return h.isArray(n) ? x(r, n) : r[n];
            };
      }),
      (h.matcher = h.matches =
        function (r) {
          return (
            (r = h.extendOwn({}, r)),
            function (n) {
              return h.isMatch(n, r);
            }
          );
        }),
      (h.times = function (n, r, t) {
        var e = Array(Math.max(0, n));
        r = y(r, t, 1);
        for (var u = 0; u < n; u++) e[u] = r(u);
        return e;
      }),
      (h.random = function (n, r) {
        return null == r && ((r = n), (n = 0)), n + Math.floor(Math.random() * (r - n + 1));
      }),
      (h.now =
        Date.now ||
        function () {
          return new Date().getTime();
        });
    var L = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;" },
      P = h.invert(L),
      W = function (r) {
        var t = function (n) {
            return r[n];
          },
          n = "(?:" + h.keys(r).join("|") + ")",
          e = RegExp(n),
          u = RegExp(n, "g");
        return function (n) {
          return (n = null == n ? "" : "" + n), e.test(n) ? n.replace(u, t) : n;
        };
      };
    (h.escape = W(L)),
      (h.unescape = W(P)),
      (h.result = function (n, r, t) {
        h.isArray(r) || (r = [r]);
        var e = r.length;
        if (!e) return h.isFunction(t) ? t.call(n) : t;
        for (var u = 0; u < e; u++) {
          var i = null == n ? void 0 : n[r[u]];
          void 0 === i && ((i = t), (u = e)), (n = h.isFunction(i) ? i.call(n) : i);
        }
        return n;
      });
    var C = 0;
    (h.uniqueId = function (n) {
      var r = ++C + "";
      return n ? n + r : r;
    }),
      (h.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g,
      });
    var J = /(.)^/,
      U = { "'": "'", "\\": "\\", "\r": "r", "\n": "n", "\u2028": "u2028", "\u2029": "u2029" },
      V = /\\|'|\r|\n|\u2028|\u2029/g,
      $ = function (n) {
        return "\\" + U[n];
      };
    (h.template = function (i, n, r) {
      !n && r && (n = r), (n = h.defaults({}, n, h.templateSettings));
      var t,
        e = RegExp(
          [(n.escape || J).source, (n.interpolate || J).source, (n.evaluate || J).source].join("|") + "|$",
          "g"
        ),
        o = 0,
        a = "__p+='";
      i.replace(e, function (n, r, t, e, u) {
        return (
          (a += i.slice(o, u).replace(V, $)),
          (o = u + n.length),
          r
            ? (a += "'+\n((__t=(" + r + "))==null?'':_.escape(__t))+\n'")
            : t
            ? (a += "'+\n((__t=(" + t + "))==null?'':__t)+\n'")
            : e && (a += "';\n" + e + "\n__p+='"),
          n
        );
      }),
        (a += "';\n"),
        n.variable || (a = "with(obj||{}){\n" + a + "}\n"),
        (a =
          "var __t,__p='',__j=Array.prototype.join," +
          "print=function(){__p+=__j.call(arguments,'');};\n" +
          a +
          "return __p;\n");
      try {
        t = new Function(n.variable || "obj", "_", a);
      } catch (n) {
        throw ((n.source = a), n);
      }
      var u = function (n) {
          return t.call(this, n, h);
        },
        c = n.variable || "obj";
      return (u.source = "function(" + c + "){\n" + a + "}"), u;
    }),
      (h.chain = function (n) {
        var r = h(n);
        return (r._chain = !0), r;
      });
    var G = function (n, r) {
      return n._chain ? h(r).chain() : r;
    };
    (h.mixin = function (t) {
      return (
        h.each(h.functions(t), function (n) {
          var r = (h[n] = t[n]);
          h.prototype[n] = function () {
            var n = [this._wrapped];
            return u.apply(n, arguments), G(this, r.apply(h, n));
          };
        }),
        h
      );
    }),
      h.mixin(h),
      h.each(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (r) {
        var t = e[r];
        h.prototype[r] = function () {
          var n = this._wrapped;
          return t.apply(n, arguments), ("shift" !== r && "splice" !== r) || 0 !== n.length || delete n[0], G(this, n);
        };
      }),
      h.each(["concat", "join", "slice"], function (n) {
        var r = e[n];
        h.prototype[n] = function () {
          return G(this, r.apply(this._wrapped, arguments));
        };
      }),
      (h.prototype.value = function () {
        return this._wrapped;
      }),
      (h.prototype.valueOf = h.prototype.toJSON = h.prototype.value),
      (h.prototype.toString = function () {
        return String(this._wrapped);
      }),
      "function" == typeof define &&
        define.amd &&
        define("underscore", [], function () {
          return h;
        });
  })();
  window._uds = _.noConflict();

  /*!
   * typeahead.js 0.11.1
   * https://github.com/twitter/typeahead.js
   * Copyright 2013-2015 Twitter, Inc. and other contributors; Licensed MIT
   */
  !(function (a, b) {
    "function" == typeof define && define.amd
      ? define("bloodhound", ["jquery"], function (c) {
          return (a.Bloodhound = b(c));
        })
      : "object" == typeof exports
      ? (module.exports = b(require("jquery")))
      : (a.Bloodhound = b(jQuery));
  })(this, function (a) {
    var b = (function () {
        "use strict";
        return {
          isMsie: function () {
            return /(msie|trident)/i.test(navigator.userAgent)
              ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2]
              : !1;
          },
          isBlankString: function (a) {
            return !a || /^\s*$/.test(a);
          },
          escapeRegExChars: function (a) {
            return a.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
          },
          isString: function (a) {
            return "string" == typeof a;
          },
          isNumber: function (a) {
            return "number" == typeof a;
          },
          isArray: a.isArray,
          isFunction: a.isFunction,
          isObject: a.isPlainObject,
          isUndefined: function (a) {
            return "undefined" == typeof a;
          },
          isElement: function (a) {
            return !(!a || 1 !== a.nodeType);
          },
          isJQuery: function (b) {
            return b instanceof a;
          },
          toStr: function (a) {
            return b.isUndefined(a) || null === a ? "" : a + "";
          },
          bind: a.proxy,
          each: function (b, c) {
            function d(a, b) {
              return c(b, a);
            }
            a.each(b, d);
          },
          map: a.map,
          filter: a.grep,
          every: function (b, c) {
            var d = !0;
            return b
              ? (a.each(b, function (a, e) {
                  return (d = c.call(null, e, a, b)) ? void 0 : !1;
                }),
                !!d)
              : d;
          },
          some: function (b, c) {
            var d = !1;
            return b
              ? (a.each(b, function (a, e) {
                  return (d = c.call(null, e, a, b)) ? !1 : void 0;
                }),
                !!d)
              : d;
          },
          mixin: a.extend,
          identity: function (a) {
            return a;
          },
          clone: function (b) {
            return a.extend(!0, {}, b);
          },
          getIdGenerator: function () {
            var a = 0;
            return function () {
              return a++;
            };
          },
          templatify: function (b) {
            function c() {
              return String(b);
            }
            return a.isFunction(b) ? b : c;
          },
          defer: function (a) {
            setTimeout(a, 0);
          },
          debounce: function (a, b, c) {
            var d, e;
            return function () {
              var f,
                g,
                h = this,
                i = arguments;
              return (
                (f = function () {
                  (d = null), c || (e = a.apply(h, i));
                }),
                (g = c && !d),
                clearTimeout(d),
                (d = setTimeout(f, b)),
                g && (e = a.apply(h, i)),
                e
              );
            };
          },
          throttle: function (a, b) {
            var c, d, e, f, g, h;
            return (
              (g = 0),
              (h = function () {
                (g = new Date()), (e = null), (f = a.apply(c, d));
              }),
              function () {
                var i = new Date(),
                  j = b - (i - g);
                return (
                  (c = this),
                  (d = arguments),
                  0 >= j ? (clearTimeout(e), (e = null), (g = i), (f = a.apply(c, d))) : e || (e = setTimeout(h, j)),
                  f
                );
              }
            );
          },
          stringify: function (a) {
            return b.isString(a) ? a : JSON.stringify(a);
          },
          noop: function () {},
        };
      })(),
      c = "0.11.1",
      d = (function () {
        "use strict";
        function a(a) {
          return (a = b.toStr(a)), a ? a.split(/\s+/) : [];
        }
        function c(a) {
          return (a = b.toStr(a)), a ? a.split(/\W+/) : [];
        }
        function d(a) {
          return function (c) {
            return (
              (c = b.isArray(c) ? c : [].slice.call(arguments, 0)),
              function (d) {
                var e = [];
                return (
                  b.each(c, function (c) {
                    e = e.concat(a(b.toStr(d[c])));
                  }),
                  e
                );
              }
            );
          };
        }
        return { nonword: c, whitespace: a, obj: { nonword: d(c), whitespace: d(a) } };
      })(),
      e = (function () {
        "use strict";
        function c(c) {
          (this.maxSize = b.isNumber(c) ? c : 100), this.reset(), this.maxSize <= 0 && (this.set = this.get = a.noop);
        }
        function d() {
          this.head = this.tail = null;
        }
        function e(a, b) {
          (this.key = a), (this.val = b), (this.prev = this.next = null);
        }
        return (
          b.mixin(c.prototype, {
            set: function (a, b) {
              var c,
                d = this.list.tail;
              this.size >= this.maxSize && (this.list.remove(d), delete this.hash[d.key], this.size--),
                (c = this.hash[a])
                  ? ((c.val = b), this.list.moveToFront(c))
                  : ((c = new e(a, b)), this.list.add(c), (this.hash[a] = c), this.size++);
            },
            get: function (a) {
              var b = this.hash[a];
              return b ? (this.list.moveToFront(b), b.val) : void 0;
            },
            reset: function () {
              (this.size = 0), (this.hash = {}), (this.list = new d());
            },
          }),
          b.mixin(d.prototype, {
            add: function (a) {
              this.head && ((a.next = this.head), (this.head.prev = a)), (this.head = a), (this.tail = this.tail || a);
            },
            remove: function (a) {
              a.prev ? (a.prev.next = a.next) : (this.head = a.next),
                a.next ? (a.next.prev = a.prev) : (this.tail = a.prev);
            },
            moveToFront: function (a) {
              this.remove(a), this.add(a);
            },
          }),
          c
        );
      })(),
      f = (function () {
        "use strict";
        function c(a, c) {
          (this.prefix = ["__", a, "__"].join("")),
            (this.ttlKey = "__ttl__"),
            (this.keyMatcher = new RegExp("^" + b.escapeRegExChars(this.prefix))),
            (this.ls = c || h),
            !this.ls && this._noop();
        }
        function d() {
          return new Date().getTime();
        }
        function e(a) {
          return JSON.stringify(b.isUndefined(a) ? null : a);
        }
        function f(b) {
          return a.parseJSON(b);
        }
        function g(a) {
          var b,
            c,
            d = [],
            e = h.length;
          for (b = 0; e > b; b++) (c = h.key(b)).match(a) && d.push(c.replace(a, ""));
          return d;
        }
        var h;
        try {
          (h = window.localStorage), h.setItem("~~~", "!"), h.removeItem("~~~");
        } catch (i) {
          h = null;
        }
        return (
          b.mixin(c.prototype, {
            _prefix: function (a) {
              return this.prefix + a;
            },
            _ttlKey: function (a) {
              return this._prefix(a) + this.ttlKey;
            },
            _noop: function () {
              this.get = this.set = this.remove = this.clear = this.isExpired = b.noop;
            },
            _safeSet: function (a, b) {
              try {
                this.ls.setItem(a, b);
              } catch (c) {
                "QuotaExceededError" === c.name && (this.clear(), this._noop());
              }
            },
            get: function (a) {
              return this.isExpired(a) && this.remove(a), f(this.ls.getItem(this._prefix(a)));
            },
            set: function (a, c, f) {
              return (
                b.isNumber(f) ? this._safeSet(this._ttlKey(a), e(d() + f)) : this.ls.removeItem(this._ttlKey(a)),
                this._safeSet(this._prefix(a), e(c))
              );
            },
            remove: function (a) {
              return this.ls.removeItem(this._ttlKey(a)), this.ls.removeItem(this._prefix(a)), this;
            },
            clear: function () {
              var a,
                b = g(this.keyMatcher);
              for (a = b.length; a--; ) this.remove(b[a]);
              return this;
            },
            isExpired: function (a) {
              var c = f(this.ls.getItem(this._ttlKey(a)));
              return b.isNumber(c) && d() > c ? !0 : !1;
            },
          }),
          c
        );
      })(),
      g = (function () {
        "use strict";
        function c(a) {
          (a = a || {}),
            (this.cancelled = !1),
            (this.lastReq = null),
            (this._send = a.transport),
            (this._get = a.limiter ? a.limiter(this._get) : this._get),
            (this._cache = a.cache === !1 ? new e(0) : h);
        }
        var d = 0,
          f = {},
          g = 6,
          h = new e(10);
        return (
          (c.setMaxPendingRequests = function (a) {
            g = a;
          }),
          (c.resetCache = function () {
            h.reset();
          }),
          b.mixin(c.prototype, {
            _fingerprint: function (b) {
              return (b = b || {}), b.url + b.type + a.param(b.data || {});
            },
            _get: function (a, b) {
              function c(a) {
                b(null, a), k._cache.set(i, a);
              }
              function e() {
                b(!0);
              }
              function h() {
                d--,
                  delete f[i],
                  k.onDeckRequestArgs && (k._get.apply(k, k.onDeckRequestArgs), (k.onDeckRequestArgs = null));
              }
              var i,
                j,
                k = this;
              (i = this._fingerprint(a)),
                this.cancelled ||
                  i !== this.lastReq ||
                  ((j = f[i])
                    ? j.done(c).fail(e)
                    : g > d
                    ? (d++, (f[i] = this._send(a).done(c).fail(e).always(h)))
                    : (this.onDeckRequestArgs = [].slice.call(arguments, 0)));
            },
            get: function (c, d) {
              var e, f;
              (d = d || a.noop),
                (c = b.isString(c) ? { url: c } : c || {}),
                (f = this._fingerprint(c)),
                (this.cancelled = !1),
                (this.lastReq = f),
                (e = this._cache.get(f)) ? d(null, e) : this._get(c, d);
            },
            cancel: function () {
              this.cancelled = !0;
            },
          }),
          c
        );
      })(),
      h = (window.SearchIndex = (function () {
        "use strict";
        function c(c) {
          (c = c || {}),
            (c.datumTokenizer && c.queryTokenizer) || a.error("datumTokenizer and queryTokenizer are both required"),
            (this.identify = c.identify || b.stringify),
            (this.datumTokenizer = c.datumTokenizer),
            (this.queryTokenizer = c.queryTokenizer),
            this.reset();
        }
        function d(a) {
          return (
            (a = b.filter(a, function (a) {
              return !!a;
            })),
            (a = b.map(a, function (a) {
              return a.toLowerCase();
            }))
          );
        }
        function e() {
          var a = {};
          return (a[i] = []), (a[h] = {}), a;
        }
        function f(a) {
          for (var b = {}, c = [], d = 0, e = a.length; e > d; d++) b[a[d]] || ((b[a[d]] = !0), c.push(a[d]));
          return c;
        }
        function g(a, b) {
          var c = 0,
            d = 0,
            e = [];
          (a = a.sort()), (b = b.sort());
          for (var f = a.length, g = b.length; f > c && g > d; )
            a[c] < b[d] ? c++ : a[c] > b[d] ? d++ : (e.push(a[c]), c++, d++);
          return e;
        }
        var h = "c",
          i = "i";
        return (
          b.mixin(c.prototype, {
            bootstrap: function (a) {
              (this.datums = a.datums), (this.trie = a.trie);
            },
            add: function (a) {
              var c = this;
              (a = b.isArray(a) ? a : [a]),
                b.each(a, function (a) {
                  var f, g;
                  (c.datums[(f = c.identify(a))] = a),
                    (g = d(c.datumTokenizer(a))),
                    b.each(g, function (a) {
                      var b, d, g;
                      for (b = c.trie, d = a.split(""); (g = d.shift()); )
                        (b = b[h][g] || (b[h][g] = e())), b[i].push(f);
                    });
                });
            },
            get: function (a) {
              var c = this;
              return b.map(a, function (a) {
                return c.datums[a];
              });
            },
            search: function (a) {
              var c,
                e,
                j = this;
              return (
                (c = d(this.queryTokenizer(a))),
                b.each(c, function (a) {
                  var b, c, d, f;
                  if (e && 0 === e.length) return !1;
                  for (b = j.trie, c = a.split(""); b && (d = c.shift()); ) b = b[h][d];
                  return b && 0 === c.length ? ((f = b[i].slice(0)), void (e = e ? g(e, f) : f)) : ((e = []), !1);
                }),
                e
                  ? b.map(f(e), function (a) {
                      return j.datums[a];
                    })
                  : []
              );
            },
            all: function () {
              var a = [];
              for (var b in this.datums) a.push(this.datums[b]);
              return a;
            },
            reset: function () {
              (this.datums = {}), (this.trie = e());
            },
            serialize: function () {
              return { datums: this.datums, trie: this.trie };
            },
          }),
          c
        );
      })()),
      i = (function () {
        "use strict";
        function a(a) {
          (this.url = a.url),
            (this.ttl = a.ttl),
            (this.cache = a.cache),
            (this.prepare = a.prepare),
            (this.transform = a.transform),
            (this.transport = a.transport),
            (this.thumbprint = a.thumbprint),
            (this.storage = new f(a.cacheKey));
        }
        var c;
        return (
          (c = { data: "data", protocol: "protocol", thumbprint: "thumbprint" }),
          b.mixin(a.prototype, {
            _settings: function () {
              return { url: this.url, type: "GET", dataType: "json" };
            },
            store: function (a) {
              this.cache &&
                (this.storage.set(c.data, a, this.ttl),
                this.storage.set(c.protocol, location.protocol, this.ttl),
                this.storage.set(c.thumbprint, this.thumbprint, this.ttl));
            },
            fromCache: function () {
              var a,
                b = {};
              return this.cache
                ? ((b.data = this.storage.get(c.data)),
                  (b.protocol = this.storage.get(c.protocol)),
                  (b.thumbprint = this.storage.get(c.thumbprint)),
                  (a = b.thumbprint !== this.thumbprint || b.protocol !== location.protocol),
                  b.data && !a ? b.data : null)
                : null;
            },
            fromNetwork: function (a) {
              function b() {
                a(!0);
              }
              function c(b) {
                a(null, e.transform(b));
              }
              var d,
                e = this;
              a && ((d = this.prepare(this._settings())), this.transport(d).fail(b).done(c));
            },
            clear: function () {
              return this.storage.clear(), this;
            },
          }),
          a
        );
      })(),
      j = (function () {
        "use strict";
        function a(a) {
          (this.url = a.url),
            (this.prepare = a.prepare),
            (this.transform = a.transform),
            (this.transport = new g({ cache: a.cache, limiter: a.limiter, transport: a.transport }));
        }
        return (
          b.mixin(a.prototype, {
            _settings: function () {
              return { url: this.url, type: "GET", dataType: "json" };
            },
            get: function (a, b) {
              function c(a, c) {
                b(a ? [] : e.transform(c));
              }
              var d,
                e = this;
              if (b) return (a = a || ""), (d = this.prepare(a, this._settings())), this.transport.get(d, c);
            },
            cancelLastRequest: function () {
              this.transport.cancel();
            },
          }),
          a
        );
      })(),
      k = (function () {
        "use strict";
        function d(d) {
          var e;
          return d
            ? ((e = {
                url: null,
                ttl: 864e5,
                cache: !0,
                cacheKey: null,
                thumbprint: "",
                prepare: b.identity,
                transform: b.identity,
                transport: null,
              }),
              (d = b.isString(d) ? { url: d } : d),
              (d = b.mixin(e, d)),
              !d.url && a.error("prefetch requires url to be set"),
              (d.transform = d.filter || d.transform),
              (d.cacheKey = d.cacheKey || d.url),
              (d.thumbprint = c + d.thumbprint),
              (d.transport = d.transport ? h(d.transport) : a.ajax),
              d)
            : null;
        }
        function e(c) {
          var d;
          if (c)
            return (
              (d = {
                url: null,
                cache: !0,
                prepare: null,
                replace: null,
                wildcard: null,
                limiter: null,
                rateLimitBy: "debounce",
                rateLimitWait: 300,
                transform: b.identity,
                transport: null,
              }),
              (c = b.isString(c) ? { url: c } : c),
              (c = b.mixin(d, c)),
              !c.url && a.error("remote requires url to be set"),
              (c.transform = c.filter || c.transform),
              (c.prepare = f(c)),
              (c.limiter = g(c)),
              (c.transport = c.transport ? h(c.transport) : a.ajax),
              delete c.replace,
              delete c.wildcard,
              delete c.rateLimitBy,
              delete c.rateLimitWait,
              c
            );
        }
        function f(a) {
          function b(a, b) {
            return (b.url = f(b.url, a)), b;
          }
          function c(a, b) {
            return (b.url = b.url.replace(g, encodeURIComponent(a))), b;
          }
          function d(a, b) {
            return b;
          }
          var e, f, g;
          return (e = a.prepare), (f = a.replace), (g = a.wildcard), e ? e : (e = f ? b : a.wildcard ? c : d);
        }
        function g(a) {
          function c(a) {
            return function (c) {
              return b.debounce(c, a);
            };
          }
          function d(a) {
            return function (c) {
              return b.throttle(c, a);
            };
          }
          var e, f, g;
          return (
            (e = a.limiter),
            (f = a.rateLimitBy),
            (g = a.rateLimitWait),
            e || (e = /^throttle$/i.test(f) ? d(g) : c(g)),
            e
          );
        }
        function h(c) {
          return function (d) {
            function e(a) {
              b.defer(function () {
                g.resolve(a);
              });
            }
            function f(a) {
              b.defer(function () {
                g.reject(a);
              });
            }
            var g = a.Deferred();
            return c(d, e, f), g;
          };
        }
        return function (c) {
          var f, g;
          return (
            (f = {
              initialize: !0,
              identify: b.stringify,
              datumTokenizer: null,
              queryTokenizer: null,
              sufficient: 5,
              sorter: null,
              local: [],
              prefetch: null,
              remote: null,
            }),
            (c = b.mixin(f, c || {})),
            !c.datumTokenizer && a.error("datumTokenizer is required"),
            !c.queryTokenizer && a.error("queryTokenizer is required"),
            (g = c.sorter),
            (c.sorter = g
              ? function (a) {
                  return a.sort(g);
                }
              : b.identity),
            (c.local = b.isFunction(c.local) ? c.local() : c.local),
            (c.prefetch = d(c.prefetch)),
            (c.remote = e(c.remote)),
            c
          );
        };
      })(),
      l = (function () {
        "use strict";
        function c(a) {
          (a = k(a)),
            (this.sorter = a.sorter),
            (this.identify = a.identify),
            (this.sufficient = a.sufficient),
            (this.local = a.local),
            (this.remote = a.remote ? new j(a.remote) : null),
            (this.prefetch = a.prefetch ? new i(a.prefetch) : null),
            (this.index = new h({
              identify: this.identify,
              datumTokenizer: a.datumTokenizer,
              queryTokenizer: a.queryTokenizer,
            })),
            a.initialize !== !1 && this.initialize();
        }
        var e;
        return (
          (e = window && window.Bloodhound),
          (c.noConflict = function () {
            return window && (window.Bloodhound = e), c;
          }),
          (c.tokenizers = d),
          b.mixin(c.prototype, {
            __ttAdapter: function () {
              function a(a, b, d) {
                return c.search(a, b, d);
              }
              function b(a, b) {
                return c.search(a, b);
              }
              var c = this;
              return this.remote ? a : b;
            },
            _loadPrefetch: function () {
              function b(a, b) {
                return a ? c.reject() : (e.add(b), e.prefetch.store(e.index.serialize()), void c.resolve());
              }
              var c,
                d,
                e = this;
              return (
                (c = a.Deferred()),
                this.prefetch
                  ? (d = this.prefetch.fromCache())
                    ? (this.index.bootstrap(d), c.resolve())
                    : this.prefetch.fromNetwork(b)
                  : c.resolve(),
                c.promise()
              );
            },
            _initialize: function () {
              function a() {
                b.add(b.local);
              }
              var b = this;
              return this.clear(), (this.initPromise = this._loadPrefetch()).done(a), this.initPromise;
            },
            initialize: function (a) {
              return !this.initPromise || a ? this._initialize() : this.initPromise;
            },
            add: function (a) {
              return this.index.add(a), this;
            },
            get: function (a) {
              return (a = b.isArray(a) ? a : [].slice.call(arguments)), this.index.get(a);
            },
            search: function (a, c, d) {
              function e(a) {
                var c = [];
                b.each(a, function (a) {
                  !b.some(f, function (b) {
                    return g.identify(a) === g.identify(b);
                  }) && c.push(a);
                }),
                  d && d(c);
              }
              var f,
                g = this;
              return (
                (f = this.sorter(this.index.search(a))),
                c(this.remote ? f.slice() : f),
                this.remote && f.length < this.sufficient
                  ? this.remote.get(a, e)
                  : this.remote && this.remote.cancelLastRequest(),
                this
              );
            },
            all: function () {
              return this.index.all();
            },
            clear: function () {
              return this.index.reset(), this;
            },
            clearPrefetchCache: function () {
              return this.prefetch && this.prefetch.clear(), this;
            },
            clearRemoteCache: function () {
              return g.resetCache(), this;
            },
            ttAdapter: function () {
              return this.__ttAdapter();
            },
          }),
          c
        );
      })();
    return l;
  }),
    (function (a, b) {
      "function" == typeof define && define.amd
        ? define("typeahead.js", ["jquery"], function (a) {
            return b(a);
          })
        : "object" == typeof exports
        ? (module.exports = b(require("jquery")))
        : b(jQuery);
    })(this, function (a) {
      var b = (function () {
          "use strict";
          return {
            isMsie: function () {
              return /(msie|trident)/i.test(navigator.userAgent)
                ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2]
                : !1;
            },
            isBlankString: function (a) {
              return !a || /^\s*$/.test(a);
            },
            escapeRegExChars: function (a) {
              return a.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
            },
            isString: function (a) {
              return "string" == typeof a;
            },
            isNumber: function (a) {
              return "number" == typeof a;
            },
            isArray: a.isArray,
            isFunction: a.isFunction,
            isObject: a.isPlainObject,
            isUndefined: function (a) {
              return "undefined" == typeof a;
            },
            isElement: function (a) {
              return !(!a || 1 !== a.nodeType);
            },
            isJQuery: function (b) {
              return b instanceof a;
            },
            toStr: function (a) {
              return b.isUndefined(a) || null === a ? "" : a + "";
            },
            bind: a.proxy,
            each: function (b, c) {
              function d(a, b) {
                return c(b, a);
              }
              a.each(b, d);
            },
            map: a.map,
            filter: a.grep,
            every: function (b, c) {
              var d = !0;
              return b
                ? (a.each(b, function (a, e) {
                    return (d = c.call(null, e, a, b)) ? void 0 : !1;
                  }),
                  !!d)
                : d;
            },
            some: function (b, c) {
              var d = !1;
              return b
                ? (a.each(b, function (a, e) {
                    return (d = c.call(null, e, a, b)) ? !1 : void 0;
                  }),
                  !!d)
                : d;
            },
            mixin: a.extend,
            identity: function (a) {
              return a;
            },
            clone: function (b) {
              return a.extend(!0, {}, b);
            },
            getIdGenerator: function () {
              var a = 0;
              return function () {
                return a++;
              };
            },
            templatify: function (b) {
              function c() {
                return String(b);
              }
              return a.isFunction(b) ? b : c;
            },
            defer: function (a) {
              setTimeout(a, 0);
            },
            debounce: function (a, b, c) {
              var d, e;
              return function () {
                var f,
                  g,
                  h = this,
                  i = arguments;
                return (
                  (f = function () {
                    (d = null), c || (e = a.apply(h, i));
                  }),
                  (g = c && !d),
                  clearTimeout(d),
                  (d = setTimeout(f, b)),
                  g && (e = a.apply(h, i)),
                  e
                );
              };
            },
            throttle: function (a, b) {
              var c, d, e, f, g, h;
              return (
                (g = 0),
                (h = function () {
                  (g = new Date()), (e = null), (f = a.apply(c, d));
                }),
                function () {
                  var i = new Date(),
                    j = b - (i - g);
                  return (
                    (c = this),
                    (d = arguments),
                    0 >= j ? (clearTimeout(e), (e = null), (g = i), (f = a.apply(c, d))) : e || (e = setTimeout(h, j)),
                    f
                  );
                }
              );
            },
            stringify: function (a) {
              return b.isString(a) ? a : JSON.stringify(a);
            },
            noop: function () {},
          };
        })(),
        c = (function () {
          "use strict";
          function a(a) {
            var g, h;
            return (
              (h = b.mixin({}, f, a)),
              (g = { css: e(), classes: h, html: c(h), selectors: d(h) }),
              {
                css: g.css,
                html: g.html,
                classes: g.classes,
                selectors: g.selectors,
                mixin: function (a) {
                  b.mixin(a, g);
                },
              }
            );
          }
          function c(a) {
            return { wrapper: '<span class="' + a.wrapper + '"></span>', menu: '<div class="' + a.menu + '"></div>' };
          }
          function d(a) {
            var c = {};
            return (
              b.each(a, function (a, b) {
                c[b] = "." + a;
              }),
              c
            );
          }
          function e() {
            var a = {
              wrapper: { position: "relative", display: "inline-block" },
              hint: {
                position: "absolute",
                top: "0",
                left: "0",
                borderColor: "transparent",
                boxShadow: "none",
                opacity: ".5",
              },
              input: { position: "relative", verticalAlign: "top", backgroundColor: "transparent" },
              inputWithNoHint: { position: "relative", verticalAlign: "top" },
              menu: { position: "fixed", left: "0", zIndex: "108000", display: "none" },
              ltr: { left: "0", right: "auto" },
              rtl: { left: "auto", right: " 0" },
            };
            return (
              b.isMsie() &&
                b.mixin(a.input, {
                  backgroundImage:
                    "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)",
                }),
              a
            );
          }
          var f = {
            wrapper: "uds-typeahead-wrapper",
            input: "tt-input",
            hint: "tt-hint",
            menu: "tt-menu",
            dataset: "tt-dataset",
            suggestion: "tt-suggestion",
            selectable: "tt-selectable",
            empty: "tt-empty",
            open: "tt-open",
            cursor: "tt-cursor",
            highlight: "tt-highlight",
          };
          return a;
        })(),
        d = (function () {
          "use strict";
          function c(b) {
            (b && b.el) || a.error("EventBus initialized without el"), (this.$el = a(b.el));
          }
          var d, e;
          return (
            (d = "typeahead:"),
            (e = {
              render: "rendered",
              cursorchange: "cursorchanged",
              select: "selected",
              autocomplete: "autocompleted",
            }),
            b.mixin(c.prototype, {
              _trigger: function (b, c) {
                var e;
                return (e = a.Event(d + b)), (c = c || []).unshift(e), this.$el.trigger.apply(this.$el, c), e;
              },
              before: function (a) {
                var b, c;
                return (b = [].slice.call(arguments, 1)), (c = this._trigger("before" + a, b)), c.isDefaultPrevented();
              },
              trigger: function (a) {
                var b;
                this._trigger(a, [].slice.call(arguments, 1)),
                  (b = e[a]) && this._trigger(b, [].slice.call(arguments, 1));
              },
            }),
            c
          );
        })(),
        e = (function () {
          "use strict";
          function a(a, b, c, d) {
            var e;
            if (!c) return this;
            for (b = b.split(i), c = d ? h(c, d) : c, this._callbacks = this._callbacks || {}; (e = b.shift()); )
              (this._callbacks[e] = this._callbacks[e] || { sync: [], async: [] }), this._callbacks[e][a].push(c);
            return this;
          }
          function b(b, c, d) {
            return a.call(this, "async", b, c, d);
          }
          function c(b, c, d) {
            return a.call(this, "sync", b, c, d);
          }
          function d(a) {
            var b;
            if (!this._callbacks) return this;
            for (a = a.split(i); (b = a.shift()); ) delete this._callbacks[b];
            return this;
          }
          function e(a) {
            var b, c, d, e, g;
            if (!this._callbacks) return this;
            for (a = a.split(i), d = [].slice.call(arguments, 1); (b = a.shift()) && (c = this._callbacks[b]); )
              (e = f(c.sync, this, [b].concat(d))), (g = f(c.async, this, [b].concat(d))), e() && j(g);
            return this;
          }
          function f(a, b, c) {
            function d() {
              for (var d, e = 0, f = a.length; !d && f > e; e += 1) d = a[e].apply(b, c) === !1;
              return !d;
            }
            return d;
          }
          function g() {
            var a;
            return (a = window.setImmediate
              ? function (a) {
                  setImmediate(function () {
                    a();
                  });
                }
              : function (a) {
                  setTimeout(function () {
                    a();
                  }, 0);
                });
          }
          function h(a, b) {
            return a.bind
              ? a.bind(b)
              : function () {
                  a.apply(b, [].slice.call(arguments, 0));
                };
          }
          var i = /\s+/,
            j = g();
          return { onSync: c, onAsync: b, off: d, trigger: e };
        })(),
        f = (function (a) {
          "use strict";
          function c(a, c, d) {
            for (var e, f = [], g = 0, h = a.length; h > g; g++) f.push(b.escapeRegExChars(a[g]));
            return (
              (e = d ? "\\b(" + f.join("|") + ")\\b" : "(" + f.join("|") + ")"), c ? new RegExp(e) : new RegExp(e, "i")
            );
          }
          var d = { node: null, pattern: null, tagName: "strong", className: null, wordsOnly: !1, caseSensitive: !1 };
          return function (e) {
            function f(b) {
              var c, d, f;
              return (
                (c = h.exec(b.data)) &&
                  ((f = a.createElement(e.tagName)),
                  e.className && (f.className = e.className),
                  (d = b.splitText(c.index)),
                  d.splitText(c[0].length),
                  f.appendChild(d.cloneNode(!0)),
                  b.parentNode.replaceChild(f, d)),
                !!c
              );
            }
            function g(a, b) {
              for (var c, d = 3, e = 0; e < a.childNodes.length; e++)
                (c = a.childNodes[e]), c.nodeType === d ? (e += b(c) ? 1 : 0) : g(c, b);
            }
            var h;
            (e = b.mixin({}, d, e)),
              e.node &&
                e.pattern &&
                ((e.pattern = b.isArray(e.pattern) ? e.pattern : [e.pattern]),
                (h = c(e.pattern, e.caseSensitive, e.wordsOnly)),
                g(e.node, f));
          };
        })(window.document),
        g = (function () {
          "use strict";
          function c(c, e) {
            (c = c || {}),
              c.input || a.error("input is missing"),
              e.mixin(this),
              (this.$hint = a(c.hint)),
              (this.$input = a(c.input)),
              (this.query = this.$input.val()),
              (this.queryWhenFocused = this.hasFocus() ? this.query : null),
              (this.$overflowHelper = d(this.$input)),
              this._checkLanguageDirection(),
              0 === this.$hint.length &&
                (this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = b.noop);
          }
          function d(b) {
            return a('<pre aria-hidden="true"></pre>')
              .css({
                position: "absolute",
                visibility: "hidden",
                whiteSpace: "pre",
                fontFamily: b.css("font-family"),
                fontSize: b.css("font-size"),
                fontStyle: b.css("font-style"),
                fontVariant: b.css("font-variant"),
                fontWeight: b.css("font-weight"),
                wordSpacing: b.css("word-spacing"),
                letterSpacing: b.css("letter-spacing"),
                textIndent: b.css("text-indent"),
                textRendering: b.css("text-rendering"),
                textTransform: b.css("text-transform"),
              })
              .insertAfter(b);
          }
          function f(a, b) {
            return c.normalizeQuery(a) === c.normalizeQuery(b);
          }
          function g(a) {
            return a.altKey || a.ctrlKey || a.metaKey || a.shiftKey;
          }
          var h;
          return (
            (h = { 9: "tab", 27: "esc", 37: "left", 39: "right", 13: "enter", 38: "up", 40: "down" }),
            (c.normalizeQuery = function (a) {
              return b
                .toStr(a)
                .replace(/^\s*/g, "")
                .replace(/\s{2,}/g, " ");
            }),
            b.mixin(c.prototype, e, {
              _onBlur: function () {
                this.resetInputValue(), this.trigger("blurred");
              },
              _onFocus: function () {
                (this.queryWhenFocused = this.query), this.trigger("focused");
              },
              _onKeydown: function (a) {
                var b = h[a.which || a.keyCode];
                this._managePreventDefault(b, a), b && this._shouldTrigger(b, a) && this.trigger(b + "Keyed", a);
              },
              _onInput: function () {
                this._setQuery(this.getInputValue()), this.clearHintIfInvalid(), this._checkLanguageDirection();
              },
              _managePreventDefault: function (a, b) {
                var c;
                switch (a) {
                  case "up":
                  case "down":
                    c = !g(b);
                    break;
                  default:
                    c = !1;
                }
                c && b.preventDefault();
              },
              _shouldTrigger: function (a, b) {
                var c;
                switch (a) {
                  case "tab":
                    c = !g(b);
                    break;
                  default:
                    c = !0;
                }
                return c;
              },
              _checkLanguageDirection: function () {
                var a = (this.$input.css("direction") || "ltr").toLowerCase();
                this.dir !== a && ((this.dir = a), this.$hint.attr("dir", a), this.trigger("langDirChanged", a));
              },
              _setQuery: function (a, b) {
                var c, d;
                (c = f(a, this.query)),
                  (d = c ? this.query.length !== a.length : !1),
                  (this.query = a),
                  b || c
                    ? !b && d && this.trigger("whitespaceChanged", this.query)
                    : this.trigger("queryChanged", this.query);
              },
              bind: function () {
                var a,
                  c,
                  d,
                  e,
                  f = this;
                return (
                  (a = b.bind(this._onBlur, this)),
                  (c = b.bind(this._onFocus, this)),
                  (d = b.bind(this._onKeydown, this)),
                  (e = b.bind(this._onInput, this)),
                  this.$input.on("blur.tt", a).on("focus.tt", c).on("keydown.tt", d),
                  !b.isMsie() || b.isMsie() > 9
                    ? this.$input.on("input.tt", e)
                    : this.$input.on("keydown.tt keypress.tt cut.tt paste.tt", function (a) {
                        h[a.which || a.keyCode] || b.defer(b.bind(f._onInput, f, a));
                      }),
                  this
                );
              },
              focus: function () {
                this.$input.focus();
              },
              blur: function () {
                this.$input.blur();
              },
              getLangDir: function () {
                return this.dir;
              },
              getQuery: function () {
                return this.query || "";
              },
              setQuery: function (a, b) {
                this.setInputValue(a), this._setQuery(a, b);
              },
              hasQueryChangedSinceLastFocus: function () {
                return this.query !== this.queryWhenFocused;
              },
              getInputValue: function () {
                return this.$input.val();
              },
              setInputValue: function (a) {
                this.$input.val(a), this.clearHintIfInvalid(), this._checkLanguageDirection();
              },
              resetInputValue: function () {
                this.setInputValue(this.query);
              },
              getHint: function () {
                return this.$hint.val();
              },
              setHint: function (a) {
                this.$hint.val(a);
              },
              clearHint: function () {
                this.setHint("");
              },
              clearHintIfInvalid: function () {
                var a, b, c, d;
                (a = this.getInputValue()),
                  (b = this.getHint()),
                  (c = a !== b && 0 === b.indexOf(a)),
                  (d = "" !== a && c && !this.hasOverflow()),
                  !d && this.clearHint();
              },
              hasFocus: function () {
                return this.$input.is(":focus");
              },
              hasOverflow: function () {
                var a = this.$input.width() - 2;
                return this.$overflowHelper.text(this.getInputValue()), this.$overflowHelper.width() >= a;
              },
              isCursorAtEnd: function () {
                var a, c, d;
                return (
                  (a = this.$input.val().length),
                  (c = this.$input[0].selectionStart),
                  b.isNumber(c)
                    ? c === a
                    : document.selection
                    ? ((d = document.selection.createRange()), d.moveStart("character", -a), a === d.text.length)
                    : !0
                );
              },
              destroy: function () {
                this.$hint.off(".tt"),
                  this.$input.off(".tt"),
                  this.$overflowHelper.remove(),
                  (this.$hint = this.$input = this.$overflowHelper = a("<div>"));
              },
            }),
            c
          );
        })(),
        h = (function () {
          "use strict";
          function c(c, e) {
            (c = c || {}),
              (c.templates = c.templates || {}),
              (c.templates.notFound = c.templates.notFound || c.templates.empty),
              c.source || a.error("missing source"),
              c.node || a.error("missing node"),
              c.name && !h(c.name) && a.error("invalid dataset name: " + c.name),
              e.mixin(this),
              (this.highlight = !!c.highlight),
              (this.name = c.name || j()),
              (this.limit = c.limit || 5),
              (this.displayFn = d(c.display || c.displayKey)),
              (this.templates = g(c.templates, this.displayFn)),
              (this.source = c.source.__ttAdapter ? c.source.__ttAdapter() : c.source),
              (this.async = b.isUndefined(c.async) ? this.source.length > 2 : !!c.async),
              this._resetLastSuggestion(),
              (this.$el = a(c.node)
                .addClass(this.classes.dataset)
                .addClass(this.classes.dataset + "-" + this.name));
          }
          function d(a) {
            function c(b) {
              return b[a];
            }
            return (a = a || b.stringify), b.isFunction(a) ? a : c;
          }
          function g(c, d) {
            function e(b) {
              return a("<div>").text(d(b));
            }
            return {
              notFound: c.notFound && b.templatify(c.notFound),
              pending: c.pending && b.templatify(c.pending),
              header: c.header && b.templatify(c.header),
              footer: c.footer && b.templatify(c.footer),
              suggestion: c.suggestion || e,
            };
          }
          function h(a) {
            return /^[_a-zA-Z0-9-]+$/.test(a);
          }
          var i, j;
          return (
            (i = { val: "tt-selectable-display", obj: "tt-selectable-object" }),
            (j = b.getIdGenerator()),
            (c.extractData = function (b) {
              var c = a(b);
              return c.data(i.obj) ? { val: c.data(i.val) || "", obj: c.data(i.obj) || null } : null;
            }),
            b.mixin(c.prototype, e, {
              _overwrite: function (a, b) {
                (b = b || []),
                  b.length
                    ? this._renderSuggestions(a, b)
                    : this.async && this.templates.pending
                    ? this._renderPending(a)
                    : !this.async && this.templates.notFound
                    ? this._renderNotFound(a)
                    : this._empty(),
                  this.trigger("rendered", this.name, b, !1);
              },
              _append: function (a, b) {
                (b = b || []),
                  b.length && this.$lastSuggestion.length
                    ? this._appendSuggestions(a, b)
                    : b.length
                    ? this._renderSuggestions(a, b)
                    : !this.$lastSuggestion.length && this.templates.notFound && this._renderNotFound(a),
                  this.trigger("rendered", this.name, b, !0);
              },
              _renderSuggestions: function (a, b) {
                var c;
                (c = this._getSuggestionsFragment(a, b)),
                  (this.$lastSuggestion = c.children().last()),
                  this.$el.html(c).prepend(this._getHeader(a, b)).append(this._getFooter(a, b));
              },
              _appendSuggestions: function (a, b) {
                var c, d;
                (c = this._getSuggestionsFragment(a, b)),
                  (d = c.children().last()),
                  this.$lastSuggestion.after(c),
                  (this.$lastSuggestion = d);
              },
              _renderPending: function (a) {
                var b = this.templates.pending;
                this._resetLastSuggestion(), b && this.$el.html(b({ query: a, dataset: this.name }));
              },
              _renderNotFound: function (a) {
                var b = this.templates.notFound;
                this._resetLastSuggestion(), b && this.$el.html(b({ query: a, dataset: this.name }));
              },
              _empty: function () {
                this.$el.empty(), this._resetLastSuggestion();
              },
              _getSuggestionsFragment: function (c, d) {
                var e,
                  g = this;
                return (
                  (e = document.createDocumentFragment()),
                  b.each(d, function (b) {
                    var d, f;
                    (f = g._injectQuery(c, b)),
                      (d = a(g.templates.suggestion(f))
                        .data(i.obj, b)
                        .data(i.val, g.displayFn(b))
                        .addClass(g.classes.suggestion + " " + g.classes.selectable)),
                      e.appendChild(d[0]);
                  }),
                  this.highlight && f({ className: this.classes.highlight, node: e, pattern: c }),
                  a(e)
                );
              },
              _getFooter: function (a, b) {
                return this.templates.footer
                  ? this.templates.footer({ query: a, suggestions: b, dataset: this.name })
                  : null;
              },
              _getHeader: function (a, b) {
                return this.templates.header
                  ? this.templates.header({ query: a, suggestions: b, dataset: this.name })
                  : null;
              },
              _resetLastSuggestion: function () {
                this.$lastSuggestion = a();
              },
              _injectQuery: function (a, c) {
                return b.isObject(c) ? b.mixin({ _query: a }, c) : c;
              },
              update: function (b) {
                function c(a) {
                  g ||
                    ((g = !0),
                    (a = (a || []).slice(0, e.limit)),
                    (h = a.length),
                    e._overwrite(b, a),
                    h < e.limit && e.async && e.trigger("asyncRequested", b));
                }
                function d(c) {
                  (c = c || []),
                    !f &&
                      h < e.limit &&
                      ((e.cancel = a.noop),
                      (h += c.length),
                      e._append(b, c.slice(0, e.limit - h)),
                      e.async && e.trigger("asyncReceived", b));
                }
                var e = this,
                  f = !1,
                  g = !1,
                  h = 0;
                this.cancel(),
                  (this.cancel = function () {
                    (f = !0), (e.cancel = a.noop), e.async && e.trigger("asyncCanceled", b);
                  }),
                  this.source(b, c, d),
                  !g && c([]);
              },
              cancel: a.noop,
              clear: function () {
                this._empty(), this.cancel(), this.trigger("cleared");
              },
              isEmpty: function () {
                return this.$el.is(":empty");
              },
              destroy: function () {
                this.$el = a("<div>");
              },
            }),
            c
          );
        })(),
        i = (function () {
          "use strict";
          function c(c, d) {
            function e(b) {
              var c = f.$node.find(b.node).first();
              return (b.node = c.length ? c : a("<div>").appendTo(f.$node)), new h(b, d);
            }
            var f = this;
            (c = c || {}),
              c.node || a.error("node is required"),
              d.mixin(this),
              (this.$node = a(c.node)),
              (this.query = null),
              (this.datasets = b.map(c.datasets, e));
          }
          return (
            b.mixin(c.prototype, e, {
              _onSelectableClick: function (b) {
                this.trigger("selectableClicked", a(b.currentTarget));
              },
              _onRendered: function (a, b, c, d) {
                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty()),
                  this.trigger("datasetRendered", b, c, d);
              },
              _onCleared: function () {
                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty()), this.trigger("datasetCleared");
              },
              _propagate: function () {
                this.trigger.apply(this, arguments);
              },
              _allDatasetsEmpty: function () {
                function a(a) {
                  return a.isEmpty();
                }
                return b.every(this.datasets, a);
              },
              _getSelectables: function () {
                return this.$node.find(this.selectors.selectable);
              },
              _removeCursor: function () {
                var a = this.getActiveSelectable();
                a && a.removeClass(this.classes.cursor);
              },
              _ensureVisible: function (a) {
                var b, c, d, e;
                (b = a.position().top),
                  (c = b + a.outerHeight(!0)),
                  (d = this.$node.scrollTop()),
                  (e =
                    this.$node.height() +
                    parseInt(this.$node.css("paddingTop"), 10) +
                    parseInt(this.$node.css("paddingBottom"), 10)),
                  0 > b ? this.$node.scrollTop(d + b) : c > e && this.$node.scrollTop(d + (c - e));
              },
              bind: function () {
                var a,
                  c = this;
                return (
                  (a = b.bind(this._onSelectableClick, this)),
                  this.$node.on("click.tt", this.selectors.selectable, a),
                  b.each(this.datasets, function (a) {
                    a.onSync("asyncRequested", c._propagate, c)
                      .onSync("asyncCanceled", c._propagate, c)
                      .onSync("asyncReceived", c._propagate, c)
                      .onSync("rendered", c._onRendered, c)
                      .onSync("cleared", c._onCleared, c);
                  }),
                  this
                );
              },
              isOpen: function () {
                return this.$node.hasClass(this.classes.open);
              },
              open: function () {
                this.$node.addClass(this.classes.open);
              },
              close: function () {
                this.$node.removeClass(this.classes.open), this._removeCursor();
              },
              setLanguageDirection: function (a) {
                this.$node.attr("dir", a);
              },
              selectableRelativeToCursor: function (a) {
                var b, c, d, e;
                return (
                  (c = this.getActiveSelectable()),
                  (b = this._getSelectables()),
                  (d = c ? b.index(c) : -1),
                  (e = d + a),
                  (e = ((e + 1) % (b.length + 1)) - 1),
                  (e = -1 > e ? b.length - 1 : e),
                  -1 === e ? null : b.eq(e)
                );
              },
              setCursor: function (a) {
                this._removeCursor(), (a = a && a.first()) && (a.addClass(this.classes.cursor), this._ensureVisible(a));
              },
              getSelectableData: function (a) {
                return a && a.length ? h.extractData(a) : null;
              },
              getActiveSelectable: function () {
                var a = this._getSelectables().filter(this.selectors.cursor).first();
                return a.length ? a : null;
              },
              getTopSelectable: function () {
                var a = this._getSelectables().first();
                return a.length ? a : null;
              },
              update: function (a) {
                function c(b) {
                  b.update(a);
                }
                var d = a !== this.query;
                return d && ((this.query = a), b.each(this.datasets, c)), d;
              },
              empty: function () {
                function a(a) {
                  a.clear();
                }
                b.each(this.datasets, a), (this.query = null), this.$node.addClass(this.classes.empty);
              },
              destroy: function () {
                function c(a) {
                  a.destroy();
                }
                this.$node.off(".tt"), (this.$node = a("<div>")), b.each(this.datasets, c);
              },
            }),
            c
          );
        })(),
        j = (function () {
          "use strict";
          function a() {
            i.apply(this, [].slice.call(arguments, 0));
          }
          var c = i.prototype;
          return (
            b.mixin(a.prototype, i.prototype, {
              open: function () {
                return !this._allDatasetsEmpty() && this._show(), c.open.apply(this, [].slice.call(arguments, 0));
              },
              close: function () {
                return this._hide(), c.close.apply(this, [].slice.call(arguments, 0));
              },
              _onRendered: function () {
                return (
                  this._allDatasetsEmpty() ? this._hide() : this.isOpen() && this._show(),
                  c._onRendered.apply(this, [].slice.call(arguments, 0))
                );
              },
              _onCleared: function () {
                return (
                  this._allDatasetsEmpty() ? this._hide() : this.isOpen() && this._show(),
                  c._onCleared.apply(this, [].slice.call(arguments, 0))
                );
              },
              setLanguageDirection: function (a) {
                return (
                  this.$node.css("ltr" === a ? this.css.ltr : this.css.rtl),
                  c.setLanguageDirection.apply(this, [].slice.call(arguments, 0))
                );
              },
              _hide: function () {
                this.$node.hide();
              },
              _show: function () {
                this.$node.css("display", "block");
              },
            }),
            a
          );
        })(),
        k = (function () {
          "use strict";
          function c(c, e) {
            var f, g, h, i, j, k, l, m, n, o, p;
            (c = c || {}),
              c.input || a.error("missing input"),
              c.menu || a.error("missing menu"),
              c.eventBus || a.error("missing event bus"),
              e.mixin(this),
              (this.eventBus = c.eventBus),
              (this.minLength = b.isNumber(c.minLength) ? c.minLength : 1),
              (this.input = c.input),
              (this.menu = c.menu),
              (this.enabled = !0),
              (this.active = !1),
              this.input.hasFocus() && this.activate(),
              (this.dir = this.input.getLangDir()),
              this._hacks(),
              this.menu
                .bind()
                .onSync("selectableClicked", this._onSelectableClicked, this)
                .onSync("asyncRequested", this._onAsyncRequested, this)
                .onSync("asyncCanceled", this._onAsyncCanceled, this)
                .onSync("asyncReceived", this._onAsyncReceived, this)
                .onSync("datasetRendered", this._onDatasetRendered, this)
                .onSync("datasetCleared", this._onDatasetCleared, this),
              (f = d(this, "activate", "open", "_onFocused")),
              (g = d(this, "deactivate", "_onBlurred")),
              (h = d(this, "isActive", "isOpen", "_onEnterKeyed")),
              (i = d(this, "isActive", "isOpen", "_onTabKeyed")),
              (j = d(this, "isActive", "_onEscKeyed")),
              (k = d(this, "isActive", "open", "_onUpKeyed")),
              (l = d(this, "isActive", "open", "_onDownKeyed")),
              (m = d(this, "isActive", "isOpen", "_onLeftKeyed")),
              (n = d(this, "isActive", "isOpen", "_onRightKeyed")),
              (o = d(this, "_openIfActive", "_onQueryChanged")),
              (p = d(this, "_openIfActive", "_onWhitespaceChanged")),
              this.input
                .bind()
                .onSync("focused", f, this)
                .onSync("blurred", g, this)
                .onSync("enterKeyed", h, this)
                .onSync("tabKeyed", i, this)
                .onSync("escKeyed", j, this)
                .onSync("upKeyed", k, this)
                .onSync("downKeyed", l, this)
                .onSync("leftKeyed", m, this)
                .onSync("rightKeyed", n, this)
                .onSync("queryChanged", o, this)
                .onSync("whitespaceChanged", p, this)
                .onSync("langDirChanged", this._onLangDirChanged, this);
          }
          function d(a) {
            var c = [].slice.call(arguments, 1);
            return function () {
              var d = [].slice.call(arguments);
              b.each(c, function (b) {
                return a[b].apply(a, d);
              });
            };
          }
          return (
            b.mixin(c.prototype, {
              _hacks: function () {
                var c, d;
                (c = this.input.$input || a("<div>")),
                  (d = this.menu.$node || a("<div>")),
                  c.on("blur.tt", function (a) {
                    var e, f, g;
                    (e = document.activeElement),
                      (f = d.is(e)),
                      (g = d.has(e).length > 0),
                      b.isMsie() &&
                        (f || g) &&
                        (a.preventDefault(),
                        a.stopImmediatePropagation(),
                        b.defer(function () {
                          c.focus();
                        }));
                  }),
                  d.on("mousedown.tt", function (a) {
                    a.preventDefault();
                  });
              },
              _onSelectableClicked: function (a, b) {
                this.select(b);
              },
              _onDatasetCleared: function () {
                this._updateHint();
              },
              _onDatasetRendered: function (a, b, c, d) {
                this._updateHint(), this.eventBus.trigger("render", c, d, b);
              },
              _onAsyncRequested: function (a, b, c) {
                this.eventBus.trigger("asyncrequest", c, b);
              },
              _onAsyncCanceled: function (a, b, c) {
                this.eventBus.trigger("asynccancel", c, b);
              },
              _onAsyncReceived: function (a, b, c) {
                this.eventBus.trigger("asyncreceive", c, b);
              },
              _onFocused: function () {
                this._minLengthMet() && this.menu.update(this.input.getQuery());
              },
              _onBlurred: function () {
                this.input.hasQueryChangedSinceLastFocus() && this.eventBus.trigger("change", this.input.getQuery());
              },
              _onEnterKeyed: function (a, b) {
                var c;
                (c = this.menu.getActiveSelectable()) && this.select(c) && b.preventDefault();
              },
              _onTabKeyed: function (a, b) {
                var c;
                (c = this.menu.getActiveSelectable())
                  ? this.select(c) && b.preventDefault()
                  : (c = this.menu.getTopSelectable()) && this.autocomplete(c) && b.preventDefault();
              },
              _onEscKeyed: function () {
                this.close();
              },
              _onUpKeyed: function () {
                this.moveCursor(-1);
              },
              _onDownKeyed: function () {
                this.moveCursor(1);
              },
              _onLeftKeyed: function () {
                "rtl" === this.dir && this.input.isCursorAtEnd() && this.autocomplete(this.menu.getTopSelectable());
              },
              _onRightKeyed: function () {
                "ltr" === this.dir && this.input.isCursorAtEnd() && this.autocomplete(this.menu.getTopSelectable());
              },
              _onQueryChanged: function (a, b) {
                this._minLengthMet(b) ? this.menu.update(b) : this.menu.empty();
              },
              _onWhitespaceChanged: function () {
                this._updateHint();
              },
              _onLangDirChanged: function (a, b) {
                this.dir !== b && ((this.dir = b), this.menu.setLanguageDirection(b));
              },
              _openIfActive: function () {
                this.isActive() && this.open();
              },
              _minLengthMet: function (a) {
                return (a = b.isString(a) ? a : this.input.getQuery() || ""), a.length >= this.minLength;
              },
              _updateHint: function () {
                var a, c, d, e, f, h, i;
                (a = this.menu.getTopSelectable()),
                  (c = this.menu.getSelectableData(a)),
                  (d = this.input.getInputValue()),
                  !c || b.isBlankString(d) || this.input.hasOverflow()
                    ? this.input.clearHint()
                    : ((e = g.normalizeQuery(d)),
                      (f = b.escapeRegExChars(e)),
                      (h = new RegExp("^(?:" + f + ")(.+$)", "i")),
                      (i = h.exec(c.val)),
                      i && this.input.setHint(d + i[1]));
              },
              isEnabled: function () {
                return this.enabled;
              },
              enable: function () {
                this.enabled = !0;
              },
              disable: function () {
                this.enabled = !1;
              },
              isActive: function () {
                return this.active;
              },
              activate: function () {
                return this.isActive()
                  ? !0
                  : !this.isEnabled() || this.eventBus.before("active")
                  ? !1
                  : ((this.active = !0), this.eventBus.trigger("active"), !0);
              },
              deactivate: function () {
                return this.isActive()
                  ? this.eventBus.before("idle")
                    ? !1
                    : ((this.active = !1), this.close(), this.eventBus.trigger("idle"), !0)
                  : !0;
              },
              isOpen: function () {
                return this.menu.isOpen();
              },
              open: function () {
                return (
                  this.isOpen() ||
                    this.eventBus.before("open") ||
                    (this.menu.open(), this._updateHint(), this.eventBus.trigger("open")),
                  this.isOpen()
                );
              },
              close: function () {
                return (
                  this.isOpen() &&
                    !this.eventBus.before("close") &&
                    (this.menu.close(),
                    this.input.clearHint(),
                    this.input.resetInputValue(),
                    this.eventBus.trigger("close")),
                  !this.isOpen()
                );
              },
              setVal: function (a) {
                this.input.setQuery(b.toStr(a));
              },
              getVal: function () {
                return this.input.getQuery();
              },
              select: function (a) {
                var b = this.menu.getSelectableData(a);
                return b && !this.eventBus.before("select", b.obj)
                  ? (this.input.setQuery(b.val, !0), this.eventBus.trigger("select", b.obj), this.close(), !0)
                  : !1;
              },
              autocomplete: function (a) {
                var b, c, d;
                return (
                  (b = this.input.getQuery()),
                  (c = this.menu.getSelectableData(a)),
                  (d = c && b !== c.val),
                  d && !this.eventBus.before("autocomplete", c.obj)
                    ? (this.input.setQuery(c.val), this.eventBus.trigger("autocomplete", c.obj), !0)
                    : !1
                );
              },
              moveCursor: function (a) {
                var b, c, d, e, f;
                return (
                  (b = this.input.getQuery()),
                  (c = this.menu.selectableRelativeToCursor(a)),
                  (d = this.menu.getSelectableData(c)),
                  (e = d ? d.obj : null),
                  (f = this._minLengthMet() && this.menu.update(b)),
                  f || this.eventBus.before("cursorchange", e)
                    ? !1
                    : (this.menu.setCursor(c),
                      d ? this.input.setInputValue(d.val) : (this.input.resetInputValue(), this._updateHint()),
                      this.eventBus.trigger("cursorchange", e),
                      !0)
                );
              },
              destroy: function () {
                this.input.destroy(), this.menu.destroy();
              },
            }),
            c
          );
        })();
      !(function () {
        "use strict";
        function e(b, c) {
          b.each(function () {
            var b,
              d = a(this);
            (b = d.data(p.typeahead)) && c(b, d);
          });
        }
        function f(a, b) {
          return a
            .clone()
            .addClass(b.classes.hint)
            .removeData()
            .css(b.css.hint)
            .css(l(a))
            .prop("readonly", !0)
            .removeAttr("id name placeholder required")
            .attr({ autocomplete: "off", spellcheck: "false", tabindex: -1 });
        }
        function h(a, b) {
          a.data(p.attrs, {
            dir: a.attr("dir"),
            autocomplete: a.attr("autocomplete"),
            spellcheck: a.attr("spellcheck"),
            style: a.attr("style"),
          }),
            a.addClass(b.classes.input).attr({ autocomplete: "off", spellcheck: !1 });
          try {
            !a.attr("dir") && a.attr("dir", "auto");
          } catch (c) {}
          return a;
        }
        function l(a) {
          return {
            backgroundAttachment: a.css("background-attachment"),
            backgroundClip: a.css("background-clip"),
            backgroundColor: a.css("background-color"),
            backgroundImage: a.css("background-image"),
            backgroundOrigin: a.css("background-origin"),
            backgroundPosition: a.css("background-position"),
            backgroundRepeat: a.css("background-repeat"),
            backgroundSize: a.css("background-size"),
          };
        }
        function m(a) {
          var c, d;
          (c = a.data(p.www)),
            (d = a.parent().filter(c.selectors.wrapper)),
            b.each(a.data(p.attrs), function (c, d) {
              b.isUndefined(c) ? a.removeAttr(d) : a.attr(d, c);
            }),
            a.removeData(p.typeahead).removeData(p.www).removeData(p.attr).removeClass(c.classes.input),
            d.length && (a.detach().insertAfter(d), d.remove());
        }
        function n(c) {
          var d, e;
          return (d = b.isJQuery(c) || b.isElement(c)), (e = d ? a(c).first() : []), e.length ? e : null;
        }
        var o, p, q;
        (o = a.fn.typeahead),
          (p = { www: "tt-www", attrs: "tt-attrs", typeahead: "tt-typeahead" }),
          (q = {
            initialize: function (e, l) {
              function m() {
                var c, m, q, r, s, t, u, v, w, x, y;
                b.each(l, function (a) {
                  a.highlight = !!e.highlight;
                }),
                  (c = a(this)),
                  (m = a(o.html.wrapper)),
                  (q = n(e.hint)),
                  (r = n(e.menu)),
                  (s = e.hint !== !1 && !q),
                  (t = e.menu !== !1 && !r),
                  s && (q = f(c, o)),
                  t && (r = a(o.html.menu).css(o.css.menu)),
                  q && q.val(""),
                  (c = h(c, o)),
                  (s || t) &&
                    (m.css(o.css.wrapper),
                    c.css(s ? o.css.input : o.css.inputWithNoHint),
                    c
                      .wrap(m)
                      .parent()
                      .prepend(s ? q : null)
                      .append(t ? r : null)),
                  (y = t ? j : i),
                  (u = new d({ el: c })),
                  (v = new g({ hint: q, input: c }, o)),
                  (w = new y({ node: r, datasets: l }, o)),
                  (x = new k({ input: v, menu: w, eventBus: u, minLength: e.minLength }, o)),
                  c.data(p.www, o),
                  c.data(p.typeahead, x);
              }
              var o;
              return (
                (l = b.isArray(l) ? l : [].slice.call(arguments, 1)), (e = e || {}), (o = c(e.classNames)), this.each(m)
              );
            },
            isEnabled: function () {
              var a;
              return (
                e(this.first(), function (b) {
                  a = b.isEnabled();
                }),
                a
              );
            },
            enable: function () {
              return (
                e(this, function (a) {
                  a.enable();
                }),
                this
              );
            },
            disable: function () {
              return (
                e(this, function (a) {
                  a.disable();
                }),
                this
              );
            },
            isActive: function () {
              var a;
              return (
                e(this.first(), function (b) {
                  a = b.isActive();
                }),
                a
              );
            },
            activate: function () {
              return (
                e(this, function (a) {
                  a.activate();
                }),
                this
              );
            },
            deactivate: function () {
              return (
                e(this, function (a) {
                  a.deactivate();
                }),
                this
              );
            },
            isOpen: function () {
              var a;
              return (
                e(this.first(), function (b) {
                  a = b.isOpen();
                }),
                a
              );
            },
            open: function () {
              return (
                e(this, function (a) {
                  a.open();
                }),
                this
              );
            },
            close: function () {
              return (
                e(this, function (a) {
                  a.close();
                }),
                this
              );
            },
            select: function (b) {
              var c = !1,
                d = a(b);
              return (
                e(this.first(), function (a) {
                  c = a.select(d);
                }),
                c
              );
            },
            autocomplete: function (b) {
              var c = !1,
                d = a(b);
              return (
                e(this.first(), function (a) {
                  c = a.autocomplete(d);
                }),
                c
              );
            },
            moveCursor: function (a) {
              var b = !1;
              return (
                e(this.first(), function (c) {
                  b = c.moveCursor(a);
                }),
                b
              );
            },
            val: function (a) {
              var b;
              return arguments.length
                ? (e(this, function (b) {
                    b.setVal(a);
                  }),
                  this)
                : (e(this.first(), function (a) {
                    b = a.getVal();
                  }),
                  b);
            },
            destroy: function () {
              return (
                e(this, function (a, b) {
                  m(b), a.destroy();
                }),
                this
              );
            },
          }),
          (a.fn.typeahead = function (a) {
            return q[a] ? q[a].apply(this, [].slice.call(arguments, 1)) : q.initialize.apply(this, arguments);
          }),
          (a.fn.typeahead.noConflict = function () {
            return (a.fn.typeahead = o), this;
          });
      })();
    });

  /*!
   * Packery PACKAGED v2.1.2
   * Gapless, draggable grid layouts
   *
   * Licensed GPLv3 for open source use
   * or Packery Commercial License for commercial use
   *
   * http://packery.metafizzy.co
   * Copyright 2013-2018 Metafizzy
   */
  !(function (t, e) {
    "function" == typeof define && define.amd
      ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) {
          return e(t, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("jquery")))
      : (t.jQueryBridget = e(t, t.jQuery));
  })(window, function (t, e) {
    "use strict";
    function i(i, s, a) {
      function h(t, e, n) {
        var o,
          s = "$()." + i + '("' + e + '")';
        return (
          t.each(function (t, h) {
            var u = a.data(h, i);
            if (!u) return void r(i + " not initialized. Cannot call methods, i.e. " + s);
            var c = u[e];
            if (!c || "_" == e.charAt(0)) return void r(s + " is not a valid method");
            var d = c.apply(u, n);
            o = void 0 === o ? d : o;
          }),
          void 0 !== o ? o : t
        );
      }
      function u(t, e) {
        t.each(function (t, n) {
          var o = a.data(n, i);
          o ? (o.option(e), o._init()) : ((o = new s(n, e)), a.data(n, i, o));
        });
      }
      (a = a || e || t.jQuery),
        a &&
          (s.prototype.option ||
            (s.prototype.option = function (t) {
              a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t));
            }),
          (a.fn[i] = function (t) {
            if ("string" == typeof t) {
              var e = o.call(arguments, 1);
              return h(this, t, e);
            }
            return u(this, t), this;
          }),
          n(a));
    }
    function n(t) {
      !t || (t && t.bridget) || (t.bridget = i);
    }
    var o = Array.prototype.slice,
      s = t.console,
      r =
        "undefined" == typeof s
          ? function () {}
          : function (t) {
              s.error(t);
            };
    return n(e || t.jQuery), i;
  }),
    (function (t, e) {
      "function" == typeof define && define.amd
        ? define("get-size/get-size", e)
        : "object" == typeof module && module.exports
        ? (module.exports = e())
        : (t.getSize = e());
    })(window, function () {
      "use strict";
      function t(t) {
        var e = parseFloat(t),
          i = -1 == t.indexOf("%") && !isNaN(e);
        return i && e;
      }
      function e() {}
      function i() {
        for (
          var t = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, e = 0;
          u > e;
          e++
        ) {
          var i = h[e];
          t[i] = 0;
        }
        return t;
      }
      function n(t) {
        var e = getComputedStyle(t);
        return (
          e ||
            a(
              "Style returned " +
                e +
                ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
            ),
          e
        );
      }
      function o() {
        if (!c) {
          c = !0;
          var e = document.createElement("div");
          (e.style.width = "200px"),
            (e.style.padding = "1px 2px 3px 4px"),
            (e.style.borderStyle = "solid"),
            (e.style.borderWidth = "1px 2px 3px 4px"),
            (e.style.boxSizing = "border-box");
          var i = document.body || document.documentElement;
          i.appendChild(e);
          var o = n(e);
          (r = 200 == Math.round(t(o.width))), (s.isBoxSizeOuter = r), i.removeChild(e);
        }
      }
      function s(e) {
        if ((o(), "string" == typeof e && (e = document.querySelector(e)), e && "object" == typeof e && e.nodeType)) {
          var s = n(e);
          if ("none" == s.display) return i();
          var a = {};
          (a.width = e.offsetWidth), (a.height = e.offsetHeight);
          for (var c = (a.isBorderBox = "border-box" == s.boxSizing), d = 0; u > d; d++) {
            var l = h[d],
              f = s[l],
              p = parseFloat(f);
            a[l] = isNaN(p) ? 0 : p;
          }
          var g = a.paddingLeft + a.paddingRight,
            m = a.paddingTop + a.paddingBottom,
            y = a.marginLeft + a.marginRight,
            v = a.marginTop + a.marginBottom,
            _ = a.borderLeftWidth + a.borderRightWidth,
            x = a.borderTopWidth + a.borderBottomWidth,
            b = c && r,
            E = t(s.width);
          E !== !1 && (a.width = E + (b ? 0 : g + _));
          var w = t(s.height);
          return (
            w !== !1 && (a.height = w + (b ? 0 : m + x)),
            (a.innerWidth = a.width - (g + _)),
            (a.innerHeight = a.height - (m + x)),
            (a.outerWidth = a.width + y),
            (a.outerHeight = a.height + v),
            a
          );
        }
      }
      var r,
        a =
          "undefined" == typeof console
            ? e
            : function (t) {
                console.error(t);
              },
        h = [
          "paddingLeft",
          "paddingRight",
          "paddingTop",
          "paddingBottom",
          "marginLeft",
          "marginRight",
          "marginTop",
          "marginBottom",
          "borderLeftWidth",
          "borderRightWidth",
          "borderTopWidth",
          "borderBottomWidth",
        ],
        u = h.length,
        c = !1;
      return s;
    }),
    (function (t, e) {
      "function" == typeof define && define.amd
        ? define("ev-emitter/ev-emitter", e)
        : "object" == typeof module && module.exports
        ? (module.exports = e())
        : (t.EvEmitter = e());
    })("undefined" != typeof window ? window : this, function () {
      function t() {}
      var e = t.prototype;
      return (
        (e.on = function (t, e) {
          if (t && e) {
            var i = (this._events = this._events || {}),
              n = (i[t] = i[t] || []);
            return -1 == n.indexOf(e) && n.push(e), this;
          }
        }),
        (e.once = function (t, e) {
          if (t && e) {
            this.on(t, e);
            var i = (this._onceEvents = this._onceEvents || {}),
              n = (i[t] = i[t] || {});
            return (n[e] = !0), this;
          }
        }),
        (e.off = function (t, e) {
          var i = this._events && this._events[t];
          if (i && i.length) {
            var n = i.indexOf(e);
            return -1 != n && i.splice(n, 1), this;
          }
        }),
        (e.emitEvent = function (t, e) {
          var i = this._events && this._events[t];
          if (i && i.length) {
            (i = i.slice(0)), (e = e || []);
            for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
              var s = i[o],
                r = n && n[s];
              r && (this.off(t, s), delete n[s]), s.apply(this, e);
            }
            return this;
          }
        }),
        (e.allOff = function () {
          delete this._events, delete this._onceEvents;
        }),
        t
      );
    }),
    (function (t, e) {
      "use strict";
      "function" == typeof define && define.amd
        ? define("desandro-matches-selector/matches-selector", e)
        : "object" == typeof module && module.exports
        ? (module.exports = e())
        : (t.matchesSelector = e());
    })(window, function () {
      "use strict";
      var t = (function () {
        var t = window.Element.prototype;
        if (t.matches) return "matches";
        if (t.matchesSelector) return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
          var n = e[i],
            o = n + "MatchesSelector";
          if (t[o]) return o;
        }
      })();
      return function (e, i) {
        return e[t](i);
      };
    }),
    (function (t, e) {
      "function" == typeof define && define.amd
        ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (i) {
            return e(t, i);
          })
        : "object" == typeof module && module.exports
        ? (module.exports = e(t, require("desandro-matches-selector")))
        : (t.fizzyUIUtils = e(t, t.matchesSelector));
    })(window, function (t, e) {
      var i = {};
      (i.extend = function (t, e) {
        for (var i in e) t[i] = e[i];
        return t;
      }),
        (i.modulo = function (t, e) {
          return ((t % e) + e) % e;
        });
      var n = Array.prototype.slice;
      (i.makeArray = function (t) {
        if (Array.isArray(t)) return t;
        if (null === t || void 0 === t) return [];
        var e = "object" == typeof t && "number" == typeof t.length;
        return e ? n.call(t) : [t];
      }),
        (i.removeFrom = function (t, e) {
          var i = t.indexOf(e);
          -1 != i && t.splice(i, 1);
        }),
        (i.getParent = function (t, i) {
          for (; t.parentNode && t != document.body; ) if (((t = t.parentNode), e(t, i))) return t;
        }),
        (i.getQueryElement = function (t) {
          return "string" == typeof t ? document.querySelector(t) : t;
        }),
        (i.handleEvent = function (t) {
          var e = "on" + t.type;
          this[e] && this[e](t);
        }),
        (i.filterFindElements = function (t, n) {
          t = i.makeArray(t);
          var o = [];
          return (
            t.forEach(function (t) {
              if (t instanceof HTMLElement) {
                if (!n) return void o.push(t);
                e(t, n) && o.push(t);
                for (var i = t.querySelectorAll(n), s = 0; s < i.length; s++) o.push(i[s]);
              }
            }),
            o
          );
        }),
        (i.debounceMethod = function (t, e, i) {
          i = i || 100;
          var n = t.prototype[e],
            o = e + "Timeout";
          t.prototype[e] = function () {
            var t = this[o];
            clearTimeout(t);
            var e = arguments,
              s = this;
            this[o] = setTimeout(function () {
              n.apply(s, e), delete s[o];
            }, i);
          };
        }),
        (i.docReady = function (t) {
          var e = document.readyState;
          "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t);
        }),
        (i.toDashed = function (t) {
          return t
            .replace(/(.)([A-Z])/g, function (t, e, i) {
              return e + "-" + i;
            })
            .toLowerCase();
        });
      var o = t.console;
      return (
        (i.htmlInit = function (e, n) {
          i.docReady(function () {
            var s = i.toDashed(n),
              r = "data-" + s,
              a = document.querySelectorAll("[" + r + "]"),
              h = document.querySelectorAll(".js-" + s),
              u = i.makeArray(a).concat(i.makeArray(h)),
              c = r + "-options",
              d = t.jQuery;
            u.forEach(function (t) {
              var i,
                s = t.getAttribute(r) || t.getAttribute(c);
              try {
                i = s && JSON.parse(s);
              } catch (a) {
                return void (o && o.error("Error parsing " + r + " on " + t.className + ": " + a));
              }
              var h = new e(t, i);
              d && d.data(t, n, h);
            });
          });
        }),
        i
      );
    }),
    (function (t, e) {
      "function" == typeof define && define.amd
        ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e)
        : "object" == typeof module && module.exports
        ? (module.exports = e(require("ev-emitter"), require("get-size")))
        : ((t.Outlayer = {}), (t.Outlayer.Item = e(t.EvEmitter, t.getSize)));
    })(window, function (t, e) {
      "use strict";
      function i(t) {
        for (var e in t) return !1;
        return (e = null), !0;
      }
      function n(t, e) {
        t && ((this.element = t), (this.layout = e), (this.position = { x: 0, y: 0 }), this._create());
      }
      function o(t) {
        return t.replace(/([A-Z])/g, function (t) {
          return "-" + t.toLowerCase();
        });
      }
      var s = document.documentElement.style,
        r = "string" == typeof s.transition ? "transition" : "WebkitTransition",
        a = "string" == typeof s.transform ? "transform" : "WebkitTransform",
        h = { WebkitTransition: "webkitTransitionEnd", transition: "transitionend" }[r],
        u = {
          transform: a,
          transition: r,
          transitionDuration: r + "Duration",
          transitionProperty: r + "Property",
          transitionDelay: r + "Delay",
        },
        c = (n.prototype = Object.create(t.prototype));
      (c.constructor = n),
        (c._create = function () {
          (this._transn = { ingProperties: {}, clean: {}, onEnd: {} }), this.css({ position: "absolute" });
        }),
        (c.handleEvent = function (t) {
          var e = "on" + t.type;
          this[e] && this[e](t);
        }),
        (c.getSize = function () {
          this.size = e(this.element);
        }),
        (c.css = function (t) {
          var e = this.element.style;
          for (var i in t) {
            var n = u[i] || i;
            e[n] = t[i];
          }
        }),
        (c.getPosition = function () {
          var t = getComputedStyle(this.element),
            e = this.layout._getOption("originLeft"),
            i = this.layout._getOption("originTop"),
            n = t[e ? "left" : "right"],
            o = t[i ? "top" : "bottom"],
            s = parseFloat(n),
            r = parseFloat(o),
            a = this.layout.size;
          -1 != n.indexOf("%") && (s = (s / 100) * a.width),
            -1 != o.indexOf("%") && (r = (r / 100) * a.height),
            (s = isNaN(s) ? 0 : s),
            (r = isNaN(r) ? 0 : r),
            (s -= e ? a.paddingLeft : a.paddingRight),
            (r -= i ? a.paddingTop : a.paddingBottom),
            (this.position.x = s),
            (this.position.y = r);
        }),
        (c.layoutPosition = function () {
          var t = this.layout.size,
            e = {},
            i = this.layout._getOption("originLeft"),
            n = this.layout._getOption("originTop"),
            o = i ? "paddingLeft" : "paddingRight",
            s = i ? "left" : "right",
            r = i ? "right" : "left",
            a = this.position.x + t[o];
          (e[s] = this.getXValue(a)), (e[r] = "");
          var h = n ? "paddingTop" : "paddingBottom",
            u = n ? "top" : "bottom",
            c = n ? "bottom" : "top",
            d = this.position.y + t[h];
          (e[u] = this.getYValue(d)), (e[c] = ""), this.css(e), this.emitEvent("layout", [this]);
        }),
        (c.getXValue = function (t) {
          var e = this.layout._getOption("horizontal");
          return this.layout.options.percentPosition && !e ? (t / this.layout.size.width) * 100 + "%" : t + "px";
        }),
        (c.getYValue = function (t) {
          var e = this.layout._getOption("horizontal");
          return this.layout.options.percentPosition && e ? (t / this.layout.size.height) * 100 + "%" : t + "px";
        }),
        (c._transitionTo = function (t, e) {
          this.getPosition();
          var i = this.position.x,
            n = this.position.y,
            o = t == this.position.x && e == this.position.y;
          if ((this.setPosition(t, e), o && !this.isTransitioning)) return void this.layoutPosition();
          var s = t - i,
            r = e - n,
            a = {};
          (a.transform = this.getTranslate(s, r)),
            this.transition({ to: a, onTransitionEnd: { transform: this.layoutPosition }, isCleaning: !0 });
        }),
        (c.getTranslate = function (t, e) {
          var i = this.layout._getOption("originLeft"),
            n = this.layout._getOption("originTop");
          return (t = i ? t : -t), (e = n ? e : -e), "translate3d(" + t + "px, " + e + "px, 0)";
        }),
        (c.goTo = function (t, e) {
          this.setPosition(t, e), this.layoutPosition();
        }),
        (c.moveTo = c._transitionTo),
        (c.setPosition = function (t, e) {
          (this.position.x = parseFloat(t)), (this.position.y = parseFloat(e));
        }),
        (c._nonTransition = function (t) {
          this.css(t.to), t.isCleaning && this._removeStyles(t.to);
          for (var e in t.onTransitionEnd) t.onTransitionEnd[e].call(this);
        }),
        (c.transition = function (t) {
          if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(t);
          var e = this._transn;
          for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
          for (i in t.to) (e.ingProperties[i] = !0), t.isCleaning && (e.clean[i] = !0);
          if (t.from) {
            this.css(t.from);
            var n = this.element.offsetHeight;
            n = null;
          }
          this.enableTransition(t.to), this.css(t.to), (this.isTransitioning = !0);
        });
      var d = "opacity," + o(a);
      (c.enableTransition = function () {
        if (!this.isTransitioning) {
          var t = this.layout.options.transitionDuration;
          (t = "number" == typeof t ? t + "ms" : t),
            this.css({ transitionProperty: d, transitionDuration: t, transitionDelay: this.staggerDelay || 0 }),
            this.element.addEventListener(h, this, !1);
        }
      }),
        (c.onwebkitTransitionEnd = function (t) {
          this.ontransitionend(t);
        }),
        (c.onotransitionend = function (t) {
          this.ontransitionend(t);
        });
      var l = { "-webkit-transform": "transform" };
      (c.ontransitionend = function (t) {
        if (t.target === this.element) {
          var e = this._transn,
            n = l[t.propertyName] || t.propertyName;
          if (
            (delete e.ingProperties[n],
            i(e.ingProperties) && this.disableTransition(),
            n in e.clean && ((this.element.style[t.propertyName] = ""), delete e.clean[n]),
            n in e.onEnd)
          ) {
            var o = e.onEnd[n];
            o.call(this), delete e.onEnd[n];
          }
          this.emitEvent("transitionEnd", [this]);
        }
      }),
        (c.disableTransition = function () {
          this.removeTransitionStyles(), this.element.removeEventListener(h, this, !1), (this.isTransitioning = !1);
        }),
        (c._removeStyles = function (t) {
          var e = {};
          for (var i in t) e[i] = "";
          this.css(e);
        });
      var f = { transitionProperty: "", transitionDuration: "", transitionDelay: "" };
      return (
        (c.removeTransitionStyles = function () {
          this.css(f);
        }),
        (c.stagger = function (t) {
          (t = isNaN(t) ? 0 : t), (this.staggerDelay = t + "ms");
        }),
        (c.removeElem = function () {
          this.element.parentNode.removeChild(this.element),
            this.css({ display: "" }),
            this.emitEvent("remove", [this]);
        }),
        (c.remove = function () {
          return r && parseFloat(this.layout.options.transitionDuration)
            ? (this.once("transitionEnd", function () {
                this.removeElem();
              }),
              void this.hide())
            : void this.removeElem();
        }),
        (c.reveal = function () {
          delete this.isHidden, this.css({ display: "" });
          var t = this.layout.options,
            e = {},
            i = this.getHideRevealTransitionEndProperty("visibleStyle");
          (e[i] = this.onRevealTransitionEnd),
            this.transition({ from: t.hiddenStyle, to: t.visibleStyle, isCleaning: !0, onTransitionEnd: e });
        }),
        (c.onRevealTransitionEnd = function () {
          this.isHidden || this.emitEvent("reveal");
        }),
        (c.getHideRevealTransitionEndProperty = function (t) {
          var e = this.layout.options[t];
          if (e.opacity) return "opacity";
          for (var i in e) return i;
        }),
        (c.hide = function () {
          (this.isHidden = !0), this.css({ display: "" });
          var t = this.layout.options,
            e = {},
            i = this.getHideRevealTransitionEndProperty("hiddenStyle");
          (e[i] = this.onHideTransitionEnd),
            this.transition({ from: t.visibleStyle, to: t.hiddenStyle, isCleaning: !0, onTransitionEnd: e });
        }),
        (c.onHideTransitionEnd = function () {
          this.isHidden && (this.css({ display: "none" }), this.emitEvent("hide"));
        }),
        (c.destroy = function () {
          this.css({ position: "", left: "", right: "", top: "", bottom: "", transition: "", transform: "" });
        }),
        n
      );
    }),
    (function (t, e) {
      "use strict";
      "function" == typeof define && define.amd
        ? define(
            "outlayer/outlayer",
            ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"],
            function (i, n, o, s) {
              return e(t, i, n, o, s);
            }
          )
        : "object" == typeof module && module.exports
        ? (module.exports = e(
            t,
            require("ev-emitter"),
            require("get-size"),
            require("fizzy-ui-utils"),
            require("./item")
          ))
        : (t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item));
    })(window, function (t, e, i, n, o) {
      "use strict";
      function s(t, e) {
        var i = n.getQueryElement(t);
        if (!i) return void (h && h.error("Bad element for " + this.constructor.namespace + ": " + (i || t)));
        (this.element = i),
          u && (this.$element = u(this.element)),
          (this.options = n.extend({}, this.constructor.defaults)),
          this.option(e);
        var o = ++d;
        (this.element.outlayerGUID = o), (l[o] = this), this._create();
        var s = this._getOption("initLayout");
        s && this.layout();
      }
      function r(t) {
        function e() {
          t.apply(this, arguments);
        }
        return (e.prototype = Object.create(t.prototype)), (e.prototype.constructor = e), e;
      }
      function a(t) {
        if ("number" == typeof t) return t;
        var e = t.match(/(^\d*\.?\d*)(\w*)/),
          i = e && e[1],
          n = e && e[2];
        if (!i.length) return 0;
        i = parseFloat(i);
        var o = p[n] || 1;
        return i * o;
      }
      var h = t.console,
        u = t.jQuery,
        c = function () {},
        d = 0,
        l = {};
      (s.namespace = "outlayer"),
        (s.Item = o),
        (s.defaults = {
          containerStyle: { position: "relative" },
          initLayout: !0,
          originLeft: !0,
          originTop: !0,
          resize: !0,
          resizeContainer: !0,
          transitionDuration: "0.4s",
          hiddenStyle: { opacity: 0, transform: "scale(0.001)" },
          visibleStyle: { opacity: 1, transform: "scale(1)" },
        });
      var f = s.prototype;
      n.extend(f, e.prototype),
        (f.option = function (t) {
          n.extend(this.options, t);
        }),
        (f._getOption = function (t) {
          var e = this.constructor.compatOptions[t];
          return e && void 0 !== this.options[e] ? this.options[e] : this.options[t];
        }),
        (s.compatOptions = {
          initLayout: "isInitLayout",
          horizontal: "isHorizontal",
          layoutInstant: "isLayoutInstant",
          originLeft: "isOriginLeft",
          originTop: "isOriginTop",
          resize: "isResizeBound",
          resizeContainer: "isResizingContainer",
        }),
        (f._create = function () {
          this.reloadItems(),
            (this.stamps = []),
            this.stamp(this.options.stamp),
            n.extend(this.element.style, this.options.containerStyle);
          var t = this._getOption("resize");
          t && this.bindResize();
        }),
        (f.reloadItems = function () {
          this.items = this._itemize(this.element.children);
        }),
        (f._itemize = function (t) {
          for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], o = 0; o < e.length; o++) {
            var s = e[o],
              r = new i(s, this);
            n.push(r);
          }
          return n;
        }),
        (f._filterFindItemElements = function (t) {
          return n.filterFindElements(t, this.options.itemSelector);
        }),
        (f.getItemElements = function () {
          return this.items.map(function (t) {
            return t.element;
          });
        }),
        (f.layout = function () {
          this._resetLayout(), this._manageStamps();
          var t = this._getOption("layoutInstant"),
            e = void 0 !== t ? t : !this._isLayoutInited;
          this.layoutItems(this.items, e), (this._isLayoutInited = !0);
        }),
        (f._init = f.layout),
        (f._resetLayout = function () {
          this.getSize();
        }),
        (f.getSize = function () {
          this.size = i(this.element);
        }),
        (f._getMeasurement = function (t, e) {
          var n,
            o = this.options[t];
          o
            ? ("string" == typeof o ? (n = this.element.querySelector(o)) : o instanceof HTMLElement && (n = o),
              (this[t] = n ? i(n)[e] : o))
            : (this[t] = 0);
        }),
        (f.layoutItems = function (t, e) {
          (t = this._getItemsForLayout(t)), this._layoutItems(t, e), this._postLayout();
        }),
        (f._getItemsForLayout = function (t) {
          return t.filter(function (t) {
            return !t.isIgnored;
          });
        }),
        (f._layoutItems = function (t, e) {
          if ((this._emitCompleteOnItems("layout", t), t && t.length)) {
            var i = [];
            t.forEach(function (t) {
              var n = this._getItemLayoutPosition(t);
              (n.item = t), (n.isInstant = e || t.isLayoutInstant), i.push(n);
            }, this),
              this._processLayoutQueue(i);
          }
        }),
        (f._getItemLayoutPosition = function () {
          return { x: 0, y: 0 };
        }),
        (f._processLayoutQueue = function (t) {
          this.updateStagger(),
            t.forEach(function (t, e) {
              this._positionItem(t.item, t.x, t.y, t.isInstant, e);
            }, this);
        }),
        (f.updateStagger = function () {
          var t = this.options.stagger;
          return null === t || void 0 === t ? void (this.stagger = 0) : ((this.stagger = a(t)), this.stagger);
        }),
        (f._positionItem = function (t, e, i, n, o) {
          n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i));
        }),
        (f._postLayout = function () {
          this.resizeContainer();
        }),
        (f.resizeContainer = function () {
          var t = this._getOption("resizeContainer");
          if (t) {
            var e = this._getContainerSize();
            e && (this._setContainerMeasure(e.width, !0), this._setContainerMeasure(e.height, !1));
          }
        }),
        (f._getContainerSize = c),
        (f._setContainerMeasure = function (t, e) {
          if (void 0 !== t) {
            var i = this.size;
            i.isBorderBox &&
              (t += e
                ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth
                : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth),
              (t = Math.max(t, 0)),
              (this.element.style[e ? "width" : "height"] = t + "px");
          }
        }),
        (f._emitCompleteOnItems = function (t, e) {
          function i() {
            o.dispatchEvent(t + "Complete", null, [e]);
          }
          function n() {
            r++, r == s && i();
          }
          var o = this,
            s = e.length;
          if (!e || !s) return void i();
          var r = 0;
          e.forEach(function (e) {
            e.once(t, n);
          });
        }),
        (f.dispatchEvent = function (t, e, i) {
          var n = e ? [e].concat(i) : i;
          if ((this.emitEvent(t, n), u))
            if (((this.$element = this.$element || u(this.element)), e)) {
              var o = u.Event(e);
              (o.type = t), this.$element.trigger(o, i);
            } else this.$element.trigger(t, i);
        }),
        (f.ignore = function (t) {
          var e = this.getItem(t);
          e && (e.isIgnored = !0);
        }),
        (f.unignore = function (t) {
          var e = this.getItem(t);
          e && delete e.isIgnored;
        }),
        (f.stamp = function (t) {
          (t = this._find(t)), t && ((this.stamps = this.stamps.concat(t)), t.forEach(this.ignore, this));
        }),
        (f.unstamp = function (t) {
          (t = this._find(t)),
            t &&
              t.forEach(function (t) {
                n.removeFrom(this.stamps, t), this.unignore(t);
              }, this);
        }),
        (f._find = function (t) {
          return t ? ("string" == typeof t && (t = this.element.querySelectorAll(t)), (t = n.makeArray(t))) : void 0;
        }),
        (f._manageStamps = function () {
          this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this));
        }),
        (f._getBoundingRect = function () {
          var t = this.element.getBoundingClientRect(),
            e = this.size;
          this._boundingRect = {
            left: t.left + e.paddingLeft + e.borderLeftWidth,
            top: t.top + e.paddingTop + e.borderTopWidth,
            right: t.right - (e.paddingRight + e.borderRightWidth),
            bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth),
          };
        }),
        (f._manageStamp = c),
        (f._getElementOffset = function (t) {
          var e = t.getBoundingClientRect(),
            n = this._boundingRect,
            o = i(t),
            s = {
              left: e.left - n.left - o.marginLeft,
              top: e.top - n.top - o.marginTop,
              right: n.right - e.right - o.marginRight,
              bottom: n.bottom - e.bottom - o.marginBottom,
            };
          return s;
        }),
        (f.handleEvent = n.handleEvent),
        (f.bindResize = function () {
          t.addEventListener("resize", this), (this.isResizeBound = !0);
        }),
        (f.unbindResize = function () {
          t.removeEventListener("resize", this), (this.isResizeBound = !1);
        }),
        (f.onresize = function () {
          this.resize();
        }),
        n.debounceMethod(s, "onresize", 100),
        (f.resize = function () {
          this.isResizeBound && this.needsResizeLayout() && this.layout();
        }),
        (f.needsResizeLayout = function () {
          var t = i(this.element),
            e = this.size && t;
          return e && t.innerWidth !== this.size.innerWidth;
        }),
        (f.addItems = function (t) {
          var e = this._itemize(t);
          return e.length && (this.items = this.items.concat(e)), e;
        }),
        (f.appended = function (t) {
          var e = this.addItems(t);
          e.length && (this.layoutItems(e, !0), this.reveal(e));
        }),
        (f.prepended = function (t) {
          var e = this._itemize(t);
          if (e.length) {
            var i = this.items.slice(0);
            (this.items = e.concat(i)),
              this._resetLayout(),
              this._manageStamps(),
              this.layoutItems(e, !0),
              this.reveal(e),
              this.layoutItems(i);
          }
        }),
        (f.reveal = function (t) {
          if ((this._emitCompleteOnItems("reveal", t), t && t.length)) {
            var e = this.updateStagger();
            t.forEach(function (t, i) {
              t.stagger(i * e), t.reveal();
            });
          }
        }),
        (f.hide = function (t) {
          if ((this._emitCompleteOnItems("hide", t), t && t.length)) {
            var e = this.updateStagger();
            t.forEach(function (t, i) {
              t.stagger(i * e), t.hide();
            });
          }
        }),
        (f.revealItemElements = function (t) {
          var e = this.getItems(t);
          this.reveal(e);
        }),
        (f.hideItemElements = function (t) {
          var e = this.getItems(t);
          this.hide(e);
        }),
        (f.getItem = function (t) {
          for (var e = 0; e < this.items.length; e++) {
            var i = this.items[e];
            if (i.element == t) return i;
          }
        }),
        (f.getItems = function (t) {
          t = n.makeArray(t);
          var e = [];
          return (
            t.forEach(function (t) {
              var i = this.getItem(t);
              i && e.push(i);
            }, this),
            e
          );
        }),
        (f.remove = function (t) {
          var e = this.getItems(t);
          this._emitCompleteOnItems("remove", e),
            e &&
              e.length &&
              e.forEach(function (t) {
                t.remove(), n.removeFrom(this.items, t);
              }, this);
        }),
        (f.destroy = function () {
          var t = this.element.style;
          (t.height = ""),
            (t.position = ""),
            (t.width = ""),
            this.items.forEach(function (t) {
              t.destroy();
            }),
            this.unbindResize();
          var e = this.element.outlayerGUID;
          delete l[e], delete this.element.outlayerGUID, u && u.removeData(this.element, this.constructor.namespace);
        }),
        (s.data = function (t) {
          t = n.getQueryElement(t);
          var e = t && t.outlayerGUID;
          return e && l[e];
        }),
        (s.create = function (t, e) {
          var i = r(s);
          return (
            (i.defaults = n.extend({}, s.defaults)),
            n.extend(i.defaults, e),
            (i.compatOptions = n.extend({}, s.compatOptions)),
            (i.namespace = t),
            (i.data = s.data),
            (i.Item = r(o)),
            n.htmlInit(i, t),
            u && u.bridget && u.bridget(t, i),
            i
          );
        });
      var p = { ms: 1, s: 1e3 };
      return (s.Item = o), s;
    }),
    (function (t, e) {
      "function" == typeof define && define.amd
        ? define("packery/js/rect", e)
        : "object" == typeof module && module.exports
        ? (module.exports = e())
        : ((t.Packery = t.Packery || {}), (t.Packery.Rect = e()));
    })(window, function () {
      "use strict";
      function t(e) {
        for (var i in t.defaults) this[i] = t.defaults[i];
        for (i in e) this[i] = e[i];
      }
      t.defaults = { x: 0, y: 0, width: 0, height: 0 };
      var e = t.prototype;
      return (
        (e.contains = function (t) {
          var e = t.width || 0,
            i = t.height || 0;
          return this.x <= t.x && this.y <= t.y && this.x + this.width >= t.x + e && this.y + this.height >= t.y + i;
        }),
        (e.overlaps = function (t) {
          var e = this.x + this.width,
            i = this.y + this.height,
            n = t.x + t.width,
            o = t.y + t.height;
          return this.x < n && e > t.x && this.y < o && i > t.y;
        }),
        (e.getMaximalFreeRects = function (e) {
          if (!this.overlaps(e)) return !1;
          var i,
            n = [],
            o = this.x + this.width,
            s = this.y + this.height,
            r = e.x + e.width,
            a = e.y + e.height;
          return (
            this.y < e.y && ((i = new t({ x: this.x, y: this.y, width: this.width, height: e.y - this.y })), n.push(i)),
            o > r && ((i = new t({ x: r, y: this.y, width: o - r, height: this.height })), n.push(i)),
            s > a && ((i = new t({ x: this.x, y: a, width: this.width, height: s - a })), n.push(i)),
            this.x < e.x &&
              ((i = new t({ x: this.x, y: this.y, width: e.x - this.x, height: this.height })), n.push(i)),
            n
          );
        }),
        (e.canFit = function (t) {
          return this.width >= t.width && this.height >= t.height;
        }),
        t
      );
    }),
    (function (t, e) {
      if ("function" == typeof define && define.amd) define("packery/js/packer", ["./rect"], e);
      else if ("object" == typeof module && module.exports) module.exports = e(require("./rect"));
      else {
        var i = (t.Packery = t.Packery || {});
        i.Packer = e(i.Rect);
      }
    })(window, function (t) {
      "use strict";
      function e(t, e, i) {
        (this.width = t || 0), (this.height = e || 0), (this.sortDirection = i || "downwardLeftToRight"), this.reset();
      }
      var i = e.prototype;
      (i.reset = function () {
        this.spaces = [];
        var e = new t({ x: 0, y: 0, width: this.width, height: this.height });
        this.spaces.push(e), (this.sorter = n[this.sortDirection] || n.downwardLeftToRight);
      }),
        (i.pack = function (t) {
          for (var e = 0; e < this.spaces.length; e++) {
            var i = this.spaces[e];
            if (i.canFit(t)) {
              this.placeInSpace(t, i);
              break;
            }
          }
        }),
        (i.columnPack = function (t) {
          for (var e = 0; e < this.spaces.length; e++) {
            var i = this.spaces[e],
              n = i.x <= t.x && i.x + i.width >= t.x + t.width && i.height >= t.height - 0.01;
            if (n) {
              (t.y = i.y), this.placed(t);
              break;
            }
          }
        }),
        (i.rowPack = function (t) {
          for (var e = 0; e < this.spaces.length; e++) {
            var i = this.spaces[e],
              n = i.y <= t.y && i.y + i.height >= t.y + t.height && i.width >= t.width - 0.01;
            if (n) {
              (t.x = i.x), this.placed(t);
              break;
            }
          }
        }),
        (i.placeInSpace = function (t, e) {
          (t.x = e.x), (t.y = e.y), this.placed(t);
        }),
        (i.placed = function (t) {
          for (var e = [], i = 0; i < this.spaces.length; i++) {
            var n = this.spaces[i],
              o = n.getMaximalFreeRects(t);
            o ? e.push.apply(e, o) : e.push(n);
          }
          (this.spaces = e), this.mergeSortSpaces();
        }),
        (i.mergeSortSpaces = function () {
          e.mergeRects(this.spaces), this.spaces.sort(this.sorter);
        }),
        (i.addSpace = function (t) {
          this.spaces.push(t), this.mergeSortSpaces();
        }),
        (e.mergeRects = function (t) {
          var e = 0,
            i = t[e];
          t: for (; i; ) {
            for (var n = 0, o = t[e + n]; o; ) {
              if (o == i) n++;
              else {
                if (o.contains(i)) {
                  t.splice(e, 1), (i = t[e]);
                  continue t;
                }
                i.contains(o) ? t.splice(e + n, 1) : n++;
              }
              o = t[e + n];
            }
            e++, (i = t[e]);
          }
          return t;
        });
      var n = {
        downwardLeftToRight: function (t, e) {
          return t.y - e.y || t.x - e.x;
        },
        rightwardTopToBottom: function (t, e) {
          return t.x - e.x || t.y - e.y;
        },
      };
      return e;
    }),
    (function (t, e) {
      "function" == typeof define && define.amd
        ? define("packery/js/item", ["outlayer/outlayer", "./rect"], e)
        : "object" == typeof module && module.exports
        ? (module.exports = e(require("outlayer"), require("./rect")))
        : (t.Packery.Item = e(t.Outlayer, t.Packery.Rect));
    })(window, function (t, e) {
      "use strict";
      var i = document.documentElement.style,
        n = "string" == typeof i.transform ? "transform" : "WebkitTransform",
        o = function () {
          t.Item.apply(this, arguments);
        },
        s = (o.prototype = Object.create(t.Item.prototype)),
        r = s._create;
      s._create = function () {
        r.call(this), (this.rect = new e());
      };
      var a = s.moveTo;
      return (
        (s.moveTo = function (t, e) {
          var i = Math.abs(this.position.x - t),
            n = Math.abs(this.position.y - e),
            o = this.layout.dragItemCount && !this.isPlacing && !this.isTransitioning && 1 > i && 1 > n;
          return o ? void this.goTo(t, e) : void a.apply(this, arguments);
        }),
        (s.enablePlacing = function () {
          this.removeTransitionStyles(),
            this.isTransitioning && n && (this.element.style[n] = "none"),
            (this.isTransitioning = !1),
            this.getSize(),
            this.layout._setRectSize(this.element, this.rect),
            (this.isPlacing = !0);
        }),
        (s.disablePlacing = function () {
          this.isPlacing = !1;
        }),
        (s.removeElem = function () {
          var t = this.element.parentNode;
          t && t.removeChild(this.element), this.layout.packer.addSpace(this.rect), this.emitEvent("remove", [this]);
        }),
        (s.showDropPlaceholder = function () {
          var t = this.dropPlaceholder;
          t ||
            ((t = this.dropPlaceholder = document.createElement("div")),
            (t.className = "packery-drop-placeholder"),
            (t.style.position = "absolute")),
            (t.style.width = this.size.width + "px"),
            (t.style.height = this.size.height + "px"),
            this.positionDropPlaceholder(),
            this.layout.element.appendChild(t);
        }),
        (s.positionDropPlaceholder = function () {
          this.dropPlaceholder.style[n] = "translate(" + this.rect.x + "px, " + this.rect.y + "px)";
        }),
        (s.hideDropPlaceholder = function () {
          var t = this.dropPlaceholder.parentNode;
          t && t.removeChild(this.dropPlaceholder);
        }),
        o
      );
    }),
    (function (t, e) {
      "function" == typeof define && define.amd
        ? define(
            ["get-size/get-size", "outlayer/outlayer", "packery/js/rect", "packery/js/packer", "packery/js/item"],
            e
          )
        : "object" == typeof module && module.exports
        ? (module.exports = e(
            require("get-size"),
            require("outlayer"),
            require("./rect"),
            require("./packer"),
            require("./item")
          ))
        : (t.Packery = e(t.getSize, t.Outlayer, t.Packery.Rect, t.Packery.Packer, t.Packery.Item));
    })(window, function (t, e, i, n, o) {
      "use strict";
      function s(t, e) {
        return t.position.y - e.position.y || t.position.x - e.position.x;
      }
      function r(t, e) {
        return t.position.x - e.position.x || t.position.y - e.position.y;
      }
      function a(t, e) {
        var i = e.x - t.x,
          n = e.y - t.y;
        return Math.sqrt(i * i + n * n);
      }
      i.prototype.canFit = function (t) {
        return this.width >= t.width - 1 && this.height >= t.height - 1;
      };
      var h = e.create("packery");
      h.Item = o;
      var u = h.prototype;
      (u._create = function () {
        e.prototype._create.call(this),
          (this.packer = new n()),
          (this.shiftPacker = new n()),
          (this.isEnabled = !0),
          (this.dragItemCount = 0);
        var t = this;
        (this.handleDraggabilly = {
          dragStart: function () {
            t.itemDragStart(this.element);
          },
          dragMove: function () {
            t.itemDragMove(this.element, this.position.x, this.position.y);
          },
          dragEnd: function () {
            t.itemDragEnd(this.element);
          },
        }),
          (this.handleUIDraggable = {
            start: function (e, i) {
              i && t.itemDragStart(e.currentTarget);
            },
            drag: function (e, i) {
              i && t.itemDragMove(e.currentTarget, i.position.left, i.position.top);
            },
            stop: function (e, i) {
              i && t.itemDragEnd(e.currentTarget);
            },
          });
      }),
        (u._resetLayout = function () {
          this.getSize(), this._getMeasurements();
          var t, e, i;
          this._getOption("horizontal")
            ? ((t = 1 / 0), (e = this.size.innerHeight + this.gutter), (i = "rightwardTopToBottom"))
            : ((t = this.size.innerWidth + this.gutter), (e = 1 / 0), (i = "downwardLeftToRight")),
            (this.packer.width = this.shiftPacker.width = t),
            (this.packer.height = this.shiftPacker.height = e),
            (this.packer.sortDirection = this.shiftPacker.sortDirection = i),
            this.packer.reset(),
            (this.maxY = 0),
            (this.maxX = 0);
        }),
        (u._getMeasurements = function () {
          this._getMeasurement("columnWidth", "width"),
            this._getMeasurement("rowHeight", "height"),
            this._getMeasurement("gutter", "width");
        }),
        (u._getItemLayoutPosition = function (t) {
          if ((this._setRectSize(t.element, t.rect), this.isShifting || this.dragItemCount > 0)) {
            var e = this._getPackMethod();
            this.packer[e](t.rect);
          } else this.packer.pack(t.rect);
          return this._setMaxXY(t.rect), t.rect;
        }),
        (u.shiftLayout = function () {
          (this.isShifting = !0), this.layout(), delete this.isShifting;
        }),
        (u._getPackMethod = function () {
          return this._getOption("horizontal") ? "rowPack" : "columnPack";
        }),
        (u._setMaxXY = function (t) {
          (this.maxX = Math.max(t.x + t.width, this.maxX)), (this.maxY = Math.max(t.y + t.height, this.maxY));
        }),
        (u._setRectSize = function (e, i) {
          var n = t(e),
            o = n.outerWidth,
            s = n.outerHeight;
          (o || s) &&
            ((o = this._applyGridGutter(o, this.columnWidth)), (s = this._applyGridGutter(s, this.rowHeight))),
            (i.width = Math.min(o, this.packer.width)),
            (i.height = Math.min(s, this.packer.height));
        }),
        (u._applyGridGutter = function (t, e) {
          if (!e) return t + this.gutter;
          e += this.gutter;
          var i = t % e,
            n = i && 1 > i ? "round" : "ceil";
          return (t = Math[n](t / e) * e);
        }),
        (u._getContainerSize = function () {
          return this._getOption("horizontal")
            ? { width: this.maxX - this.gutter }
            : { height: this.maxY - this.gutter };
        }),
        (u._manageStamp = function (t) {
          var e,
            n = this.getItem(t);
          if (n && n.isPlacing) e = n.rect;
          else {
            var o = this._getElementOffset(t);
            e = new i({
              x: this._getOption("originLeft") ? o.left : o.right,
              y: this._getOption("originTop") ? o.top : o.bottom,
            });
          }
          this._setRectSize(t, e), this.packer.placed(e), this._setMaxXY(e);
        }),
        (u.sortItemsByPosition = function () {
          var t = this._getOption("horizontal") ? r : s;
          this.items.sort(t);
        }),
        (u.fit = function (t, e, i) {
          var n = this.getItem(t);
          n &&
            (this.stamp(n.element),
            n.enablePlacing(),
            this.updateShiftTargets(n),
            (e = void 0 === e ? n.rect.x : e),
            (i = void 0 === i ? n.rect.y : i),
            this.shift(n, e, i),
            this._bindFitEvents(n),
            n.moveTo(n.rect.x, n.rect.y),
            this.shiftLayout(),
            this.unstamp(n.element),
            this.sortItemsByPosition(),
            n.disablePlacing());
        }),
        (u._bindFitEvents = function (t) {
          function e() {
            n++, 2 == n && i.dispatchEvent("fitComplete", null, [t]);
          }
          var i = this,
            n = 0;
          t.once("layout", e), this.once("layoutComplete", e);
        }),
        (u.resize = function () {
          this.isResizeBound &&
            this.needsResizeLayout() &&
            (this.options.shiftPercentResize ? this.resizeShiftPercentLayout() : this.layout());
        }),
        (u.needsResizeLayout = function () {
          var e = t(this.element),
            i = this._getOption("horizontal") ? "innerHeight" : "innerWidth";
          return e[i] != this.size[i];
        }),
        (u.resizeShiftPercentLayout = function () {
          var e = this._getItemsForLayout(this.items),
            i = this._getOption("horizontal"),
            n = i ? "y" : "x",
            o = i ? "height" : "width",
            s = i ? "rowHeight" : "columnWidth",
            r = i ? "innerHeight" : "innerWidth",
            a = this[s];
          if ((a = a && a + this.gutter)) {
            this._getMeasurements();
            var h = this[s] + this.gutter;
            e.forEach(function (t) {
              var e = Math.round(t.rect[n] / a);
              t.rect[n] = e * h;
            });
          } else {
            var u = t(this.element)[r] + this.gutter,
              c = this.packer[o];
            e.forEach(function (t) {
              t.rect[n] = (t.rect[n] / c) * u;
            });
          }
          this.shiftLayout();
        }),
        (u.itemDragStart = function (t) {
          if (this.isEnabled) {
            this.stamp(t);
            var e = this.getItem(t);
            e && (e.enablePlacing(), e.showDropPlaceholder(), this.dragItemCount++, this.updateShiftTargets(e));
          }
        }),
        (u.updateShiftTargets = function (t) {
          this.shiftPacker.reset(), this._getBoundingRect();
          var e = this._getOption("originLeft"),
            n = this._getOption("originTop");
          this.stamps.forEach(function (t) {
            var o = this.getItem(t);
            if (!o || !o.isPlacing) {
              var s = this._getElementOffset(t),
                r = new i({ x: e ? s.left : s.right, y: n ? s.top : s.bottom });
              this._setRectSize(t, r), this.shiftPacker.placed(r);
            }
          }, this);
          var o = this._getOption("horizontal"),
            s = o ? "rowHeight" : "columnWidth",
            r = o ? "height" : "width";
          (this.shiftTargetKeys = []), (this.shiftTargets = []);
          var a,
            h = this[s];
          if ((h = h && h + this.gutter)) {
            var u = Math.ceil(t.rect[r] / h),
              c = Math.floor((this.shiftPacker[r] + this.gutter) / h);
            a = (c - u) * h;
            for (var d = 0; c > d; d++) {
              var l = o ? 0 : d * h,
                f = o ? d * h : 0;
              this._addShiftTarget(l, f, a);
            }
          } else (a = this.shiftPacker[r] + this.gutter - t.rect[r]), this._addShiftTarget(0, 0, a);
          var p = this._getItemsForLayout(this.items),
            g = this._getPackMethod();
          p.forEach(function (t) {
            var e = t.rect;
            this._setRectSize(t.element, e), this.shiftPacker[g](e), this._addShiftTarget(e.x, e.y, a);
            var i = o ? e.x + e.width : e.x,
              n = o ? e.y : e.y + e.height;
            if ((this._addShiftTarget(i, n, a), h))
              for (var s = Math.round(e[r] / h), u = 1; s > u; u++) {
                var c = o ? i : e.x + h * u,
                  d = o ? e.y + h * u : n;
                this._addShiftTarget(c, d, a);
              }
          }, this);
        }),
        (u._addShiftTarget = function (t, e, i) {
          var n = this._getOption("horizontal") ? e : t;
          if (!(0 !== n && n > i)) {
            var o = t + "," + e,
              s = -1 != this.shiftTargetKeys.indexOf(o);
            s || (this.shiftTargetKeys.push(o), this.shiftTargets.push({ x: t, y: e }));
          }
        }),
        (u.shift = function (t, e, i) {
          var n,
            o = 1 / 0,
            s = { x: e, y: i };
          this.shiftTargets.forEach(function (t) {
            var e = a(t, s);
            o > e && ((n = t), (o = e));
          }),
            (t.rect.x = n.x),
            (t.rect.y = n.y);
        });
      var c = 120;
      (u.itemDragMove = function (t, e, i) {
        function n() {
          s.shift(o, e, i), o.positionDropPlaceholder(), s.layout();
        }
        var o = this.isEnabled && this.getItem(t);
        if (o) {
          (e -= this.size.paddingLeft), (i -= this.size.paddingTop);
          var s = this,
            r = new Date(),
            a = this._itemDragTime && r - this._itemDragTime < c;
          a ? (clearTimeout(this.dragTimeout), (this.dragTimeout = setTimeout(n, c))) : (n(), (this._itemDragTime = r));
        }
      }),
        (u.itemDragEnd = function (t) {
          function e() {
            n++,
              2 == n &&
                (i.element.classList.remove("is-positioning-post-drag"),
                i.hideDropPlaceholder(),
                o.dispatchEvent("dragItemPositioned", null, [i]));
          }
          var i = this.isEnabled && this.getItem(t);
          if (i) {
            clearTimeout(this.dragTimeout), i.element.classList.add("is-positioning-post-drag");
            var n = 0,
              o = this;
            i.once("layout", e),
              this.once("layoutComplete", e),
              i.moveTo(i.rect.x, i.rect.y),
              this.layout(),
              (this.dragItemCount = Math.max(0, this.dragItemCount - 1)),
              this.sortItemsByPosition(),
              i.disablePlacing(),
              this.unstamp(i.element);
          }
        }),
        (u.bindDraggabillyEvents = function (t) {
          this._bindDraggabillyEvents(t, "on");
        }),
        (u.unbindDraggabillyEvents = function (t) {
          this._bindDraggabillyEvents(t, "off");
        }),
        (u._bindDraggabillyEvents = function (t, e) {
          var i = this.handleDraggabilly;
          t[e]("dragStart", i.dragStart), t[e]("dragMove", i.dragMove), t[e]("dragEnd", i.dragEnd);
        }),
        (u.bindUIDraggableEvents = function (t) {
          this._bindUIDraggableEvents(t, "on");
        }),
        (u.unbindUIDraggableEvents = function (t) {
          this._bindUIDraggableEvents(t, "off");
        }),
        (u._bindUIDraggableEvents = function (t, e) {
          var i = this.handleUIDraggable;
          t[e]("dragstart", i.start)[e]("drag", i.drag)[e]("dragstop", i.stop);
        });
      var d = u.destroy;
      return (
        (u.destroy = function () {
          d.apply(this, arguments), (this.isEnabled = !1);
        }),
        (h.Rect = i),
        (h.Packer = n),
        h
      );
    });

  /*!
   * imagesLoaded PACKAGED v4.1.4
   * JavaScript is all like "You images are done yet or what?"
   * MIT License
   */
  !(function (e, t) {
    "function" == typeof define && define.amd
      ? define("ev-emitter/ev-emitter", t)
      : "object" == typeof module && module.exports
      ? (module.exports = t())
      : (e.EvEmitter = t());
  })("undefined" != typeof window ? window : this, function () {
    function e() {}
    var t = e.prototype;
    return (
      (t.on = function (e, t) {
        if (e && t) {
          var i = (this._events = this._events || {}),
            n = (i[e] = i[e] || []);
          return n.indexOf(t) == -1 && n.push(t), this;
        }
      }),
      (t.once = function (e, t) {
        if (e && t) {
          this.on(e, t);
          var i = (this._onceEvents = this._onceEvents || {}),
            n = (i[e] = i[e] || {});
          return (n[t] = !0), this;
        }
      }),
      (t.off = function (e, t) {
        var i = this._events && this._events[e];
        if (i && i.length) {
          var n = i.indexOf(t);
          return n != -1 && i.splice(n, 1), this;
        }
      }),
      (t.emitEvent = function (e, t) {
        var i = this._events && this._events[e];
        if (i && i.length) {
          (i = i.slice(0)), (t = t || []);
          for (var n = this._onceEvents && this._onceEvents[e], o = 0; o < i.length; o++) {
            var r = i[o],
              s = n && n[r];
            s && (this.off(e, r), delete n[r]), r.apply(this, t);
          }
          return this;
        }
      }),
      (t.allOff = function () {
        delete this._events, delete this._onceEvents;
      }),
      e
    );
  }),
    (function (e, t) {
      "use strict";
      "function" == typeof define && define.amd
        ? define(["ev-emitter/ev-emitter"], function (i) {
            return t(e, i);
          })
        : "object" == typeof module && module.exports
        ? (module.exports = t(e, require("ev-emitter")))
        : (e.imagesLoaded = t(e, e.EvEmitter));
    })("undefined" != typeof window ? window : this, function (e, t) {
      function i(e, t) {
        for (var i in t) e[i] = t[i];
        return e;
      }
      function n(e) {
        if (Array.isArray(e)) return e;
        var t = "object" == typeof e && "number" == typeof e.length;
        return t ? d.call(e) : [e];
      }
      function o(e, t, r) {
        if (!(this instanceof o)) return new o(e, t, r);
        var s = e;
        return (
          "string" == typeof e && (s = document.querySelectorAll(e)),
          s
            ? ((this.elements = n(s)),
              (this.options = i({}, this.options)),
              "function" == typeof t ? (r = t) : i(this.options, t),
              r && this.on("always", r),
              this.getImages(),
              h && (this.jqDeferred = new h.Deferred()),
              void setTimeout(this.check.bind(this)))
            : void a.error("Bad element for imagesLoaded " + (s || e))
        );
      }
      function r(e) {
        this.img = e;
      }
      function s(e, t) {
        (this.url = e), (this.element = t), (this.img = new Image());
      }
      var h = e.jQuery,
        a = e.console,
        d = Array.prototype.slice;
      (o.prototype = Object.create(t.prototype)),
        (o.prototype.options = {}),
        (o.prototype.getImages = function () {
          (this.images = []), this.elements.forEach(this.addElementImages, this);
        }),
        (o.prototype.addElementImages = function (e) {
          "IMG" == e.nodeName && this.addImage(e), this.options.background === !0 && this.addElementBackgroundImages(e);
          var t = e.nodeType;
          if (t && u[t]) {
            for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
              var o = i[n];
              this.addImage(o);
            }
            if ("string" == typeof this.options.background) {
              var r = e.querySelectorAll(this.options.background);
              for (n = 0; n < r.length; n++) {
                var s = r[n];
                this.addElementBackgroundImages(s);
              }
            }
          }
        });
      var u = { 1: !0, 9: !0, 11: !0 };
      return (
        (o.prototype.addElementBackgroundImages = function (e) {
          var t = getComputedStyle(e);
          if (t)
            for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage); null !== n; ) {
              var o = n && n[2];
              o && this.addBackground(o, e), (n = i.exec(t.backgroundImage));
            }
        }),
        (o.prototype.addImage = function (e) {
          var t = new r(e);
          this.images.push(t);
        }),
        (o.prototype.addBackground = function (e, t) {
          var i = new s(e, t);
          this.images.push(i);
        }),
        (o.prototype.check = function () {
          function e(e, i, n) {
            setTimeout(function () {
              t.progress(e, i, n);
            });
          }
          var t = this;
          return (
            (this.progressedCount = 0),
            (this.hasAnyBroken = !1),
            this.images.length
              ? void this.images.forEach(function (t) {
                  t.once("progress", e), t.check();
                })
              : void this.complete()
          );
        }),
        (o.prototype.progress = function (e, t, i) {
          this.progressedCount++,
            (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
            this.emitEvent("progress", [this, e, t]),
            this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e),
            this.progressedCount == this.images.length && this.complete(),
            this.options.debug && a && a.log("progress: " + i, e, t);
        }),
        (o.prototype.complete = function () {
          var e = this.hasAnyBroken ? "fail" : "done";
          if (((this.isComplete = !0), this.emitEvent(e, [this]), this.emitEvent("always", [this]), this.jqDeferred)) {
            var t = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[t](this);
          }
        }),
        (r.prototype = Object.create(t.prototype)),
        (r.prototype.check = function () {
          var e = this.getIsImageComplete();
          return e
            ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
            : ((this.proxyImage = new Image()),
              this.proxyImage.addEventListener("load", this),
              this.proxyImage.addEventListener("error", this),
              this.img.addEventListener("load", this),
              this.img.addEventListener("error", this),
              void (this.proxyImage.src = this.img.src));
        }),
        (r.prototype.getIsImageComplete = function () {
          return this.img.complete && this.img.naturalWidth;
        }),
        (r.prototype.confirm = function (e, t) {
          (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
        }),
        (r.prototype.handleEvent = function (e) {
          var t = "on" + e.type;
          this[t] && this[t](e);
        }),
        (r.prototype.onload = function () {
          this.confirm(!0, "onload"), this.unbindEvents();
        }),
        (r.prototype.onerror = function () {
          this.confirm(!1, "onerror"), this.unbindEvents();
        }),
        (r.prototype.unbindEvents = function () {
          this.proxyImage.removeEventListener("load", this),
            this.proxyImage.removeEventListener("error", this),
            this.img.removeEventListener("load", this),
            this.img.removeEventListener("error", this);
        }),
        (s.prototype = Object.create(r.prototype)),
        (s.prototype.check = function () {
          this.img.addEventListener("load", this), this.img.addEventListener("error", this), (this.img.src = this.url);
          var e = this.getIsImageComplete();
          e && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
        }),
        (s.prototype.unbindEvents = function () {
          this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
        }),
        (s.prototype.confirm = function (e, t) {
          (this.isLoaded = e), this.emitEvent("progress", [this, this.element, t]);
        }),
        (o.makeJQueryPlugin = function (t) {
          (t = t || e.jQuery),
            t &&
              ((h = t),
              (h.fn.imagesLoaded = function (e, t) {
                var i = new o(this, e, t);
                return i.jqDeferred.promise(h(this));
              }));
        }),
        o.makeJQueryPlugin(),
        o
      );
    });

  /*!
   * Rivets.js + Sightglass.js
   * version: 0.9.6
   * author: Michael Richards
   * license: MIT
   */
  (function () {
    function t(t, s, i, h) {
      return new e(t, s, i, h);
    }
    function e(t, e, i, h) {
      (this.options = h || {}),
        (this.options.adapters = this.options.adapters || {}),
        (this.obj = t),
        (this.keypath = e),
        (this.callback = i),
        (this.objectPath = []),
        (this.update = this.update.bind(this)),
        this.parse(),
        s((this.target = this.realize())) && this.set(!0, this.key, this.target, this.callback);
    }
    function s(t) {
      return "object" == typeof t && null !== t;
    }
    function i(t) {
      throw new Error("[sightglass] " + t);
    }
    (t.adapters = {}),
      (e.tokenize = function (t, e, s) {
        var i,
          h,
          a = [],
          o = { i: s, path: "" };
        for (i = 0; i < t.length; i++)
          (h = t.charAt(i)), ~e.indexOf(h) ? (a.push(o), (o = { i: h, path: "" })) : (o.path += h);
        return a.push(o), a;
      }),
      (e.prototype.parse = function () {
        var s,
          h,
          a = this.interfaces();
        a.length || i("Must define at least one adapter interface."),
          ~a.indexOf(this.keypath[0])
            ? ((s = this.keypath[0]), (h = this.keypath.substr(1)))
            : ("undefined" == typeof (s = this.options.root || t.root) && i("Must define a default root adapter."),
              (h = this.keypath)),
          (this.tokens = e.tokenize(h, a, s)),
          (this.key = this.tokens.pop());
      }),
      (e.prototype.realize = function () {
        var t,
          e = this.obj,
          i = !1;
        return (
          this.tokens.forEach(function (h, a) {
            s(e)
              ? ("undefined" != typeof this.objectPath[a]
                  ? e !== (t = this.objectPath[a]) &&
                    (this.set(!1, h, t, this.update), this.set(!0, h, e, this.update), (this.objectPath[a] = e))
                  : (this.set(!0, h, e, this.update), (this.objectPath[a] = e)),
                (e = this.get(h, e)))
              : (i === !1 && (i = a), (t = this.objectPath[a]) && this.set(!1, h, t, this.update));
          }, this),
          i !== !1 && this.objectPath.splice(i),
          e
        );
      }),
      (e.prototype.update = function () {
        var t, e;
        (t = this.realize()) !== this.target &&
          (s(this.target) && this.set(!1, this.key, this.target, this.callback),
          s(t) && this.set(!0, this.key, t, this.callback),
          (e = this.value()),
          (this.target = t),
          (this.value() instanceof Function || this.value() !== e) && this.callback());
      }),
      (e.prototype.value = function () {
        return s(this.target) ? this.get(this.key, this.target) : void 0;
      }),
      (e.prototype.setValue = function (t) {
        s(this.target) && this.adapter(this.key).set(this.target, this.key.path, t);
      }),
      (e.prototype.get = function (t, e) {
        return this.adapter(t).get(e, t.path);
      }),
      (e.prototype.set = function (t, e, s, i) {
        var h = t ? "observe" : "unobserve";
        this.adapter(e)[h](s, e.path, i);
      }),
      (e.prototype.interfaces = function () {
        var e = Object.keys(this.options.adapters);
        return (
          Object.keys(t.adapters).forEach(function (t) {
            ~e.indexOf(t) || e.push(t);
          }),
          e
        );
      }),
      (e.prototype.adapter = function (e) {
        return this.options.adapters[e.i] || t.adapters[e.i];
      }),
      (e.prototype.unobserve = function () {
        var t;
        this.tokens.forEach(function (e, s) {
          (t = this.objectPath[s]) && this.set(!1, e, t, this.update);
        }, this),
          s(this.target) && this.set(!1, this.key, this.target, this.callback);
      }),
      "undefined" != typeof module && module.exports
        ? (module.exports = t)
        : "function" == typeof define && define.amd
        ? define([], function () {
            return (this.sightglass = t);
          })
        : (this.sightglass = t);
  }).call(this);
  (function () {
    var t,
      e,
      i,
      n,
      r,
      s = function (t, e) {
        return function () {
          return t.apply(e, arguments);
        };
      },
      o = [].slice,
      u = {}.hasOwnProperty,
      l = function (t, e) {
        function i() {
          this.constructor = t;
        }
        for (var n in e) u.call(e, n) && (t[n] = e[n]);
        return (i.prototype = e.prototype), (t.prototype = new i()), (t.__super__ = e.prototype), t;
      },
      h =
        [].indexOf ||
        function (t) {
          for (var e = 0, i = this.length; i > e; e++) if (e in this && this[e] === t) return e;
          return -1;
        };
    (t = {
      options: ["prefix", "templateDelimiters", "rootInterface", "preloadData", "handler", "executeFunctions"],
      extensions: ["binders", "formatters", "components", "adapters"],
      public: {
        binders: {},
        components: {},
        formatters: {},
        adapters: {},
        prefix: "rv",
        templateDelimiters: ["{", "}"],
        rootInterface: ".",
        preloadData: !0,
        executeFunctions: !1,
        iterationAlias: function (t) {
          return "%" + t + "%";
        },
        handler: function (t, e, i) {
          return this.call(t, e, i.view.models);
        },
        configure: function (e) {
          var i, n, r, s;
          null == e && (e = {});
          for (r in e)
            if (((s = e[r]), "binders" === r || "components" === r || "formatters" === r || "adapters" === r))
              for (n in s) (i = s[n]), (t[r][n] = i);
            else t["public"][r] = s;
        },
        bind: function (e, i, n) {
          var r;
          return null == i && (i = {}), null == n && (n = {}), (r = new t.View(e, i, n)), r.bind(), r;
        },
        init: function (e, i, n) {
          var r, s, o;
          if (
            (null == n && (n = {}),
            null == i && (i = document.createElement("div")),
            (e = t["public"].components[e]),
            (s = e.template.call(this, i)),
            s instanceof HTMLElement)
          ) {
            for (; i.firstChild; ) i.removeChild(i.firstChild);
            i.appendChild(s);
          } else i.innerHTML = s;
          return (r = e.initialize.call(this, i, n)), (o = new t.View(i, r)), o.bind(), o;
        },
      },
    }),
      window.jQuery || window.$
        ? ((i = window.jQuery || window.$),
          (r = "on" in i.prototype ? ["on", "off"] : ["bind", "unbind"]),
          (e = r[0]),
          (n = r[1]),
          (t.Util = {
            bindEvent: function (t, n, r) {
              return i(t)[e](n, r);
            },
            unbindEvent: function (t, e, r) {
              return i(t)[n](e, r);
            },
            getInputValue: function (t) {
              var e;
              return (e = i(t)), "checkbox" === e.attr("type") ? e.is(":checked") : e.val();
            },
          }))
        : (t.Util = {
            bindEvent: (function () {
              return "addEventListener" in window
                ? function (t, e, i) {
                    return t.addEventListener(e, i, !1);
                  }
                : function (t, e, i) {
                    return t.attachEvent("on" + e, i);
                  };
            })(),
            unbindEvent: (function () {
              return "removeEventListener" in window
                ? function (t, e, i) {
                    return t.removeEventListener(e, i, !1);
                  }
                : function (t, e, i) {
                    return t.detachEvent("on" + e, i);
                  };
            })(),
            getInputValue: function (t) {
              var e, i, n, r;
              if ("checkbox" === t.type) return t.checked;
              if ("select-multiple" === t.type) {
                for (r = [], i = 0, n = t.length; n > i; i++) (e = t[i]), e.selected && r.push(e.value);
                return r;
              }
              return t.value;
            },
          }),
      (t.TypeParser = (function () {
        function t() {}
        return (
          (t.types = { primitive: 0, keypath: 1 }),
          (t.parse = function (t) {
            return /^'.*'$|^".*"$/.test(t)
              ? { type: this.types.primitive, value: t.slice(1, -1) }
              : "true" === t
              ? { type: this.types.primitive, value: !0 }
              : "false" === t
              ? { type: this.types.primitive, value: !1 }
              : "null" === t
              ? { type: this.types.primitive, value: null }
              : "undefined" === t
              ? { type: this.types.primitive, value: void 0 }
              : "" === t
              ? { type: this.types.primitive, value: void 0 }
              : isNaN(Number(t)) === !1
              ? { type: this.types.primitive, value: Number(t) }
              : { type: this.types.keypath, value: t };
          }),
          t
        );
      })()),
      (t.TextTemplateParser = (function () {
        function t() {}
        return (
          (t.types = { text: 0, binding: 1 }),
          (t.parse = function (t, e) {
            var i, n, r, s, o, u, l;
            for (u = [], s = t.length, i = 0, n = 0; s > n; ) {
              if (((i = t.indexOf(e[0], n)), 0 > i)) {
                u.push({ type: this.types.text, value: t.slice(n) });
                break;
              }
              if (
                (i > 0 && i > n && u.push({ type: this.types.text, value: t.slice(n, i) }),
                (n = i + e[0].length),
                (i = t.indexOf(e[1], n)),
                0 > i)
              ) {
                (o = t.slice(n - e[1].length)),
                  (r = u[u.length - 1]),
                  (null != r ? r.type : void 0) === this.types.text
                    ? (r.value += o)
                    : u.push({ type: this.types.text, value: o });
                break;
              }
              (l = t.slice(n, i).trim()), u.push({ type: this.types.binding, value: l }), (n = i + e[1].length);
            }
            return u;
          }),
          t
        );
      })()),
      (t.View = (function () {
        function e(e, i, n) {
          var r, o, u, l, h, a, p, d, c, f, b, v, m;
          for (
            this.els = e,
              this.models = i,
              null == n && (n = {}),
              this.update = s(this.update, this),
              this.publish = s(this.publish, this),
              this.sync = s(this.sync, this),
              this.unbind = s(this.unbind, this),
              this.bind = s(this.bind, this),
              this.select = s(this.select, this),
              this.traverse = s(this.traverse, this),
              this.build = s(this.build, this),
              this.buildBinding = s(this.buildBinding, this),
              this.bindingRegExp = s(this.bindingRegExp, this),
              this.options = s(this.options, this),
              this.els.jquery || this.els instanceof Array || (this.els = [this.els]),
              c = t.extensions,
              h = 0,
              p = c.length;
            p > h;
            h++
          ) {
            if (((o = c[h]), (this[o] = {}), n[o])) {
              f = n[o];
              for (r in f) (u = f[r]), (this[o][r] = u);
            }
            b = t["public"][o];
            for (r in b) (u = b[r]), null == (l = this[o])[r] && (l[r] = u);
          }
          for (v = t.options, a = 0, d = v.length; d > a; a++)
            (o = v[a]), (this[o] = null != (m = n[o]) ? m : t["public"][o]);
          this.build();
        }
        return (
          (e.prototype.options = function () {
            var e, i, n, r, s;
            for (i = {}, s = t.extensions.concat(t.options), n = 0, r = s.length; r > n; n++)
              (e = s[n]), (i[e] = this[e]);
            return i;
          }),
          (e.prototype.bindingRegExp = function () {
            return new RegExp("^" + this.prefix + "-");
          }),
          (e.prototype.buildBinding = function (e, i, n, r) {
            var s, o, u, l, h, a, p;
            return (
              (h = {}),
              (p = (function () {
                var t, e, i, n;
                for (
                  i = r.match(/((?:'[^']*')*(?:(?:[^\|']*(?:'[^']*')+[^\|']*)+|[^\|]+))|^$/g),
                    n = [],
                    t = 0,
                    e = i.length;
                  e > t;
                  t++
                )
                  (a = i[t]), n.push(a.trim());
                return n;
              })()),
              (s = (function () {
                var t, e, i, n;
                for (i = p.shift().split("<"), n = [], t = 0, e = i.length; e > t; t++) (o = i[t]), n.push(o.trim());
                return n;
              })()),
              (l = s.shift()),
              (h.formatters = p),
              (u = s.shift()) && (h.dependencies = u.split(/\s+/)),
              this.bindings.push(new t[e](this, i, n, l, h))
            );
          }),
          (e.prototype.build = function () {
            var e, i, n, r, s;
            for (
              this.bindings = [],
                i = (function (e) {
                  return function (n) {
                    var r, s, o, u, l, h, a, p, d, c, f, b, v;
                    if (3 === n.nodeType) {
                      if (
                        ((l = t.TextTemplateParser),
                        (o = e.templateDelimiters) &&
                          (p = l.parse(n.data, o)).length &&
                          (1 !== p.length || p[0].type !== l.types.text))
                      ) {
                        for (d = 0, f = p.length; f > d; d++)
                          (a = p[d]),
                            (h = document.createTextNode(a.value)),
                            n.parentNode.insertBefore(h, n),
                            1 === a.type && e.buildBinding("TextBinding", h, null, a.value);
                        n.parentNode.removeChild(n);
                      }
                    } else 1 === n.nodeType && (r = e.traverse(n));
                    if (!r)
                      for (
                        v = (function () {
                          var t, e, i, r;
                          for (i = n.childNodes, r = [], t = 0, e = i.length; e > t; t++) (u = i[t]), r.push(u);
                          return r;
                        })(),
                          c = 0,
                          b = v.length;
                        b > c;
                        c++
                      )
                        (s = v[c]), i(s);
                  };
                })(this),
                s = this.els,
                n = 0,
                r = s.length;
              r > n;
              n++
            )
              (e = s[n]), i(e);
            this.bindings.sort(function (t, e) {
              var i, n;
              return (
                ((null != (i = e.binder) ? i.priority : void 0) || 0) -
                ((null != (n = t.binder) ? n.priority : void 0) || 0)
              );
            });
          }),
          (e.prototype.traverse = function (e) {
            var i, n, r, s, o, u, l, h, a, p, d, c, f, b, v, m;
            for (
              s = this.bindingRegExp(),
                o = "SCRIPT" === e.nodeName || "STYLE" === e.nodeName,
                b = e.attributes,
                p = 0,
                c = b.length;
              c > p;
              p++
            )
              if (((i = b[p]), s.test(i.name))) {
                if (((h = i.name.replace(s, "")), !(r = this.binders[h]))) {
                  v = this.binders;
                  for (u in v)
                    (a = v[u]),
                      "*" !== u &&
                        -1 !== u.indexOf("*") &&
                        ((l = new RegExp("^" + u.replace(/\*/g, ".+") + "$")), l.test(h) && (r = a));
                }
                r || (r = this.binders["*"]), r.block && ((o = !0), (n = [i]));
              }
            for (m = n || e.attributes, d = 0, f = m.length; f > d; d++)
              (i = m[d]), s.test(i.name) && ((h = i.name.replace(s, "")), this.buildBinding("Binding", e, h, i.value));
            return (
              o ||
                ((h = e.nodeName.toLowerCase()),
                this.components[h] && !e._bound && (this.bindings.push(new t.ComponentBinding(this, e, h)), (o = !0))),
              o
            );
          }),
          (e.prototype.select = function (t) {
            var e, i, n, r, s;
            for (r = this.bindings, s = [], i = 0, n = r.length; n > i; i++) (e = r[i]), t(e) && s.push(e);
            return s;
          }),
          (e.prototype.bind = function () {
            var t, e, i, n;
            for (n = this.bindings, e = 0, i = n.length; i > e; e++) (t = n[e]), t.bind();
          }),
          (e.prototype.unbind = function () {
            var t, e, i, n;
            for (n = this.bindings, e = 0, i = n.length; i > e; e++) (t = n[e]), t.unbind();
          }),
          (e.prototype.sync = function () {
            var t, e, i, n;
            for (n = this.bindings, e = 0, i = n.length; i > e; e++)
              (t = n[e]), "function" == typeof t.sync && t.sync();
          }),
          (e.prototype.publish = function () {
            var t, e, i, n;
            for (
              n = this.select(function (t) {
                var e;
                return null != (e = t.binder) ? e.publishes : void 0;
              }),
                e = 0,
                i = n.length;
              i > e;
              e++
            )
              (t = n[e]), t.publish();
          }),
          (e.prototype.update = function (t) {
            var e, i, n, r, s, o;
            null == t && (t = {});
            for (i in t) (n = t[i]), (this.models[i] = n);
            for (o = this.bindings, r = 0, s = o.length; s > r; r++)
              (e = o[r]), "function" == typeof e.update && e.update(t);
          }),
          e
        );
      })()),
      (t.Binding = (function () {
        function e(t, e, i, n, r) {
          (this.view = t),
            (this.el = e),
            (this.type = i),
            (this.keypath = n),
            (this.options = null != r ? r : {}),
            (this.getValue = s(this.getValue, this)),
            (this.update = s(this.update, this)),
            (this.unbind = s(this.unbind, this)),
            (this.bind = s(this.bind, this)),
            (this.publish = s(this.publish, this)),
            (this.sync = s(this.sync, this)),
            (this.set = s(this.set, this)),
            (this.eventHandler = s(this.eventHandler, this)),
            (this.formattedValue = s(this.formattedValue, this)),
            (this.parseFormatterArguments = s(this.parseFormatterArguments, this)),
            (this.parseTarget = s(this.parseTarget, this)),
            (this.observe = s(this.observe, this)),
            (this.setBinder = s(this.setBinder, this)),
            (this.formatters = this.options.formatters || []),
            (this.dependencies = []),
            (this.formatterObservers = {}),
            (this.model = void 0),
            this.setBinder();
        }
        return (
          (e.prototype.setBinder = function () {
            var t, e, i, n;
            if (!(this.binder = this.view.binders[this.type])) {
              n = this.view.binders;
              for (t in n)
                (i = n[t]),
                  "*" !== t &&
                    -1 !== t.indexOf("*") &&
                    ((e = new RegExp("^" + t.replace(/\*/g, ".+") + "$")),
                    e.test(this.type) &&
                      ((this.binder = i),
                      (this.args = new RegExp("^" + t.replace(/\*/g, "(.+)") + "$").exec(this.type)),
                      this.args.shift()));
            }
            return (
              this.binder || (this.binder = this.view.binders["*"]),
              this.binder instanceof Function ? (this.binder = { routine: this.binder }) : void 0
            );
          }),
          (e.prototype.observe = function (e, i, n) {
            return t.sightglass(e, i, n, { root: this.view.rootInterface, adapters: this.view.adapters });
          }),
          (e.prototype.parseTarget = function () {
            var e;
            return (
              (e = t.TypeParser.parse(this.keypath)),
              e.type === t.TypeParser.types.primitive
                ? (this.value = e.value)
                : ((this.observer = this.observe(this.view.models, this.keypath, this.sync)),
                  (this.model = this.observer.target))
            );
          }),
          (e.prototype.parseFormatterArguments = function (e, i) {
            var n, r, s, o, u, l, h;
            for (
              e = (function () {
                var i, n, s;
                for (s = [], i = 0, n = e.length; n > i; i++) (r = e[i]), s.push(t.TypeParser.parse(r));
                return s;
              })(),
                o = [],
                n = l = 0,
                h = e.length;
              h > l;
              n = ++l
            )
              (r = e[n]),
                o.push(
                  r.type === t.TypeParser.types.primitive
                    ? r.value
                    : ((u = this.formatterObservers)[i] || (u[i] = {}),
                      (s = this.formatterObservers[i][n])
                        ? void 0
                        : ((s = this.observe(this.view.models, r.value, this.sync)),
                          (this.formatterObservers[i][n] = s)),
                      s.value())
                );
            return o;
          }),
          (e.prototype.formattedValue = function (t) {
            var e, i, n, r, s, u, l, h, a;
            for (h = this.formatters, i = u = 0, l = h.length; l > u; i = ++u)
              (n = h[i]),
                (e = n.match(/[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g)),
                (r = e.shift()),
                (n = this.view.formatters[r]),
                (s = this.parseFormatterArguments(e, i)),
                (null != n ? n.read : void 0) instanceof Function
                  ? (t = (a = n.read).call.apply(a, [this.model, t].concat(o.call(s))))
                  : n instanceof Function && (t = n.call.apply(n, [this.model, t].concat(o.call(s))));
            return t;
          }),
          (e.prototype.eventHandler = function (t) {
            var e, i;
            return (
              (i = (e = this).view.handler),
              function (n) {
                return i.call(t, this, n, e);
              }
            );
          }),
          (e.prototype.set = function (e) {
            var i;
            return (
              (e =
                e instanceof Function && !this.binder["function"] && t["public"].executeFunctions
                  ? this.formattedValue(e.call(this.model))
                  : this.formattedValue(e)),
              null != (i = this.binder.routine) ? i.call(this, this.el, e) : void 0
            );
          }),
          (e.prototype.sync = function () {
            var t, e;
            return this.set(
              function () {
                var i, n, r, s, o, u, l;
                if (this.observer) {
                  if (this.model !== this.observer.target) {
                    for (o = this.dependencies, i = 0, r = o.length; r > i; i++) (e = o[i]), e.unobserve();
                    if (
                      ((this.dependencies = []),
                      null != (this.model = this.observer.target) &&
                        (null != (u = this.options.dependencies) ? u.length : void 0))
                    )
                      for (l = this.options.dependencies, n = 0, s = l.length; s > n; n++)
                        (t = l[n]), (e = this.observe(this.model, t, this.sync)), this.dependencies.push(e);
                  }
                  return this.observer.value();
                }
                return this.value;
              }.call(this)
            );
          }),
          (e.prototype.publish = function () {
            var t, e, i, n, r, s, u, l, h, a, p, d, c;
            if (this.observer) {
              for (
                l = this.getValue(this.el),
                  s = this.formatters.length - 1,
                  p = this.formatters.slice(0).reverse(),
                  i = h = 0,
                  a = p.length;
                a > h;
                i = ++h
              )
                (n = p[i]),
                  (e = s - i),
                  (t = n.split(/\s+/)),
                  (r = t.shift()),
                  (u = this.parseFormatterArguments(t, e)),
                  (null != (d = this.view.formatters[r]) ? d.publish : void 0) &&
                    (l = (c = this.view.formatters[r]).publish.apply(c, [l].concat(o.call(u))));
              return this.observer.setValue(l);
            }
          }),
          (e.prototype.bind = function () {
            var t, e, i, n, r, s, o;
            if (
              (this.parseTarget(),
              null != (r = this.binder.bind) && r.call(this, this.el),
              null != this.model && (null != (s = this.options.dependencies) ? s.length : void 0))
            )
              for (o = this.options.dependencies, i = 0, n = o.length; n > i; i++)
                (t = o[i]), (e = this.observe(this.model, t, this.sync)), this.dependencies.push(e);
            return this.view.preloadData ? this.sync() : void 0;
          }),
          (e.prototype.unbind = function () {
            var t, e, i, n, r, s, o, u, l, h;
            for (
              null != (o = this.binder.unbind) && o.call(this, this.el),
                null != (u = this.observer) && u.unobserve(),
                l = this.dependencies,
                r = 0,
                s = l.length;
              s > r;
              r++
            )
              (n = l[r]), n.unobserve();
            (this.dependencies = []), (h = this.formatterObservers);
            for (i in h) {
              e = h[i];
              for (t in e) (n = e[t]), n.unobserve();
            }
            return (this.formatterObservers = {});
          }),
          (e.prototype.update = function (t) {
            var e, i;
            return (
              null == t && (t = {}),
              (this.model = null != (e = this.observer) ? e.target : void 0),
              null != (i = this.binder.update) ? i.call(this, t) : void 0
            );
          }),
          (e.prototype.getValue = function (e) {
            return this.binder && null != this.binder.getValue
              ? this.binder.getValue.call(this, e)
              : t.Util.getInputValue(e);
          }),
          e
        );
      })()),
      (t.ComponentBinding = (function (e) {
        function i(e, i, n) {
          var r, o, u, l, a, p, d, c;
          for (
            this.view = e,
              this.el = i,
              this.type = n,
              this.unbind = s(this.unbind, this),
              this.bind = s(this.bind, this),
              this.locals = s(this.locals, this),
              this.component = this.view.components[this.type],
              this["static"] = {},
              this.observers = {},
              this.upstreamObservers = {},
              o = e.bindingRegExp(),
              d = this.el.attributes || [],
              a = 0,
              p = d.length;
            p > a;
            a++
          )
            (r = d[a]),
              o.test(r.name) ||
                ((u = this.camelCase(r.name)),
                (l = t.TypeParser.parse(r.value)),
                h.call(null != (c = this.component["static"]) ? c : [], u) >= 0
                  ? (this["static"][u] = r.value)
                  : l.type === t.TypeParser.types.primitive
                  ? (this["static"][u] = l.value)
                  : (this.observers[u] = r.value));
        }
        return (
          l(i, e),
          (i.prototype.sync = function () {}),
          (i.prototype.update = function () {}),
          (i.prototype.publish = function () {}),
          (i.prototype.locals = function () {
            var t, e, i, n, r, s;
            (i = {}), (r = this["static"]);
            for (t in r) (n = r[t]), (i[t] = n);
            s = this.observers;
            for (t in s) (e = s[t]), (i[t] = e.value());
            return i;
          }),
          (i.prototype.camelCase = function (t) {
            return t.replace(/-([a-z])/g, function (t) {
              return t[1].toUpperCase();
            });
          }),
          (i.prototype.bind = function () {
            var e, i, n, r, s, o, u, l, h, a, p, d, c, f, b, v, m, y, g, w;
            if (!this.bound) {
              f = this.observers;
              for (i in f)
                (n = f[i]),
                  (this.observers[i] = this.observe(
                    this.view.models,
                    n,
                    (function (t) {
                      return function (e) {
                        return function () {
                          return (t.componentView.models[e] = t.observers[e].value());
                        };
                      };
                    })(this).call(this, i)
                  ));
              this.bound = !0;
            }
            if (null != this.componentView) this.componentView.bind();
            else {
              for (
                this.el.innerHTML = this.component.template.call(this),
                  u = this.component.initialize.call(this, this.el, this.locals()),
                  this.el._bound = !0,
                  o = {},
                  b = t.extensions,
                  a = 0,
                  d = b.length;
                d > a;
                a++
              ) {
                if (((s = b[a]), (o[s] = {}), this.component[s])) {
                  v = this.component[s];
                  for (e in v) (l = v[e]), (o[s][e] = l);
                }
                m = this.view[s];
                for (e in m) (l = m[e]), null == (h = o[s])[e] && (h[e] = l);
              }
              for (y = t.options, p = 0, c = y.length; c > p; p++)
                (s = y[p]), (o[s] = null != (g = this.component[s]) ? g : this.view[s]);
              (this.componentView = new t.View(Array.prototype.slice.call(this.el.childNodes), u, o)),
                this.componentView.bind(),
                (w = this.observers);
              for (i in w)
                (r = w[i]),
                  (this.upstreamObservers[i] = this.observe(
                    this.componentView.models,
                    i,
                    (function (t) {
                      return function (e, i) {
                        return function () {
                          return i.setValue(t.componentView.models[e]);
                        };
                      };
                    })(this).call(this, i, r)
                  ));
            }
          }),
          (i.prototype.unbind = function () {
            var t, e, i, n, r;
            i = this.upstreamObservers;
            for (t in i) (e = i[t]), e.unobserve();
            n = this.observers;
            for (t in n) (e = n[t]), e.unobserve();
            return null != (r = this.componentView) ? r.unbind.call(this) : void 0;
          }),
          i
        );
      })(t.Binding)),
      (t.TextBinding = (function (t) {
        function e(t, e, i, n, r) {
          (this.view = t),
            (this.el = e),
            (this.type = i),
            (this.keypath = n),
            (this.options = null != r ? r : {}),
            (this.sync = s(this.sync, this)),
            (this.formatters = this.options.formatters || []),
            (this.dependencies = []),
            (this.formatterObservers = {});
        }
        return (
          l(e, t),
          (e.prototype.binder = {
            routine: function (t, e) {
              return (t.data = null != e ? e : "");
            },
          }),
          (e.prototype.sync = function () {
            return e.__super__.sync.apply(this, arguments);
          }),
          e
        );
      })(t.Binding)),
      (t["public"].binders.text = function (t, e) {
        return null != t.textContent ? (t.textContent = null != e ? e : "") : (t.innerText = null != e ? e : "");
      }),
      (t["public"].binders.html = function (t, e) {
        return (t.innerHTML = null != e ? e : "");
      }),
      (t["public"].binders.show = function (t, e) {
        return (t.style.display = e ? "" : "none");
      }),
      (t["public"].binders.hide = function (t, e) {
        return (t.style.display = e ? "none" : "");
      }),
      (t["public"].binders.enabled = function (t, e) {
        return (t.disabled = !e);
      }),
      (t["public"].binders.disabled = function (t, e) {
        return (t.disabled = !!e);
      }),
      (t["public"].binders.checked = {
        publishes: !0,
        priority: 2e3,
        bind: function (e) {
          return t.Util.bindEvent(e, "change", this.publish);
        },
        unbind: function (e) {
          return t.Util.unbindEvent(e, "change", this.publish);
        },
        routine: function (t, e) {
          var i;
          return (t.checked =
            "radio" === t.type
              ? (null != (i = t.value) ? i.toString() : void 0) === (null != e ? e.toString() : void 0)
              : !!e);
        },
      }),
      (t["public"].binders.unchecked = {
        publishes: !0,
        priority: 2e3,
        bind: function (e) {
          return t.Util.bindEvent(e, "change", this.publish);
        },
        unbind: function (e) {
          return t.Util.unbindEvent(e, "change", this.publish);
        },
        routine: function (t, e) {
          var i;
          return (t.checked =
            "radio" === t.type
              ? (null != (i = t.value) ? i.toString() : void 0) !== (null != e ? e.toString() : void 0)
              : !e);
        },
      }),
      (t["public"].binders.value = {
        publishes: !0,
        priority: 3e3,
        bind: function (e) {
          return "INPUT" !== e.tagName || "radio" !== e.type
            ? ((this.event = "SELECT" === e.tagName ? "change" : "input"),
              t.Util.bindEvent(e, this.event, this.publish))
            : void 0;
        },
        unbind: function (e) {
          return "INPUT" !== e.tagName || "radio" !== e.type ? t.Util.unbindEvent(e, this.event, this.publish) : void 0;
        },
        routine: function (t, e) {
          var n, r, s, o, u, l, a;
          if ("INPUT" === t.tagName && "radio" === t.type) return t.setAttribute("value", e);
          if (null != window.jQuery) {
            if (((t = i(t)), (null != e ? e.toString() : void 0) !== (null != (o = t.val()) ? o.toString() : void 0)))
              return t.val(null != e ? e : "");
          } else if ("select-multiple" === t.type) {
            if (null != e) {
              for (a = [], r = 0, s = t.length; s > r; r++)
                (n = t[r]), a.push((n.selected = ((u = n.value), h.call(e, u) >= 0)));
              return a;
            }
          } else if ((null != e ? e.toString() : void 0) !== (null != (l = t.value) ? l.toString() : void 0))
            return (t.value = null != e ? e : "");
        },
      }),
      (t["public"].binders["if"] = {
        block: !0,
        priority: 4e3,
        bind: function (t) {
          var e, i;
          return null == this.marker
            ? ((e = [this.view.prefix, this.type].join("-").replace("--", "-")),
              (i = t.getAttribute(e)),
              (this.marker = document.createComment(" rivets: " + this.type + " " + i + " ")),
              (this.bound = !1),
              t.removeAttribute(e),
              t.parentNode.insertBefore(this.marker, t),
              t.parentNode.removeChild(t))
            : void 0;
        },
        unbind: function () {
          return this.nested ? (this.nested.unbind(), (this.bound = !1)) : void 0;
        },
        routine: function (e, i) {
          var n, r, s, o;
          if (!!i == !this.bound) {
            if (i) {
              (s = {}), (o = this.view.models);
              for (n in o) (r = o[n]), (s[n] = r);
              return (
                (this.nested || (this.nested = new t.View(e, s, this.view.options()))).bind(),
                this.marker.parentNode.insertBefore(e, this.marker.nextSibling),
                (this.bound = !0)
              );
            }
            return e.parentNode.removeChild(e), this.nested.unbind(), (this.bound = !1);
          }
        },
        update: function (t) {
          var e;
          return null != (e = this.nested) ? e.update(t) : void 0;
        },
      }),
      (t["public"].binders.unless = {
        block: !0,
        priority: 4e3,
        bind: function (e) {
          return t["public"].binders["if"].bind.call(this, e);
        },
        unbind: function () {
          return t["public"].binders["if"].unbind.call(this);
        },
        routine: function (e, i) {
          return t["public"].binders["if"].routine.call(this, e, !i);
        },
        update: function (e) {
          return t["public"].binders["if"].update.call(this, e);
        },
      }),
      (t["public"].binders["on-*"] = {
        function: !0,
        priority: 1e3,
        unbind: function (e) {
          return this.handler ? t.Util.unbindEvent(e, this.args[0], this.handler) : void 0;
        },
        routine: function (e, i) {
          return (
            this.handler && t.Util.unbindEvent(e, this.args[0], this.handler),
            t.Util.bindEvent(e, this.args[0], (this.handler = this.eventHandler(i)))
          );
        },
      }),
      (t["public"].binders["each-*"] = {
        block: !0,
        priority: 4e3,
        bind: function (t) {
          var e, i, n, r, s;
          if (null == this.marker)
            (e = [this.view.prefix, this.type].join("-").replace("--", "-")),
              (this.marker = document.createComment(" rivets: " + this.type + " ")),
              (this.iterated = []),
              t.removeAttribute(e),
              t.parentNode.insertBefore(this.marker, t),
              t.parentNode.removeChild(t);
          else for (s = this.iterated, n = 0, r = s.length; r > n; n++) (i = s[n]), i.bind();
        },
        unbind: function () {
          var t, e, i, n;
          if (null != this.iterated) for (n = this.iterated, e = 0, i = n.length; i > e; e++) (t = n[e]), t.unbind();
        },
        routine: function (e, i) {
          var n, r, s, o, u, l, h, a, p, d, c, f, b, v, m, y, g, w, k, x;
          if (((h = this.args[0]), (i = i || []), this.iterated.length > i.length))
            for (w = Array(this.iterated.length - i.length), f = 0, m = w.length; m > f; f++)
              (s = w[f]), (c = this.iterated.pop()), c.unbind(), this.marker.parentNode.removeChild(c.els[0]);
          for (o = b = 0, y = i.length; y > b; o = ++b)
            if (
              ((l = i[o]),
              (r = { index: o }),
              (r[t["public"].iterationAlias(h)] = o),
              (r[h] = l),
              null == this.iterated[o])
            ) {
              k = this.view.models;
              for (u in k) (l = k[u]), null == r[u] && (r[u] = l);
              (p = this.iterated.length ? this.iterated[this.iterated.length - 1].els[0] : this.marker),
                (a = this.view.options()),
                (a.preloadData = !0),
                (d = e.cloneNode(!0)),
                (c = new t.View(d, r, a)),
                c.bind(),
                this.iterated.push(c),
                this.marker.parentNode.insertBefore(d, p.nextSibling);
            } else this.iterated[o].models[h] !== l && this.iterated[o].update(r);
          if ("OPTION" === e.nodeName)
            for (x = this.view.bindings, v = 0, g = x.length; g > v; v++)
              (n = x[v]), n.el === this.marker.parentNode && "value" === n.type && n.sync();
        },
        update: function (t) {
          var e, i, n, r, s, o, u;
          e = {};
          for (i in t) (n = t[i]), i !== this.args[0] && (e[i] = n);
          for (u = this.iterated, s = 0, o = u.length; o > s; s++) (r = u[s]), r.update(e);
        },
      }),
      (t["public"].binders["class-*"] = function (t, e) {
        var i;
        return (
          (i = " " + t.className + " "),
          !e == (-1 !== i.indexOf(" " + this.args[0] + " "))
            ? (t.className = e
                ? "" + t.className + " " + this.args[0]
                : i.replace(" " + this.args[0] + " ", " ").trim())
            : void 0
        );
      }),
      (t["public"].binders["*"] = function (t, e) {
        return null != e ? t.setAttribute(this.type, e) : t.removeAttribute(this.type);
      }),
      (t["public"].formatters.call = function () {
        var t, e;
        return (
          (e = arguments[0]),
          (t = 2 <= arguments.length ? o.call(arguments, 1) : []),
          e.call.apply(e, [this].concat(o.call(t)))
        );
      }),
      (t["public"].adapters["."] = {
        id: "_rv",
        counter: 0,
        weakmap: {},
        weakReference: function (t) {
          var e, i, n;
          return (
            t.hasOwnProperty(this.id) || ((e = this.counter++), Object.defineProperty(t, this.id, { value: e })),
            (i = this.weakmap)[(n = t[this.id])] || (i[n] = { callbacks: {} })
          );
        },
        cleanupWeakReference: function (t, e) {
          return Object.keys(t.callbacks).length || (t.pointers && Object.keys(t.pointers).length)
            ? void 0
            : delete this.weakmap[e];
        },
        stubFunction: function (t, e) {
          var i, n, r;
          return (
            (n = t[e]),
            (i = this.weakReference(t)),
            (r = this.weakmap),
            (t[e] = function () {
              var e, s, o, u, l, h, a, p, d, c;
              (u = n.apply(t, arguments)), (a = i.pointers);
              for (o in a)
                for (
                  s = a[o],
                    c = null != (p = null != (d = r[o]) ? d.callbacks[s] : void 0) ? p : [],
                    l = 0,
                    h = c.length;
                  h > l;
                  l++
                )
                  (e = c[l]), e();
              return u;
            })
          );
        },
        observeMutations: function (t, e, i) {
          var n, r, s, o, u, l;
          if (Array.isArray(t)) {
            if (((s = this.weakReference(t)), null == s.pointers))
              for (
                s.pointers = {},
                  r = ["push", "pop", "shift", "unshift", "sort", "reverse", "splice"],
                  u = 0,
                  l = r.length;
                l > u;
                u++
              )
                (n = r[u]), this.stubFunction(t, n);
            if ((null == (o = s.pointers)[e] && (o[e] = []), h.call(s.pointers[e], i) < 0))
              return s.pointers[e].push(i);
          }
        },
        unobserveMutations: function (t, e, i) {
          var n, r, s;
          return Array.isArray(t) && null != t[this.id] && (r = this.weakmap[t[this.id]]) && (s = r.pointers[e])
            ? ((n = s.indexOf(i)) >= 0 && s.splice(n, 1),
              s.length || delete r.pointers[e],
              this.cleanupWeakReference(r, t[this.id]))
            : void 0;
        },
        observe: function (t, e, i) {
          var n, r, s;
          return (
            (n = this.weakReference(t).callbacks),
            null == n[e] &&
              ((n[e] = []),
              (r = Object.getOwnPropertyDescriptor(t, e)),
              (null != r ? r.get : void 0) ||
                (null != r ? r.set : void 0) ||
                ((s = t[e]),
                Object.defineProperty(t, e, {
                  enumerable: !0,
                  get: function () {
                    return s;
                  },
                  set: (function (i) {
                    return function (r) {
                      var o, u, l, a, p;
                      if (r !== s && (i.unobserveMutations(s, t[i.id], e), (s = r), (u = i.weakmap[t[i.id]]))) {
                        if (((n = u.callbacks), n[e]))
                          for (p = n[e].slice(), l = 0, a = p.length; a > l; l++)
                            (o = p[l]), h.call(n[e], o) >= 0 && o();
                        return i.observeMutations(r, t[i.id], e);
                      }
                    };
                  })(this),
                }))),
            h.call(n[e], i) < 0 && n[e].push(i),
            this.observeMutations(t[e], t[this.id], e)
          );
        },
        unobserve: function (t, e, i) {
          var n, r, s;
          return (s = this.weakmap[t[this.id]]) && (n = s.callbacks[e])
            ? ((r = n.indexOf(i)) >= 0 &&
                (n.splice(r, 1), n.length || (delete s.callbacks[e], this.unobserveMutations(t[e], t[this.id], e))),
              this.cleanupWeakReference(s, t[this.id]))
            : void 0;
        },
        get: function (t, e) {
          return t[e];
        },
        set: function (t, e, i) {
          return (t[e] = i);
        },
      }),
      (t.factory = function (e) {
        return (t.sightglass = e), (t["public"]._ = t), t["public"];
      }),
      "object" == typeof ("undefined" != typeof module && null !== module ? module.exports : void 0)
        ? (module.exports = t.factory(require("sightglass")))
        : "function" == typeof define && define.amd
        ? define(["sightglass"], function (e) {
            return (this.rivets = t.factory(e));
          })
        : (this.rivets = t.factory(sightglass));
  }).call(this);

  /*************************************************************************
   *
   * UDUDNI CONFIDENTIAL
   * ___________________
   *
   *	[2012] - [2020]	 Udundi, LLC
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Udundi, LLC and its suppliers, if any.
   * The intellectual and technical concepts contained herein
   * are proprietary to Udundi, LLC and its suppliers and may
   * be covered by U.S. and Foreign Patents, patents in process,
   * and are protected by trade secret or copyright law.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Udundi, LLC.
   *
   * UDUNDI SEARCH
   * version: 0.5.1
   *
   */
  (function () {
    var $document,
      UdundiSearch,
      Products,
      xhr = new XMLHttpRequest(),
      url = "https://shopify.udundi.io/api/collection?myshopify_domain=blombergappliances&collection_id=270819983547";
    // 'https://cdn.shopify.com/s/files/1/2114/3697/files/'
    // swatches = [
    //   {
    //     color: 'heather-grey',
    //     filename: 'heather_grey_50x.jpg'
    //   }
    // ]

    UdundiSearch = {
      settings: {
        debug: false,
        dataAPI: true,
        requestBodyClass: "ud-search-loading",
        rivetsModels: {},
        currency: null,
        moneyFormat: null,
        moneyWithCurrencyFormat: null,
        weightUnit: "g",
        weightPrecision: 0,
        limit: 15,
        search: "",
      },
      products: [],
      options: [],
    };

    Products = function () {
      var start = window.performance.now();
      xhr.open("GET", url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          var data = JSON.parse(xhr.responseText);
          var variantImages = _uds
            .chain(data.products)
            .pluck("images")
            .flatten()
            .filter(function (v) {
              return v.variant_ids.length !== 0;
            })
            .value();

          data.products = _uds.each(data.products, function (p) {
            _uds.map(p.variants, function (v) {
              if (v.image_id) {
                v.src = variantImages.find(function (image) {
                  return image.id == v.image_id;
                }).src;
              }
              return v;
            });
            return (
              _uds.map(
                (p.featured_img_src = _uds.isNull(p.image)
                  ? "//udundi-filtering.herokuapp.com/assets/images/blank_400x.png"
                  : p.image.src)
              ) &&
              _uds.map((p.price = p.price_min = _uds.min(_uds.pluck(p.variants, "price").map(Number)))) &&
              _uds.map((p.price_max = _uds.max(_uds.pluck(p.variants, "price").map(Number)))) &&
              _uds.map((p.compare_at_price = _uds.max(_uds.pluck(p.variants, "compare_at_price").map(Number)))) &&
              delete p.body_html
            );
          });
          UdundiSearch.products = data.products;

          data.options = [];
          data.options.push(
            { name: "type", values: _uds.uniq(_uds.compact(_uds.pluck(data.products, "product_type"))) },
            { name: "vendor", values: _uds.uniq(_uds.compact(_uds.pluck(data.products, "vendor"))) }
          );

          UdundiSearch.options = data.options;
          UdundiSearch.settings.productTypes = _uds.findWhere(UdundiSearch.options, { name: "type" })["values"];
          UdundiSearch.settings.titles = _uds.pluck(UdundiSearch.products, "title").sort();
          var time = window.performance.now() - start;
          UdundiSearch.Utils.log("Products Loaded " + time + "ms");
          UdundiSearch.Core.reloadPackery();
          UdundiSearch.Core.suggestions();
        }
      };
      xhr.send(null);
    };

    UdundiSearch.init = function (products, settings) {
      // NEEDS WORK
      // add code below if prefer empty results
      // rv-show="settings.search | !empty"
      $("body").append(
        '<div class="uds-results" uds-endless-scroll="UdundiSearch.Core.increaseLimit()" uds-search-show uds-search-hide uds-search-view>' +
          '<div class="uds-container">' +
          // '<ul class="list-group list-group-horizontal mx-3">' +
          //   '<li class="list-group-item"><a href="https://cozyearth.com/pages/returns">Returns & Exchanges</></li>' +
          // '</ul>' +
          '<div class="uds-packery uds-details-below uds-col-lg-4 uds-col-md-4 uds-col-sm-3 uds-col-xs-2">' +
          '<div class="uds-gutter-sizer"></div>' +
          '<div onclick="sendEvent(this)" rv-id="product.id" class="uds-grid-item" rv-each-product="products | searchFilter settings.search | limitTo settings.limit | orderBy">' +
          '<div class="uds-item-wrapper uds-shadow-10dp">' +
          //                 '<a class="uds-image">' +
          '<a class="uds-image" rv-href="product.handle | setParam">' +
          '<div class="uds-overlay"></div>' +
          '<img rv-src="product.featured_img_src | setImgSize" rv-alt="product.alt" uds-search-image />' +
          "</a>" +
          '<div class="uds-details">' +
          '<a rv-href="product.handle | setParam">' +
          // 	              '<a>' +
          // '<span class="uds-vendor color-primary">{ product.vendor }</span>' +
          '<span class="uds-title uds-title uds-text-left uds-font-black uds-text-none uds-line-height-normal uds-letter-spacing-normal">{ product.title }</span>' +
          '<span class="uds-sku">{ product.variants | sku }</span>' +
          // '<span class="uds-sku">{ product.title }</span>' +
          '<span class="uds-price uds-text-left color-primary" class="uds-font-black uds-text-none uds-line-height-normal uds-letter-spacing-normal" rv-show="product.price | greater 0">{ product.price | _money }</span>' +
          '<span rv-if="product.compare_at_price color-primary" class="uds-compare-at-price uds-text-left uds-font-extrabold uds-line-height-normal uds-letter-spacing-normal ud-p-b-15">{ product.compare_at_price | _money }</span>' +
          "</a>" +
          // '<div rv-show="option | isOptionColor" id="option.id" class="ud-hidden uds-color-swatches" rv-each-option="product.options">' +
          //   '<div class="uds-color-swatch" rv-each-value="option.values">' +
          //     '<input type="radio" rv-id="option.id | prepend '+"'uds-swatch-'"+' | append '+"'-'"+' | append value | spacesToDashes | slashesToDashes" rv-name="option.id | prepend '+"'uds-option-'"+'" rv-value="value" uds-search-toggle-swatch />' +
          //     '<label rv-for="option.id | prepend '+"'uds-swatch-'"+' | append '+"'-'"+' | append value | spacesToDashes  | slashesToDashes" rv-title="value"></label>' +
          //   '</div>' +
          // '</div>' +
          "</div>" +
          "</div>" +
          "</div>" +
          "</div>" +
          '<div class="uds-no-results text-center" rv-show="products | searchFilter settings.search | empty">' +
          '<p>Your search "<span>{ settings.search }</span>" did not have any matches.</p>' +
          "</div>" +
          "</div>" +
          "</div>"
      );

      UdundiSearch.Utils.log("Initialising Udundi Search");
      UdundiSearch.Core.initLinks();
      Products();
      UdundiSearch.configure(settings);
      UdundiSearch.Core.loadPackery();
      if (UdundiSearch.settings.dataAPI) {
        UdundiSearch.Utils.log('"dataAPI" setting is true, initialising Data API.');
        UdundiSearch.Data.init();
      }
      if (UdundiSearch.settings.requestBodyClass) {
        UdundiSearch.Utils.log('"requestBodyClass" set, adding event listeners.');
        jQuery(document).on("products.requestStarted", function () {
          return jQuery("body").addClass(UdundiSearch.settings.requestBodyClass);
        });
        jQuery(document).on("products.requestComplete", function () {
          return jQuery("body").removeClass(UdundiSearch.settings.requestBodyClass);
        });
      }
      UdundiSearch.Rivets.init();
      return $(document).trigger("products.ready", UdundiSearch.products);
    };

    UdundiSearch.configure = function (settings) {
      if (settings == null) {
        settings = {};
      }
      return UdundiSearch.Utils.extend(UdundiSearch.settings, settings);
    };

    if (window.console == null) {
      window.console = {};
      window.console.log = function () {};
    }

    UdundiSearch.Utils = {
      log: function () {
        return UdundiSearch.Utils.console(console.log, arguments);
      },
      error: function () {
        return UdundiSearch.Utils.console(console.error, arguments);
      },
      console: function (method, args) {
        if (UdundiSearch.settings.debug && typeof console !== "undefined" && console !== null) {
          args = Array.prototype.slice.call(args);
          args.unshift("[UdundiSearch]:");
          return method.apply(console, args);
        }
      },
      wrapKeys: function (obj, type, override) {
        var key, value, wrapped;
        if (type == null) {
          type = "properties";
        }
        wrapped = {};
        for (key in obj) {
          value = obj[key];
          wrapped["" + type + "[" + key + "]"] = override != null ? override : value;
        }
        return wrapped;
      },
      unwrapKeys: function (obj, type, override) {
        var key, unwrapped, unwrappedKey, value;
        if (type == null) {
          type = "properties";
        }
        unwrapped = {};
        for (key in obj) {
          value = obj[key];
          unwrappedKey = key.replace("" + type + "[", "").replace("]", "");
          unwrapped[unwrappedKey] = override != null ? override : value;
        }
        return unwrapped;
      },
      extend: function (object, properties) {
        var key, val;
        for (key in properties) {
          val = properties[key];
          object[key] = val;
        }
        return object;
      },
      clone: function (object) {
        var key, newInstance;
        if (object == null || typeof object !== "object") {
          return object;
        }
        newInstance = new object.constructor();
        for (key in object) {
          newInstance[key] = clone(object[key]);
        }
        return newInstance;
      },
      isArray:
        Array.isArray ||
        function (value) {
          return {}.toString.call(value) === "[object Array]";
        },
      ensureArray: function (value) {
        if (UdundiSearch.Utils.isArray(value)) {
          return value;
        }
        if (value != null) {
          return [value];
        } else {
          return [];
        }
      },
      formatMoney: function (value, format, formatName, currency) {
        var _ref, _ref1;
        if (currency == null) {
          currency = "";
        }
        if (!currency) {
          currency = UdundiSearch.settings.currency;
        }
        if (window.Currency != null && currency !== UdundiSearch.settings.currency) {
          value = Currency.convert(value, UdundiSearch.settings.currency, currency);
          if (
            ((_ref = window.Currency) != null ? _ref.moneyFormats : void 0) != null &&
            currency in window.Currency.moneyFormats
          ) {
            format = window.Currency.moneyFormats[currency][formatName];
          }
        }
        if (((_ref1 = window.Shopify) != null ? _ref1.formatMoney : void 0) != null) {
          return Shopify.formatMoney(value, format);
        } else {
          return value;
        }
      },
      getSizedImageUrl: function (src, size) {
        var _ref, _ref1;
        if (
          ((_ref = window.Shopify) != null
            ? (_ref1 = _ref.Image) != null
              ? _ref1.getSizedImageUrl
              : void 0
            : void 0) != null
        ) {
          if (src) {
            return Shopify.Image.getSizedImageUrl(src, size);
          } else {
            return Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif", size).replace(
              "-_",
              "-"
            );
          }
        } else {
          if (src) {
            return src;
          } else {
            return "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
          }
        }
      },
      filterFilter: function (array, expression, comparator, anyPropertyKey) {
        var ArrayProto = Array.prototype,
          ObjProto = Object.prototype,
          FuncProto = Function.prototype;

        slice = ArrayProto.slice;
        var property = function (key) {
          return function (obj) {
            return obj == null ? void 0 : obj[key];
          };
        };
        var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
        var getLength = property("length");
        var isArrayLike = function (collection) {
          var length = getLength(collection);
          return typeof length == "number" && length >= 0 && length <= MAX_ARRAY_INDEX;
        };
        if (!isArrayLike(array)) {
          if (array == null) {
            return array;
          } else {
            throw minErr("filter")("notarray", "Expected array but received: {0}", array);
          }
        }

        anyPropertyKey = anyPropertyKey || "$";
        var expressionType = getTypeForFilter(expression);
        var predicateFn;
        var matchAgainstAnyProp;

        switch (expressionType) {
          case "function":
            predicateFn = expression;
            break;
          case "boolean":
          case "null":
          case "number":
          case "string":
            matchAgainstAnyProp = true;
          // falls through
          case "object":
            predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
            break;
          default:
            return array;
        }

        return Array.prototype.filter.call(array, predicateFn);
      },
    };

    UdundiSearch.Core = {
      initLinks: function () {
        document.querySelectorAll('a[href*="search"]').forEach(function (el) {
          el.setAttribute("uds-search-link", "");
          el.parentNode.replaceChild(el.cloneNode(true), el);
        });
      },
      loadPackery: function () {
        $grid = $(".uds-packery").packery({
          initLayout: false,
          itemSelector: ".uds-grid-item",
          percentPosition: true,
        });
        $grid.packery();
        $grid.imagesLoaded().progress(function () {
          $grid.packery();
        });
      },
      reloadPackery: function () {
        setTimeout(function () {
          $grid.packery();
          $grid.packery("reloadItems");
          $grid.packery("layout");
          $grid.imagesLoaded().progress(function () {
            $grid.packery();
          });
        });
      },
      input: function (e, value) {
        // var start = window.performance.now()

        // Remove typeahead menu on keypress 'Enter' or 'Tab'
        // on 'Enter' edit search
        if (e !== undefined) {
          const keycode = e.keyCode ? e.keyCode : e.which;
          if (keycode == "9") {
            $(".tt-menu").css("display", "none").removeClass("tt-open");
          } else if (keycode == "13") {
            const selectables = $(".tt-menu").find(".tt-selectable");
            if (selectables.length > 0) {
              value = selectables[0].innerText;
              $(selectables[0]).trigger("click");
              $(".tt-menu").css("display", "none").removeClass("tt-open");
            }
          }
        }

        UdundiSearch.Rivets.model.settings.search = UdundiSearch.settings.search = value;
        UdundiSearch.Rivets.model.products = UdundiSearch.Core.applyFilter(UdundiSearch.products, value, "OR");
        UdundiSearch.Core.endlessScroll();
        UdundiSearch.Core.searchSwatch();

        setTimeout(function () {
          if (typeof $grid === "undefined") return;
          $grid.packery();
          $grid.packery("reloadItems");
          $grid.packery("layout");
          $grid.imagesLoaded().progress(function () {
            $grid.packery();
          });
        });

        // Google Analytics - Site Search
        // if (history.pushState) {
        // 	var hash = window.location.hash.replace(/\?.+/, '')
        // 	var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + hash + '?q=' + UdundiSearch.settings.search
        // 	window.history.pushState({ path:newurl }, '', newurl)
        // }
        // var time = window.performance.now() - start
        // UdundiSearch.Utils.log(UdundiSearch.Rivets.model.products.length + ' results in ' + time + 'ms')
      },
      show: function (e) {
        // Show search input & init results
        var _wHeight = $(document).height();
        var _qOffset = $(".uds-search").find('input[type*="search"]').offset();
        var _qHeight = $(".uds-search").find('input[type*="search"]').outerHeight();
        var _headerHeight = $("nav.navbar").parent().height();
        console.log(_qHeight);
        console.log(_headerHeight);
        if (_qOffset.top + _qHeight === 0) {
          $(".uds-results").css("top", _headerHeight);
          $(".uds-search").height(_headerHeight);
        } else {
          $(".uds-results").css("top", _headerHeight);
          $(".uds-search").height(_headerHeight);
        }
        $("html").css("overflow-y", "hidden");
        $("body").css("overflow-y", "hidden");
        $("body").addClass("ud-search-input--focus");
        $(".uds-results").removeClass("uds-hidden");

        // hide promo bar
        // let promoBar = document.getElementById('promoContainer')

        // BRING BACK WHEN PROMO BAR ADDED
        // document.getElementById('promoContainer').style.display = 'none';

        // let promoBarParent = promoBar.parentElement
        // promoBar.setAttribute('aria-hidden', true)
        // promoBarParent.setAttribute('data-promo-visibile', false)
        // Sections.PromoBar.hide();

        // var header = document.getElementById('Header')
        // var bar = document.getElementById('SectionsBar')
        // var barHeight = bar.getBoundingClientRect().height

        // header.style.marginTop = barHeight + 'px'
        // var headerBottom = header.getBoundingClientRect().bottom
        // document.body.style.paddingTop = headerBottom + 'px'

        // set blank search
        UdundiSearch.Core.input(e, "");

        // input focus
        setTimeout(function () {
          $("input.uds-search-input.tt-input").focus();
        }, 300);

        // ga('send', 'event', 'Button', 'Search Initialized', window.location.href)
      },
      hide: function (e) {
        //    GTM variable setting
        let searchInputs = $(".uds-search-input");
        let searchTerm;
        let searchChars;
        let resultCards = $(".uds-grid-item").length;

        for (let i = 0; i < searchInputs.length; i++) {
          console.log("option", $(searchInputs[i]).val());
          if ($(searchInputs[i]).val() != "") {
            searchTerm = $(searchInputs[i]).val();
            searchChars = searchTerm.length;
          }
        }
        //     End GTM variable settting

        const keycode = e.keyCode ? e.keyCode : e.which;
        if (keycode === "Backspace" || keycode === "Delete") return;

        $("html").css("overflow-y", "initial");
        $("body").css("overflow-y", "auto");
        $("body").removeClass("ud-search-input--focus");
        $(".tt-input").typeahead("val", "");
        $(".uds-search-input").val("");
        UdundiSearch.settings.limit = 15;

        //      GTM datalayer send
        if (searchTerm == "" || searchTerm == null) {
          console.log("no search term");
          return;
        } else {
          window.dataLayer.push({
            event: "search",
            searchTerm: searchTerm,
            searchCharacterCount: searchChars,
            resultsCount: resultCards,
            searchFulfilled: false,
            productClickedTitle: "N/A",
            productClickedSku: "N/A",
          });
        }
        //      End GTM datalayer send

        // Sections.PromoBar.show();
      },
      applyFilter: function (array, input, booleanOp) {
        console.log(array);
        booleanOp = booleanOp || "AND";
        var expressions = (input || "").trim().toLowerCase().split(/\s+/g);
        console.log(expressions);
        if (booleanOp === "AND") {
          var result = array;
          expressions.forEach(function (expression) {
            result = UdundiSearch.Utils.filterFilter(result, expression);
          });
        } else {
          var result = [];
          expressions.forEach(function (expression) {
            console.log(expression);
            result = result.concat(UdundiSearch.Utils.filterFilter(array, expression));
          });
        }
        return result;
      },
      endlessScroll: function () {
        element = $document.find(".uds-results");
        element.scroll(function (e) {
          e.preventDefault();
          var scrollTop = element[0].scrollTop,
            scrollHeight = element[0].scrollHeight,
            offsetHeight = element[0].offsetHeight * 2;
          if (
            scrollTop >= scrollHeight - offsetHeight &&
            UdundiSearch.settings.limit < UdundiSearch.Rivets.model.products.length
          ) {
            UdundiSearch.settings.limit += 15;
            UdundiSearch.Core.reloadPackery();
            UdundiSearch.Core.searchSwatch();
            UdundiSearch.Core.toggleSwatch();
          }
        });
      },
      toggleSwatch: function (input, value) {
        if (typeof input === "undefined") return;

        var _product = $(input).parents(".uds-grid-item");
        var id = parseInt(_product.attr("id"));
        var product = _uds.findWhere(UdundiSearch.products, { id: id });
        var option = product.options.filter(function (option) {
          return ~option.name.toLowerCase().indexOf("color");
        })[0];

        if (typeof option === "undefined") return;

        var _imageObj = product.variants.find(function (variant) {
          if (!variant.src) return false;
          return variant["option" + option.position] === value;
        });

        if (typeof _imageObj === "undefined") return;
        product.featured_img_src = _imageObj.src;
      },
      searchSwatch: function () {
        var expressions = (UdundiSearch.settings.search || "").trim().toLowerCase().split(/\s+/g);
        if (!expressions || typeof expressions === "undefined" || expressions == "") return;

        UdundiSearch.products.forEach(function (product) {
          var option = product.options.filter(function (option) {
            return ~option.name.toLowerCase().indexOf("color");
          })[0];

          if (typeof option === "undefined") return;

          var lastInt = _uds.last(
            option.values.filter(function (val) {
              return expressions.some(function (expression) {
                return ~val.toLowerCase().indexOf(expression);
              });
            })
          );

          if (typeof lastInt === "undefined") return;
          var color = lastInt || option.values[0];

          if (!color) return;
          var _swatch = $(
            "#uds-swatch-" + option.id + "-" + color.replace(/\s+/g, "-").replace(/\//g, "-").replace(/[()]/g, "")
          );

          _swatch.prop("checked", true);

          var _imageObj = product.variants.find(function (variant) {
            if (!variant.src) return false;
            return variant["option" + option.position] === color;
          });

          if (typeof _imageObj === "undefined") return;
          product.featured_img_src = _imageObj.src;
        });
      },
      suggestions: function () {
        var productTypes = new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.whitespace,
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          local: UdundiSearch.settings.productTypes,
        });

        // var vendors = new Bloodhound({
        //   datumTokenizer: Bloodhound.tokenizers.whitespace,
        //   queryTokenizer: Bloodhound.tokenizers.whitespace,
        //   local: UdundiSearch.settings.vendors
        // })

        var titles = new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.whitespace,
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          local: UdundiSearch.settings.titles,
        });

        $("[uds-search-typeahead]").typeahead(
          {
            hint: true,
            highlight: true,
            minLength: 1,
          },
          {
            name: "productTypes",
            source: productTypes,
          }
        );
        // {
        //   name: 'titles',
        //   source: titles
        // })
      },
    };

    $document = null;

    UdundiSearch.Data = {
      init: function () {
        $document = jQuery(document);
        $("body").append(
          '<div class="uds-search" uds-search-form uds-search-view>' +
            '<input type="search" class="uds-search-input" placeholder="Search..." rv-value-on-input="settings.search" uds-search-input uds-search-typeahead />' +
            '<a role="button" aria-label="Close" class="close uds-search-close" uds-search-close><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16"><path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"/></svg></a>' +
            "</div>"
        );
        UdundiSearch.Data.setEventListeners("on");
        return UdundiSearch.Data.render(null, UdundiSearch.products);
      },
      destroy: function () {
        return UdundiSearch.Data.setEventListeners("off");
      },
      setEventListeners: function (method) {
        $document[method]("click tap", "[uds-search-link]", UdundiSearch.Data.initSearch);
        $document[method]("keyup", "[uds-search-input]", _uds.throttle(UdundiSearch.Data.input, 400));
        $document[method]("click tap", "[uds-option-search]", _uds.throttle(UdundiSearch.Data.input, 400));
        $document[method]("click tap", "[uds-search-close]", UdundiSearch.Data.close);
        $document[method]("change", "[uds-search-toggle-swatch]", UdundiSearch.Data.toggleSwatch);
        $document[method]("submit", "[uds-search-form]", UdundiSearch.Data.submitForm);
        return $document[method]("products.requestComplete", UdundiSearch.Data.render);
      },
      initSearch: function (e) {
        e.preventDefault();
        e.stopPropagation();
        return UdundiSearch.Core.show();
      },
      reloadPackery: function (e) {
        e.preventDefault();
        return UdundiSearch.Core.reloadPackery();
      },
      input: function (e) {
        var $this;
        $this = jQuery(this);
        console.log($this[0].value);
        return UdundiSearch.Core.input(e, $this[0].value);
      },
      toggleSwatch: function (e) {
        var $this;
        e.preventDefault();
        $this = jQuery(this);
        return UdundiSearch.Core.toggleSwatch($this, $this.attr("value"));
      },
      submitForm: function (e) {
        e.preventDefault();
      },
      close: function (e) {
        e.preventDefault();
        e.stopPropagation();
        // $this = jQuery(this)
        $(".uds-results").addClass("uds-hidden");
        return UdundiSearch.Core.hide(e);
      },
      render: function (e, search) {
        return jQuery("[uds-search-render]").each(function () {
          var $this;
          $this = jQuery(this);
          return $this.html(context[$this.attr("uds-search-render")]);
        });
      },
    };

    if ("rivets" in window) {
      UdundiSearch.Rivets = {
        model: null,
        boundViews: [],
        init: function () {
          return UdundiSearch.Rivets.bindViews();
        },
        destroy: function () {
          return UdundiSearch.Rivets.unbindViews();
        },
        bindViews: function () {
          UdundiSearch.Utils.log("Rivets.js is present, binding views.");
          UdundiSearch.Rivets.unbindViews();
          UdundiSearch.Rivets.model = UdundiSearch.Utils.extend(
            {
              settings: UdundiSearch.settings,
              products: UdundiSearch.products,
              options: UdundiSearch.options,
            },
            UdundiSearch.settings.rivetsModels
          );
          if (window.Currency != null) {
            UdundiSearch.Rivets.model.Currency = window.Currency;
          }
          return jQuery("[uds-search-view]").each(function () {
            var view;
            view = rivets.bind(jQuery(this), UdundiSearch.Rivets.model);
            return UdundiSearch.Rivets.boundViews.push(view);
          });
        },
        unbindViews: function () {
          var view, _i, _len, _ref;
          _ref = UdundiSearch.Rivets.boundViews;
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            view = _ref[_i];
            view.unbind();
          }
          return (UdundiSearch.Rivets.boundViews = []);
        },
      };

      rivets.binders["value-on-input"] = {
        publishes: true,
        bind: function (el) {
          el.addEventListener("input", this.publish);
          $(el).bind("typeahead:select", this.publish);
        },
        unbind: function (el) {
          el.removeEventListener("input", this.publish);
          $(el).unbind("typeahead:select", this.publish);
        },
        routine: rivets.binders.value.routine,
      };
      // rivets.binders['style-*'] = function(el, value) {
      //   var _value = $(el).attr('title').replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
      //     if (+match === 0) return
      //     return index == 0 ? match.toLowerCase() : match.toUpperCase()
      //   })
      //   console.log(_value)
      //   // if(this.args[0] === 'background-color') {
      //   //   if(_uds.isUndefined(UdundiSearch.settings.swatches[_value])) return
      //   //   var value = UdundiSearch.settings.swatches[_value].primaryColor
      //   // }else if(this.args[0] === 'background-image'){
      //   //   if(_uds.isUndefined(UdundiSearch.settings.swatches[_value])) return
      //   //   var value = 'url('+UdundiSearch.settings.swatches[_value].src+')'
      //   // }
      //   el.style.setProperty(this.args[0], value)
      // }
      rivets.binders.show = function (el, value) {
        if (value) {
          if (el.hasAttribute("uds-search-show") && $(el).hasClass("uds-hidden")) {
            UdundiSearch.Core.show();
          }
          $(el).removeClass("uds-hidden");
        } else {
          if (el.hasAttribute("uds-search-hide")) {
            UdundiSearch.Core.hide();
          }
          $(el).addClass("uds-hidden");
        }
        return value;
      };
      rivets.binders.hide = function (el, value) {
        return rivets.binders.show(el, value == false);
      };

      // Helper functions for 'filterFilter'
      function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
        function isObject(value) {
          // http://jsperf.com/isobject4
          return value !== null && typeof value === "object";
        }
        function isFunction(value) {
          return typeof value === "function";
        }

        var property = function (key) {
          return function (obj) {
            return obj == null ? void 0 : obj[key];
          };
        };
        var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
        var getLength = property("length");
        var isArrayLike = function (collection) {
          var length = getLength(collection);
          return typeof length == "number" && length >= 0 && length <= MAX_ARRAY_INDEX;
        };

        function isUndefined(value) {
          return typeof value === "undefined";
        }

        function isString(value) {
          return typeof value === "string";
        }

        var lowercase = function (string) {
          return isString(string) ? string.toLowerCase() : string;
        };

        function hasCustomToString(obj) {
          return isFunction(obj.toString) && obj.toString !== toString;
        }

        var shouldMatchPrimitives = isObject(expression) && anyPropertyKey in expression;
        var predicateFn;

        if (comparator === true) {
          comparator = equals;
        } else if (!isFunction(comparator)) {
          comparator = function (actual, expected) {
            if (isUndefined(actual)) {
              // No substring matching against `undefined`
              return false;
            }
            if (actual === null || expected === null) {
              // No substring matching against `null` only match against `null`
              return actual === expected;
            }
            if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
              // Should not compare primitives against objects, unless they have custom `toString` method
              return false;
            }

            actual = lowercase("" + actual);
            expected = lowercase("" + expected);
            return actual.indexOf(expected) !== -1;
          };
        }

        predicateFn = function (item) {
          if (shouldMatchPrimitives && !isObject(item)) {
            return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, true);
          }
          return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
        };

        return predicateFn;
      }
      function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
        var actualType = getTypeForFilter(actual);
        var expectedType = getTypeForFilter(expected);

        if (expectedType === "string" && expected.charAt(0) === "!") {
          return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
        } else if (UdundiSearch.Utils.isArray(actual)) {
          // In case `actual` is an array, consider it a match
          // if ANY of it's items matches `expected`
          return actual.some(function (item) {
            return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
          });
        }

        switch (actualType) {
          case "object":
            var key;
            if (matchAgainstAnyProp) {
              for (key in actual) {
                if (key.charAt(0) !== "$" && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
                  return true;
                }
              }
              return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
            } else if (expectedType === "object") {
              for (key in expected) {
                var expectedVal = expected[key];
                if (isFunction(expectedVal) || isUndefined(expectedVal)) {
                  continue;
                }

                var matchAnyProperty = key === anyPropertyKey;
                var actualVal = matchAnyProperty ? actual : actual[key];
                if (
                  !deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)
                ) {
                  return false;
                }
              }
              return true;
            } else {
              return comparator(actual, expected);
            }
          case "function":
            return false;
          default:
            return comparator(actual, expected);
        }
      }
      function getTypeForFilter(val) {
        return val === null ? "null" : typeof val;
      }

      rivets.formatters.orderBy = function (array, expression) {
        if (array == null) return array;

        array.sort(function (a, b) {
          const regex = /order_by_(\d+)/;
          var a = a.tags.match(regex) == null ? 100 : a.tags.match(regex)[1];
          var b = b.tags.match(regex) == null ? 100 : b.tags.match(regex)[1];
          return a - b;
        });

        return array;
      };
      rivets.formatters.limitTo = function (input, limit, begin) {
        var ArrayProto = Array.prototype,
          ObjProto = Object.prototype,
          FuncProto = Function.prototype;
        slice = ArrayProto.slice;

        var toInt = function (str) {
          return parseInt(str, 10);
        };

        var isNumberNaN =
          Number.isNaN ||
          function isNumberNaN(num) {
            // eslint-disable-next-line no-self-compare
            return num !== num;
          };

        var isNumber = function (ch) {
          return "0" <= ch && ch <= "9" && typeof ch === "string";
        };

        var property = function (key) {
          return function (obj) {
            return obj == null ? void 0 : obj[key];
          };
        };
        var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
        var getLength = property("length");
        var isArrayLike = function (collection) {
          var length = getLength(collection);
          return typeof length == "number" && length >= 0 && length <= MAX_ARRAY_INDEX;
        };
        function isString(value) {
          return typeof value === "string";
        }

        if (Math.abs(Number(limit)) === Infinity) {
          limit = Number(limit);
        } else {
          limit = toInt(limit);
        }

        if (isNumberNaN(limit)) return input;

        // if(!Number.isInteger(limit)) return input

        if (isNumber(input)) input = input.toString();
        if (!isArrayLike(input)) return input;

        begin = !begin || isNaN(begin) ? 0 : toInt(begin);
        begin = begin < 0 ? Math.max(0, input.length + begin) : begin;
        begin = 0;

        if (limit >= 0) {
          return sliceFn(input, begin, begin + limit);
        } else {
          if (begin === 0) {
            return sliceFn(input, limit, input.length);
          } else {
            return sliceFn(input, Math.max(0, begin + limit), begin);
          }
        }

        function sliceFn(input, begin, end) {
          if (isString(input)) return input.slice(begin, end);
          return slice.call(input, begin, end);
        }
      };
      rivets.formatters.or = function () {
        var i = arguments.length;
        while (i--) if (typeof arguments[i] !== "undefined") return arguments[i];
        return false;
      };
      rivets.formatters.lowercase = function (a) {
        if (a) {
          return a.toLowerCase();
        }
      };
      rivets.formatters.spacesToDashes = function (a) {
        if (a) {
          return a.replace(/\s+/g, "-");
        }
      };
      rivets.formatters.slashesToDashes = function (a) {
        if (a) {
          return a.replace(/\//g, "-");
        }
      };
      rivets.formatters.eq = function (a, b) {
        return a === b;
      };
      rivets.formatters.isColor = function (a) {
        if (a.name) {
          return ["color", "colors", "colour", "colours"].some(function (b) {
            return a.name.toLowerCase() === b;
          });
        }
      };
      rivets.formatters.isGtOne = function (a) {
        return a.length > 1;
      };
      rivets.formatters.isOptionColor = function (a) {
        if (a) {
          var isColor = ["color", "colors", "colour", "colours"].some(function (b) {
            return a.name.toLowerCase() === b;
          });
          if (isColor) {
            return a.values.length > 1;
          }
        }
      };
      rivets.formatters.includes = function (a, b) {
        return a.indexOf(b) >= 0;
      };
      rivets.formatters.match = function (a, regexp, flags) {
        return a.match(new RegExp(regexp, flags));
      };
      rivets.formatters.lt = function (a, b) {
        return a < b;
      };
      rivets.formatters.gt = function (a, b) {
        return a > b;
      };
      rivets.formatters.not = function (a) {
        return !a;
      };
      rivets.formatters.empty = function (a) {
        if (a == null) return;
        return !a.length;
      };
      rivets.formatters.plus = function (a, b) {
        return parseInt(a) + parseInt(b);
      };
      rivets.formatters.minus = function (a, b) {
        return parseInt(a) - parseInt(b);
      };
      rivets.formatters.times = function (a, b) {
        return a * b;
      };
      rivets.formatters.divided_by = function (a, b) {
        return a / b;
      };
      rivets.formatters.modulo = function (a, b) {
        return a % b;
      };
      rivets.formatters.prepend = function (a, b) {
        return b + a;
      };
      rivets.formatters.append = function (a, b) {
        return a + b;
      };
      rivets.formatters.slice = function (value, start, end) {
        return value.slice(start, end);
      };
      rivets.formatters.pluralize = function (input, singular, plural) {
        if (plural == null) {
          plural = singular + "s";
        }
        if (UdundiSearch.Utils.isArray(input)) {
          input = input.length;
        }
        if (input === 1) {
          return singular;
        } else {
          return plural;
        }
      };
      rivets.formatters.array_element = function (array, index) {
        return array[index];
      };
      rivets.formatters.array_first = function (array) {
        return array[0];
      };
      rivets.formatters.array_last = function (array) {
        return array[array.length - 1];
      };
      rivets.formatters.setParam = function (arr) {
        var hash = window.location.hash.replace(/\?.+/, "");
        return window.location.protocol + "//" + window.location.host + "/products/" + arr;
        // if (!window.location.hash) return '#?product=' + arr
        // return window.location.protocol + "//" + window.location.host + window.location.pathname + hash + '?product=' + arr
      };
      rivets.formatters.setImgSize = function (img) {
        return img.replace(/(\.gif+|\.jpg+|\.jpeg+|\.png+)/i, "_400x$1");
      };
      rivets.formatters.sku = function (variants) {
        return variants[0].sku;
      };
      rivets.formatters._money = function (value, currency) {
        return UdundiSearch.Utils.formatMoney(value * 100, UdundiSearch.settings.moneyFormat, "money_format", currency);
      };
      rivets.formatters.money_with_currency = function (value, currency) {
        return UdundiSearch.Utils.formatMoney(
          value,
          UdundiSearch.settings.moneyWithCurrencyFormat,
          "money_with_currency_format",
          currency
        );
      };
      rivets.formatters.weight = function (grams) {
        switch (UdundiSearch.settings.weightUnit) {
          case "kg":
            return (grams / 1000).toFixed(UdundiSearch.settings.weightPrecision);
          case "oz":
            return (grams * 0.035274).toFixed(UdundiSearch.settings.weightPrecision);
          case "lb":
            return (grams * 0.00220462).toFixed(UdundiSearch.settings.weightPrecision);
          default:
            return grams.toFixed(UdundiSearch.settings.weightPrecision);
        }
      };
      rivets.formatters.weight_with_unit = function (grams) {
        return rivets.formatters.weight(grams) + UdundiSearch.settings.weightUnit;
      };
      rivets.formatters.product_image_size = function (src, size) {
        return UdundiSearch.Utils.getSizedImageUrl(src, size);
      };
      rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency;
      rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit;
      rivets.formatters.productImageSize = rivets.formatters.product_image_size;
    } else {
      UdundiSearch.Rivets = {
        init: function () {},
        destroy: function () {},
      };
    }

    UdundiSearch.factory = function (exports) {
      exports.init = UdundiSearch.init;
      exports.configure = UdundiSearch.configure;
      exports.products = UdundiSearch.products;
      exports.options = UdundiSearch.options;
      exports.settings = UdundiSearch.settings;
      return (exports.render = UdundiSearch.Data.render);
    };

    if (typeof exports === "object") {
      UdundiSearch.factory(exports);
    } else if (typeof define === "function" && define.amd) {
      define(["exports"], function (exports) {
        UdundiSearch.factory((this.UdundiSearch = exports));
        return exports;
      });
    } else {
      UdundiSearch.factory((this.UdundiSearch = {}));
    }
  }).call(this);

  UdundiSearch.init();
}

// GTM
function sendEvent(productCard) {
  let productSku = $(productCard).find(".uds-sku").text();
  let productTitle = $(productCard).find(".uds-title").text();
  let searchInputs = $(".uds-search-input");
  let resultCards = $(".uds-grid-item").length;
  let searchTerm;
  let searchChars;

  for (let i = 0; i < searchInputs.length; i++) {
    if ($(searchInputs[i]).val() != "") {
      searchTerm = $(searchInputs[i]).val();
      searchChars = searchTerm.length;
    }
  }

  if (productSku == "" || productSku == null) {
    productSku = "could not identify product sku";
  }

  if (productTitle == "" || productTitle == null) {
    productTitle = "could not identify product title";
  }

  if (searchTerm == "" || searchTerm == null) {
    console.log("no search term");
    return;
  } else {
    console.log(
      "sku",
      productSku,
      "title",
      productTitle,
      "term",
      searchTerm,
      "length",
      searchChars,
      "results",
      resultCards
    );
    window.dataLayer.push({
      event: "search",
      searchTerm: searchTerm,
      searchCharacterCount: searchChars,
      resultsCount: resultCards,
      searchFulfilled: true,
      productClickedTitle: productTitle,
      productClickedSku: productSku,
    });
  }
}
